import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
};

export type Activity = {
  __typename?: 'Activity';
  createdAt: Scalars['DateTime'];
  createdBy: User;
  experiment: Experiment;
  id: Scalars['Int'];
  message: Scalars['String'];
};

export type ActivityCollection = {
  __typename?: 'ActivityCollection';
  items: Array<Activity>;
  totalCount: Scalars['Int'];
};

export type AdcOrder = {
  __typename?: 'AdcOrder';
  adcOrderItems: Array<AdcOrderItem>;
  experiment: Experiment;
  experimentId: Scalars['Int'];
  fulfilledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  status: OrderStatus;
};

export type AdcOrderCollection = {
  __typename?: 'AdcOrderCollection';
  items: Array<AdcOrder>;
  totalCount: Scalars['Int'];
};

export type AdcOrderInput = {
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
};

export type AdcOrderItem = {
  __typename?: 'AdcOrderItem';
  a280?: Maybe<Scalars['Float']>;
  batchNumber?: Maybe<Scalars['String']>;
  bioregId?: Maybe<Scalars['String']>;
  conjugate: Conjugate;
  createdAt: Scalars['DateTime'];
  deliveredAmount?: Maybe<Scalars['Float']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  deliveredConcentration?: Maybe<Scalars['Float']>;
  formulation?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isBioanalysis: Scalars['Boolean'];
  mgPerMl?: Maybe<Scalars['Float']>;
  purpose: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  removed: Scalars['Boolean'];
  returnedAt?: Maybe<Scalars['DateTime']>;
  unit?: Maybe<Scalars['String']>;
  wAvgOverage: Scalars['Float'];
};

export type AdcOrderItemInput = {
  a280?: InputMaybe<Scalars['Float']>;
  batchNumber?: InputMaybe<Scalars['String']>;
  deliveredAmount?: InputMaybe<Scalars['Float']>;
  deliveredConcentration?: InputMaybe<Scalars['Float']>;
  formulation?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type AddModelInput = {
  cellLineId?: InputMaybe<Scalars['Int']>;
  experimentId: Scalars['Int'];
  gender: Gender;
  implant: Implant;
  species: Species;
  strain: Scalars['String'];
  subcutaneousEndpoint?: InputMaybe<Scalars['String']>;
  tumorStartingVolume?: InputMaybe<Scalars['String']>;
};

export type AddTestArticleInput = {
  bioregId?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['Float']>;
  doseNumber?: InputMaybe<Scalars['Int']>;
  doseUnit?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<Scalars['Float']>;
  moleculeId?: InputMaybe<Scalars['Int']>;
  moleculeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  route?: InputMaybe<Scalars['String']>;
  treatmentId: Scalars['Int'];
};

export type AddTreatmentGroupInput = {
  experimentId: Scalars['Int'];
  hasBioanalysis?: InputMaybe<Scalars['Boolean']>;
  hasImaging?: InputMaybe<Scalars['Boolean']>;
  modelCount: Scalars['Int'];
  modelId: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  overage?: InputMaybe<Scalars['Float']>;
  treatmentGroupIndex: Scalars['Int'];
  treatmentId: Scalars['Int'];
};

export type AddTreatmentInput = {
  experimentId: Scalars['Int'];
};

export type AddUsersToExperimentInput = {
  experimentId: Scalars['Int'];
  userIds: Array<Scalars['Int']>;
};

export type AnimalOrder = {
  __typename?: 'AnimalOrder';
  animalOrderItems: Array<AnimalOrderItem>;
  id: Scalars['Int'];
  status: OrderStatus;
};

export type AnimalOrderItem = {
  __typename?: 'AnimalOrderItem';
  animal: Model;
  bornAt?: Maybe<Scalars['DateTime']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type AnimalOrderItemInput = {
  bornAt?: InputMaybe<Scalars['DateTime']>;
  deliveredAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
};

export type Antibody = {
  __typename?: 'Antibody';
  bioregId: Scalars['String'];
  dotmaticId: Scalars['Int'];
  humanizedVariant?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isoType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sgName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
};

export type AntibodyCollection = {
  __typename?: 'AntibodyCollection';
  items: Array<Antibody>;
  totalCount: Scalars['Int'];
};

export type Attachment = {
  __typename?: 'Attachment';
  category: Scalars['String'];
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
};

export type BioanalysisCollectionSchedule = {
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  onlyGroups: Array<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type BioanalysisTimepoint = {
  createdAt: Scalars['DateTime'];
  dose: Scalars['Int'];
  id: Scalars['Int'];
  minutes: Scalars['Int'];
  onlyAnimals: Array<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type BioanalysisTreatmentGroup = {
  baseTestArticle?: Maybe<TestArticle>;
  baseTestArticleId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  treatmentGroup?: Maybe<TreatmentGroup>;
  treatmentGroupId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BloodBioanalysis = {
  __typename?: 'BloodBioanalysis';
  bloodType: Scalars['String'];
  collectionSchedules?: Maybe<Array<BloodBioanalysisCollectionSchedule>>;
  createdAt: Scalars['DateTime'];
  experimentId: Scalars['Int'];
  id: Scalars['Int'];
  methods: Array<Scalars['String']>;
  otherMethods?: Maybe<Scalars['String']>;
  sampleAmount: Scalars['Int'];
  timePoints: Scalars['String'];
  treatmentGroups: Array<BloodBioanalysisTreatmentGroup>;
  updatedAt: Scalars['DateTime'];
};

export type BloodBioanalysisCollectionSchedule = BioanalysisCollectionSchedule & {
  __typename?: 'BloodBioanalysisCollectionSchedule';
  bloodBioanalysisId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  onlyGroups: Array<Scalars['Int']>;
  timepoints: Array<BloodBioanalysisTimepoint>;
  updatedAt: Scalars['DateTime'];
};

export type BloodBioanalysisTimepoint = BioanalysisTimepoint & {
  __typename?: 'BloodBioanalysisTimepoint';
  bloodBioanalysisCollectionScheduleId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  dose: Scalars['Int'];
  id: Scalars['Int'];
  minutes: Scalars['Int'];
  onlyAnimals: Array<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type BloodBioanalysisTreatmentGroup = BioanalysisTreatmentGroup & {
  __typename?: 'BloodBioanalysisTreatmentGroup';
  baseTestArticle?: Maybe<TestArticle>;
  baseTestArticleId: Scalars['Int'];
  bloodBioanalysisId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  treatmentGroup?: Maybe<TreatmentGroup>;
  treatmentGroupId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BulkCreateWorksheetEntriesInput = {
  entries: Array<CreateWorksheetEntryInput>;
};

export type BulkDeleteWorksheetEntriesInput = {
  ids: Array<Scalars['Int']>;
};

export type CroCellLineInput = {
  cultureProperties?: InputMaybe<Scalars['String']>;
  disease: Scalars['String'];
  location: Scalars['String'];
  modelType: Scalars['String'];
  name: Scalars['String'];
  recommendedGrowthMedia?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  species: Scalars['String'];
};

export type CellLine = {
  __typename?: 'CellLine';
  antibiotic?: Maybe<Scalars['String']>;
  antibioticSelectionConc?: Maybe<Scalars['String']>;
  averageStudyDuration?: Maybe<Scalars['Int']>;
  bioregId?: Maybe<Scalars['String']>;
  catalogNumber?: Maybe<Scalars['String']>;
  cloneCount?: Maybe<Scalars['Int']>;
  cro: Scalars['Boolean'];
  cultureProperties?: Maybe<Scalars['String']>;
  disease?: Maybe<Scalars['String']>;
  eln?: Maybe<Scalars['String']>;
  geneticManipulation?: Maybe<Scalars['String']>;
  geneticTarget?: Maybe<Scalars['String']>;
  hyperlink?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  licenseAgreement: Scalars['Boolean'];
  location: Scalars['String'];
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  parentBioregId?: Maybe<Scalars['String']>;
  recommendedGrowthMedia?: Maybe<Scalars['String']>;
  seedingDensity96w?: Maybe<Scalars['String']>;
  seedingDensity384w?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  species?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  thawToImplant?: Maybe<Scalars['Int']>;
  tissueSource?: Maybe<Scalars['String']>;
  vectorName?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
  vendorLink?: Maybe<Scalars['String']>;
};

export type CellLineCollection = {
  __typename?: 'CellLineCollection';
  items: Array<CellLine>;
  totalCount: Scalars['Int'];
};

export type ClearPkBloodWorksheetCollectionsActualTimeInput = {
  id: Scalars['Int'];
};

export type ClearPkTissueWorksheetCollectionsActualTimeInput = {
  id: Scalars['Int'];
};

export type Collection = ActivityCollection | AdcOrderCollection | AntibodyCollection | CellLineCollection | ConjugateCollection | ExperimentCollection | InventoryCollection | InventoryRequestCollection | ListContentCollection | OtherMoleculeCollection | RoleCollection | SmallMoleculeCollection | UserCollection | WorksheetCollection | WorksheetEntryCollection;

export type Conjugate = {
  __typename?: 'Conjugate';
  antibodyName: Scalars['String'];
  bioregId: Scalars['String'];
  dars?: Maybe<Scalars['String']>;
  dotmaticId: Scalars['Int'];
  drugLinker?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  parentabbioregId: Scalars['String'];
  sgName: Scalars['String'];
};

export type ConjugateCollection = {
  __typename?: 'ConjugateCollection';
  items: Array<Conjugate>;
  totalCount: Scalars['Int'];
};

export type CreateBioanalysisCollectionScheduleInput = {
  isDefault: Scalars['Boolean'];
  onlyGroups: Array<Scalars['Int']>;
  timepoints: Array<CreateBioanalysisTimepointInput>;
};

export type CreateBioanalysisTimepointInput = {
  dose: Scalars['Int'];
  minutes: Scalars['Int'];
  onlyAnimals: Array<Scalars['Int']>;
};

export type CreateBioanalysisTissueInput = {
  handlingAndStorage: Array<HandlingAndStorageInput>;
  notes?: InputMaybe<Scalars['String']>;
  tissue: Scalars['String'];
};

export type CreateBioanalysisTreatmentGroupInput = {
  baseTestArticleId: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  treatmentGroupId: Scalars['Int'];
};

export type CreateBloodBioanalysisInput = {
  bloodType: Scalars['String'];
  collectionSchedules: Array<CreateBioanalysisCollectionScheduleInput>;
  experimentId: Scalars['Int'];
  methods: Array<Scalars['String']>;
  otherMethods?: InputMaybe<Scalars['String']>;
  sampleAmount: Scalars['Int'];
  treatmentGroups: Array<CreateBioanalysisTreatmentGroupInput>;
};

export type CreateExperimentInput = {
  CRO?: InputMaybe<Scalars['Boolean']>;
  IACUC: Scalars['String'];
  MTA?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  designMethods?: InputMaybe<Scalars['String']>;
  endpoints?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  project: Scalars['String'];
  purposes?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateImagingInput = {
  experimentId: Scalars['Int'];
  instructions?: InputMaybe<Scalars['String']>;
  numViews: Scalars['Int'];
  timePoints: Scalars['String'];
  treatmentGroups: Array<CreateImagingTreatmentGroupInput>;
};

export type CreateImagingTreatmentGroupInput = {
  notes?: InputMaybe<Scalars['String']>;
  treatmentGroupId: Scalars['Int'];
};

export type CreateInventoryInput = {
  dob: Scalars['DateTime'];
  gender: Gender;
  notes?: InputMaybe<Scalars['String']>;
  poNumber: Scalars['String'];
  quantity: Scalars['Int'];
  species: Species;
  status: InventoryStatus;
  strain: Scalars['String'];
};

export type CreateInventoryRequestInput = {
  experimentId?: InputMaybe<Scalars['Int']>;
  inventoryId: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  status: InventoryRequestStatus;
};

export type CreateOtherMoleculeInput = {
  category: Scalars['String'];
  name: Scalars['String'];
};

export type CreateTissueBioanalysisInput = {
  collectionCriteria: Scalars['String'];
  collectionSchedules: Array<CreateBioanalysisCollectionScheduleInput>;
  destination: Scalars['String'];
  experimentId: Scalars['Int'];
  stains?: InputMaybe<Scalars['String']>;
  tissues: Array<CreateBioanalysisTissueInput>;
  treatmentGroups: Array<CreateBioanalysisTreatmentGroupInput>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roleId: Scalars['Int'];
};

export type CreateWorksheetEntryInput = {
  columnId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  rowId?: InputMaybe<Scalars['String']>;
  sectionId: Scalars['String'];
  worksheetId: Scalars['Int'];
};

export type DeleteBloodBioanalysisInput = {
  id: Scalars['Int'];
};

export type DeleteImagingInput = {
  id: Scalars['Int'];
};

export type DeleteTissueBioanalysisInput = {
  id: Scalars['Int'];
};

export type DeleteUserFromExperimentInput = {
  experimentId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type DeleteWorksheetEntryInput = {
  id: Scalars['Int'];
};

export type DeliverAdcOrderItemsInput = {
  adcOrderId: Scalars['Int'];
  adcOrderItemIds: Array<Scalars['Int']>;
  deliveredAt?: InputMaybe<Scalars['DateTime']>;
};

export type Experiment = {
  __typename?: 'Experiment';
  CRO: Scalars['Boolean'];
  IACUC: Scalars['String'];
  MTA: Scalars['Boolean'];
  activity: Array<Activity>;
  approvalCount: Scalars['Int'];
  approvalName?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Attachment>>;
  bloodBioanalysis?: Maybe<BloodBioanalysis>;
  completionDate?: Maybe<Scalars['DateTime']>;
  conclusion?: Maybe<Scalars['String']>;
  coordinator?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  designMethods?: Maybe<Scalars['String']>;
  endpoints?: Maybe<Scalars['String']>;
  hypothesis?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imaging?: Maybe<Imaging>;
  inventoryRequests?: Maybe<Array<InventoryRequest>>;
  meetingDate?: Maybe<Scalars['DateTime']>;
  models: Array<Model>;
  name: Scalars['String'];
  orders?: Maybe<Orders>;
  owner: User;
  priority?: Maybe<Scalars['Int']>;
  project: Scalars['String'];
  purposes?: Maybe<Scalars['String']>;
  researcher?: Maybe<User>;
  status: ExperimentState;
  subStatus?: Maybe<ExperimentSubState>;
  submissionDate?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  team?: Maybe<Array<Maybe<User>>>;
  tissueBioanalysis?: Maybe<TissueBioanalysis>;
  treatmentGroups: Array<TreatmentGroup>;
  treatments: Array<Treatment>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  worksheets?: Maybe<Array<Worksheet>>;
};

export type ExperimentCollection = {
  __typename?: 'ExperimentCollection';
  items: Array<Experiment>;
  totalCount: Scalars['Int'];
};

/** Only the name of the experiment will be returned */
export type ExperimentForInventoryRequest = {
  __typename?: 'ExperimentForInventoryRequest';
  MTA: Scalars['Boolean'];
  approvalName?: Maybe<Scalars['String']>;
};

export type ExperimentState =
  | 'Completed'
  | 'Draft'
  | 'Execution'
  | 'Provision'
  | 'Ready'
  | 'Review';

export type ExperimentSubState =
  | 'CellThaw'
  | 'StudyEnd'
  | 'StudyStart';

export type Gender =
  | 'female'
  | 'male'
  | 'mix';

export type HandlingAndStorage = {
  __typename?: 'HandlingAndStorage';
  includeWeight: Scalars['Boolean'];
  method: Scalars['String'];
};

export type HandlingAndStorageInput = {
  includeWeight: Scalars['Boolean'];
  method: Scalars['String'];
};

export type Heartbeat = {
  __typename?: 'Heartbeat';
  status: Scalars['String'];
};

export type Imaging = {
  __typename?: 'Imaging';
  createdAt: Scalars['DateTime'];
  experimentId: Scalars['Int'];
  id: Scalars['Int'];
  instructions?: Maybe<Scalars['String']>;
  numViews: Scalars['Int'];
  timePoints: Scalars['String'];
  treatmentGroups: Array<ImagingTreatmentGroup>;
  updatedAt: Scalars['DateTime'];
};

export type ImagingTreatmentGroup = {
  __typename?: 'ImagingTreatmentGroup';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  imagingId: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  treatmentGroup?: Maybe<TreatmentGroup>;
  treatmentGroupId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type Implant =
  | 'intravenous'
  | 'none'
  | 'orthotopic'
  | 'subcutaneous';

export type IncludeOrderInput = {
  adcOrder?: InputMaybe<Scalars['Boolean']>;
  animalOrder?: InputMaybe<Scalars['Boolean']>;
  nonAdcOrder?: InputMaybe<Scalars['Boolean']>;
};

/** Inventory (Animals) */
export type Inventory = {
  __typename?: 'Inventory';
  createdAt: Scalars['DateTime'];
  dob: Scalars['DateTime'];
  gender: Gender;
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  poNumber: Scalars['String'];
  quantity: Scalars['Int'];
  reserved?: Maybe<Scalars['Int']>;
  species: Species;
  status: InventoryStatus;
  strain: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  used?: Maybe<Scalars['Int']>;
};

export type InventoryCollection = {
  __typename?: 'InventoryCollection';
  items: Array<Inventory>;
  totalCount: Scalars['Int'];
};

export type InventoryExperimentFilters = {
  strain?: InputMaybe<Scalars['String']>;
};

export type InventoryFilters = {
  species?: InputMaybe<Species>;
  status?: InputMaybe<InventoryStatus>;
  strain?: InputMaybe<Scalars['String']>;
};

/** Only the poNumber of the inventory will be returned */
export type InventoryForInventoryRequest = {
  __typename?: 'InventoryForInventoryRequest';
  dob: Scalars['DateTime'];
  gender: Scalars['String'];
  poNumber: Scalars['String'];
  species: Scalars['String'];
  status: Scalars['String'];
  strain: Scalars['String'];
};

/** Inventory Requests (Animals) */
export type InventoryRequest = {
  __typename?: 'InventoryRequest';
  createdAt: Scalars['DateTime'];
  experiment?: Maybe<ExperimentForInventoryRequest>;
  experimentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  inventory?: Maybe<InventoryForInventoryRequest>;
  inventoryId: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  status: InventoryRequestStatus;
  updatedAt: Scalars['DateTime'];
};

export type InventoryRequestCollection = {
  __typename?: 'InventoryRequestCollection';
  items: Array<InventoryRequest>;
  totalCount: Scalars['Int'];
};

export type InventoryRequestFilters = {
  experimentId?: InputMaybe<Array<Scalars['Int']>>;
  experimentName?: InputMaybe<Array<Scalars['String']>>;
  inventoryId?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<InventoryRequestStatus>;
  strain?: InputMaybe<Scalars['String']>;
};

export type InventoryRequestStatus =
  | 'reserved'
  | 'used';

export type InventoryStatus =
  | 'closed'
  | 'open';

export type ListContent = {
  __typename?: 'ListContent';
  category: ListContentCategory;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ListContentCategory =
  | 'IACUC'
  | 'animal'
  | 'bioanalysisTimepoint'
  | 'bioanalysisTumorVolumeTimepoint'
  | 'doseUnit'
  | 'excludeConjugate'
  | 'experimentType'
  | 'handlingAndStorage'
  | 'notificationEmailBioanalysisForTissueGroupTeam'
  | 'notificationEmailBloodGroupTeam'
  | 'notificationEmailCROGroupTeam'
  | 'notificationEmailConjugationGroupTeam'
  | 'notificationEmailGroupAdmin'
  | 'notificationEmailProteinScienceGroupTeam'
  | 'notificationEmailToxicologyGroupTeam'
  | 'preclinicalObservation'
  | 'route'
  | 'strain'
  | 'subcutaneousEndpoint'
  | 'tissue';

export type ListContentCategoryInput = {
  category: Scalars['String'];
  items: Array<ListContentInput>;
};

export type ListContentCollection = {
  __typename?: 'ListContentCollection';
  items: Array<ListContent>;
  totalCount: Scalars['Int'];
};

export type ListContentInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Model = {
  __typename?: 'Model';
  cellLine?: Maybe<CellLine>;
  cellQuantity?: Maybe<Scalars['String']>;
  gender: Gender;
  id: Scalars['Int'];
  implant: Implant;
  implantationDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  species: Species;
  strain: Scalars['String'];
  subcutaneousEndpoint?: Maybe<Scalars['String']>;
  tumorStartingVolume?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addModelToExperiment: Array<Model>;
  addTestArticleToTreatment: TestArticle;
  addTreatmentGroupToExperiment: Array<TreatmentGroup>;
  addTreatmentToExperiment: Treatment;
  addUsersToExperiment: Experiment;
  bulkCreateWorksheetEntries: WorksheetEntryCollection;
  bulkDeleteWorksheetEntries: WorksheetEntryCollection;
  clearPKBloodWorksheetCollectionsActualTime: Array<PkBloodWorksheetCollection>;
  clearPKTissueWorksheetCollectionsActualTime: Array<PkTissueWorksheetCollection>;
  createBloodBioanalysis: BloodBioanalysis;
  createCROCellLine: CellLine;
  createExperiment: Experiment;
  createImaging: Imaging;
  /** Create a single instance (record) of inventory */
  createInventory: Inventory;
  /** Create a single instance (record) of an inventory request */
  createInventoryRequest: InventoryRequest;
  createOtherMolecule: OtherMolecule;
  createTissueBioanalysis: TissueBioanalysis;
  createUser: User;
  createWorksheetEntry: WorksheetEntry;
  deleteBloodBioanalysis: Scalars['Int'];
  deleteCROCellLine: Scalars['Boolean'];
  deleteImaging: Scalars['Int'];
  deleteOtherMolecule: Scalars['Boolean'];
  deleteTissueBioanalysis: Scalars['Int'];
  deleteUserFromExperiment: Experiment;
  deleteWorksheetEntry: WorksheetEntry;
  deliverAdcOrderItems: Array<AdcOrderItem>;
  duplicateAnimalToExperiment: Model;
  duplicateExperiment: Experiment;
  duplicateTreatmentGroup: Array<TreatmentGroup>;
  duplicateTreatmentToExperiment: Array<Treatment>;
  initWorksheetEntries: Scalars['Int'];
  populateTreatmentGroups: Array<TreatmentGroup>;
  removeExperiment: Scalars['Boolean'];
  /** Deletes the inventory with the passed id from the database. */
  removeInventory: Scalars['Boolean'];
  /** Deletes the inventory request with the passed id from the database. */
  removeInventoryRequest: Scalars['Boolean'];
  removeModel: Array<Model>;
  removeTestArticle: Scalars['Boolean'];
  removeTreatment?: Maybe<RemoveTreatmentResponse>;
  removeTreatmentGroup: Array<TreatmentGroup>;
  returnAdcOrderItems: Array<AdcOrderItem>;
  setListContentCategory?: Maybe<Scalars['Boolean']>;
  setTreatmentsTestArticles: Array<Treatment>;
  syncExperimentOrders: Orders;
  updateAdcOrder: AdcOrder;
  updateAdcOrderItem: AdcOrderItem;
  updateAnimalOrderItem: AnimalOrderItem;
  updateBloodBioanalysis: BloodBioanalysis;
  updateCROCellLine: CellLine;
  updateExperiment: Experiment;
  updateImaging: Imaging;
  /** Update a single instance (record) of inventory */
  updateInventory: Inventory;
  /** Update a single instance (record) of an inventory request */
  updateInventoryRequest: InventoryRequest;
  updateModel: Array<Model>;
  updateNonAdcOrderItem: NonAdcOrderItem;
  updateOtherMolecule: OtherMolecule;
  updatePKBloodWorksheetBasisDate: PkBloodWorksheet;
  updatePKBloodWorksheetCollectionActualTime: PkBloodWorksheetCollection;
  updatePKBloodWorksheetCollectionActualTimes: Array<PkBloodWorksheetCollection>;
  updatePKBloodWorksheetNotes: PkBloodWorksheet;
  updatePKBloodWorksheetStatus: PkBloodWorksheet;
  updatePKTissueWorksheetBasisDate: PkTissueWorksheet;
  updatePKTissueWorksheetCollectionActualTime: PkTissueWorksheetCollection;
  updatePKTissueWorksheetCollectionActualTimes: Array<PkTissueWorksheetCollection>;
  updatePKTissueWorksheetHandlingAndStorage: PkTissueWorksheetHandlingAndStorage;
  updatePKTissueWorksheetNotes: PkTissueWorksheet;
  updatePKTissueWorksheetStatus: PkTissueWorksheet;
  updateTestArticle: TestArticle;
  updateTissueBioanalysis: TissueBioanalysis;
  updateTreatmentGroup: Array<TreatmentGroup>;
  updateTreatmentGroupIndex: Array<TreatmentGroup>;
  updateUser: User;
  updateWorksheetEntryDataValues: WorksheetEntry;
  updateWorksheetStatus: Worksheet;
};


export type MutationAddModelToExperimentArgs = {
  input: AddModelInput;
};


export type MutationAddTestArticleToTreatmentArgs = {
  input: AddTestArticleInput;
};


export type MutationAddTreatmentGroupToExperimentArgs = {
  input: AddTreatmentGroupInput;
};


export type MutationAddTreatmentToExperimentArgs = {
  input: AddTreatmentInput;
};


export type MutationAddUsersToExperimentArgs = {
  input: AddUsersToExperimentInput;
};


export type MutationBulkCreateWorksheetEntriesArgs = {
  input: BulkCreateWorksheetEntriesInput;
};


export type MutationBulkDeleteWorksheetEntriesArgs = {
  input: BulkDeleteWorksheetEntriesInput;
};


export type MutationClearPkBloodWorksheetCollectionsActualTimeArgs = {
  input: ClearPkBloodWorksheetCollectionsActualTimeInput;
};


export type MutationClearPkTissueWorksheetCollectionsActualTimeArgs = {
  input: ClearPkTissueWorksheetCollectionsActualTimeInput;
};


export type MutationCreateBloodBioanalysisArgs = {
  input: CreateBloodBioanalysisInput;
};


export type MutationCreateCroCellLineArgs = {
  input: CroCellLineInput;
};


export type MutationCreateExperimentArgs = {
  input: CreateExperimentInput;
};


export type MutationCreateImagingArgs = {
  input: CreateImagingInput;
};


export type MutationCreateInventoryArgs = {
  input: CreateInventoryInput;
};


export type MutationCreateInventoryRequestArgs = {
  input: CreateInventoryRequestInput;
};


export type MutationCreateOtherMoleculeArgs = {
  input: CreateOtherMoleculeInput;
};


export type MutationCreateTissueBioanalysisArgs = {
  input: CreateTissueBioanalysisInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateWorksheetEntryArgs = {
  input: CreateWorksheetEntryInput;
};


export type MutationDeleteBloodBioanalysisArgs = {
  input: DeleteBloodBioanalysisInput;
};


export type MutationDeleteCroCellLineArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteImagingArgs = {
  input: DeleteImagingInput;
};


export type MutationDeleteOtherMoleculeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteTissueBioanalysisArgs = {
  input: DeleteTissueBioanalysisInput;
};


export type MutationDeleteUserFromExperimentArgs = {
  input: DeleteUserFromExperimentInput;
};


export type MutationDeleteWorksheetEntryArgs = {
  input: DeleteWorksheetEntryInput;
};


export type MutationDeliverAdcOrderItemsArgs = {
  input: DeliverAdcOrderItemsInput;
};


export type MutationDuplicateAnimalToExperimentArgs = {
  id: Scalars['Int'];
};


export type MutationDuplicateExperimentArgs = {
  id: Scalars['Int'];
};


export type MutationDuplicateTreatmentGroupArgs = {
  id: Scalars['Int'];
};


export type MutationDuplicateTreatmentToExperimentArgs = {
  id: Scalars['Int'];
};


export type MutationInitWorksheetEntriesArgs = {
  input: Array<CreateWorksheetEntryInput>;
};


export type MutationPopulateTreatmentGroupsArgs = {
  experimentId: Scalars['Int'];
};


export type MutationRemoveExperimentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveInventoryArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveInventoryRequestArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveModelArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveTestArticleArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveTreatmentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveTreatmentGroupArgs = {
  id: Scalars['Int'];
};


export type MutationReturnAdcOrderItemsArgs = {
  input: DeliverAdcOrderItemsInput;
};


export type MutationSetListContentCategoryArgs = {
  input: ListContentCategoryInput;
};


export type MutationSetTreatmentsTestArticlesArgs = {
  input: Array<AddTestArticleInput>;
};


export type MutationSyncExperimentOrdersArgs = {
  experimentId: Scalars['Int'];
};


export type MutationUpdateAdcOrderArgs = {
  input: AdcOrderInput;
};


export type MutationUpdateAdcOrderItemArgs = {
  input: AdcOrderItemInput;
};


export type MutationUpdateAnimalOrderItemArgs = {
  input: AnimalOrderItemInput;
};


export type MutationUpdateBloodBioanalysisArgs = {
  input: UpdateBloodBioanalysisInput;
};


export type MutationUpdateCroCellLineArgs = {
  input: UpdateCroCellLineInput;
};


export type MutationUpdateExperimentArgs = {
  input: UpdateExperimentInput;
};


export type MutationUpdateImagingArgs = {
  input: UpdateImagingInput;
};


export type MutationUpdateInventoryArgs = {
  input: UpdateInventoryInput;
};


export type MutationUpdateInventoryRequestArgs = {
  input: UpdateInventoryRequestInput;
};


export type MutationUpdateModelArgs = {
  input: UpdateModelInput;
};


export type MutationUpdateNonAdcOrderItemArgs = {
  input: NonAdcOrderItemInput;
};


export type MutationUpdateOtherMoleculeArgs = {
  input: UpdateOtherMoleculeInput;
};


export type MutationUpdatePkBloodWorksheetBasisDateArgs = {
  input: UpdatePkBloodWorksheetBasisDateInput;
};


export type MutationUpdatePkBloodWorksheetCollectionActualTimeArgs = {
  input: UpdatePkBloodWorksheetCollectionActualTimeInput;
};


export type MutationUpdatePkBloodWorksheetCollectionActualTimesArgs = {
  input: UpdatePkBloodWorksheetCollectionActualTimesInput;
};


export type MutationUpdatePkBloodWorksheetNotesArgs = {
  input: UpdatePkBloodWorksheetNotesInput;
};


export type MutationUpdatePkBloodWorksheetStatusArgs = {
  input: UpdatePkBloodWorksheetStatusInput;
};


export type MutationUpdatePkTissueWorksheetBasisDateArgs = {
  input: UpdatePkTissueWorksheetBasisDateInput;
};


export type MutationUpdatePkTissueWorksheetCollectionActualTimeArgs = {
  input: UpdatePkTissueWorksheetCollectionActualTimeInput;
};


export type MutationUpdatePkTissueWorksheetCollectionActualTimesArgs = {
  input: UpdatePkTissueWorksheetCollectionActualTimesInput;
};


export type MutationUpdatePkTissueWorksheetHandlingAndStorageArgs = {
  input: UpdatePkTissueWorksheetHandlingAndStorageInput;
};


export type MutationUpdatePkTissueWorksheetNotesArgs = {
  input: UpdatePkTissueWorksheetNotesInput;
};


export type MutationUpdatePkTissueWorksheetStatusArgs = {
  input: UpdatePkTissueWorksheetStatusInput;
};


export type MutationUpdateTestArticleArgs = {
  input: UpdateTestArticleInput;
};


export type MutationUpdateTissueBioanalysisArgs = {
  input: UpdateTissueBioanalysisInput;
};


export type MutationUpdateTreatmentGroupArgs = {
  input: UpdateTreatmentGroupInput;
};


export type MutationUpdateTreatmentGroupIndexArgs = {
  input: TreatmentGroupIndexInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWorksheetEntryDataValuesArgs = {
  input: UpdateWorksheetEntryDataValuesInput;
};


export type MutationUpdateWorksheetStatusArgs = {
  input: UpdateWorksheetStatusInput;
};

export type NonAdcOrder = {
  __typename?: 'NonAdcOrder';
  id: Scalars['Int'];
  nonAdcOrderItems: Array<NonAdcOrderItem>;
  status: OrderStatus;
};

export type NonAdcOrderItem = {
  __typename?: 'NonAdcOrderItem';
  bioregId?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  fulfilledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  testArticles: Array<TestArticle>;
  unit: Scalars['String'];
};

export type NonAdcOrderItemInput = {
  fulfilledAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
};

export type OrderBy =
  | 'asc'
  | 'desc';

export type OrderStatus =
  | 'completed'
  | 'inProgress'
  | 'initiated';

export type Orders = {
  __typename?: 'Orders';
  adcOrder?: Maybe<AdcOrder>;
  animalOrder?: Maybe<AnimalOrder>;
  nonAdcOrder?: Maybe<NonAdcOrder>;
};

export type OtherMolecule = {
  __typename?: 'OtherMolecule';
  bioregId?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  commonName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  otherNames?: Maybe<Scalars['String']>;
};

export type OtherMoleculeCollection = {
  __typename?: 'OtherMoleculeCollection';
  items: Array<OtherMolecule>;
  totalCount: Scalars['Int'];
};

export type PkBloodWorksheet = {
  __typename?: 'PKBloodWorksheet';
  basisDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  experimentId: Scalars['Int'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  pkBloodWorksheetCollections?: Maybe<Array<PkBloodWorksheetCollection>>;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PkBloodWorksheetCollection = {
  __typename?: 'PKBloodWorksheetCollection';
  actualTime?: Maybe<Scalars['DateTime']>;
  animalNumber: Scalars['Int'];
  bloodBioanalysisTimepointId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  expectedDate?: Maybe<Scalars['DateTime']>;
  expectedTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  pkBloodWorksheetId: Scalars['Int'];
  treatmentGroupId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PkTissueWorksheet = {
  __typename?: 'PKTissueWorksheet';
  basisDate?: Maybe<Scalars['DateTime']>;
  collectionCriteria: Scalars['String'];
  createdAt: Scalars['DateTime'];
  experimentId: Scalars['Int'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  pkTissueWorksheetCollections?: Maybe<Array<PkTissueWorksheetCollection>>;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PkTissueWorksheetCollection = {
  __typename?: 'PKTissueWorksheetCollection';
  actualTime?: Maybe<Scalars['DateTime']>;
  animalNumber: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  expectedDate?: Maybe<Scalars['DateTime']>;
  expectedTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  pkTissueWorksheetHandlingAndStorage: Array<PkTissueWorksheetHandlingAndStorage>;
  pkTissueWorksheetId: Scalars['Int'];
  tissueBioanalysisTimepointId: Scalars['Int'];
  treatmentGroupId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PkTissueWorksheetHandlingAndStorage = {
  __typename?: 'PKTissueWorksheetHandlingAndStorage';
  collected: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  method: Scalars['String'];
  pkTissueWorksheetCollectionId: Scalars['Int'];
  tissueBioanalysisTissueId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  weight?: Maybe<Scalars['Float']>;
};

export type PaginationFilter = {
  items?: InputMaybe<Array<PaginationFilterItem>>;
  linkOperator?: InputMaybe<PaginationFilterLinkOperator>;
  quickFilterLogicOperator?: InputMaybe<Scalars['String']>;
  quickFilterValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PaginationFilterItem = {
  columnField: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  operatorValue: PaginationOperator;
  value?: InputMaybe<Scalars['String']>;
};

export type PaginationFilterLinkOperator =
  | 'and'
  | 'or';

export type PaginationOperator =
  | 'equals'
  | 'is';

export type PaginationSort = {
  field: Scalars['String'];
  sort: OrderBy;
};

export type Permission = {
  __typename?: 'Permission';
  action: PermissionAction;
  conditions?: Maybe<Scalars['String']>;
  fields: Array<Scalars['String']>;
  subject: PermissionResource;
};

export type PermissionAction =
  | 'clearActualTimes'
  | 'create'
  | 'delete'
  | 'list'
  | 'manageEntry'
  | 'read'
  | 'returnToDraft'
  | 'returnToExecution'
  | 'update'
  | 'updateActualTimes'
  | 'updateWorksheetStatus';

export type PermissionResource =
  | 'activity'
  | 'adcOrder'
  | 'all'
  | 'animal'
  | 'animalOrder'
  | 'antibody'
  | 'cellLine'
  | 'conjugate'
  | 'experiment'
  | 'experimentResearcher'
  | 'inventory'
  | 'inventoryRequest'
  | 'listContent'
  | 'meetingDate'
  | 'nonAdcOrder'
  | 'otherMolecule'
  | 'pkBloodWorksheet'
  | 'pkBloodWorksheetCollection'
  | 'pkTissueWorksheet'
  | 'pkTissueWorksheetCollection'
  | 'role'
  | 'smallMolecule'
  | 'testArticle'
  | 'treatment'
  | 'treatmentGroup'
  | 'user'
  | 'worksheet'
  | 'worksheetEntry';

export type Program = {
  __typename?: 'Program';
  bioregId: Scalars['String'];
  dotmaticId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type ProgramCollection = {
  __typename?: 'ProgramCollection';
  items: Array<Program>;
};

export type Query = {
  __typename?: 'Query';
  activities: ActivityCollection;
  adcOrders?: Maybe<AdcOrderCollection>;
  antibodies: AntibodyCollection;
  bloodBioanalysis: BloodBioanalysis;
  cellLines: CellLineCollection;
  conjugates: ConjugateCollection;
  croCellLine: CellLine;
  croCellLines: CellLineCollection;
  experiment?: Maybe<Experiment>;
  experimentAttachments: Array<Attachment>;
  experimentOrders: Orders;
  experiments: ExperimentCollection;
  experimentsByStatus: ExperimentCollection;
  heartbeat: Heartbeat;
  imaging: Imaging;
  inventory: Inventory;
  inventoryRequest: InventoryRequest;
  /**
   * List Animal Inventory Requests for an experiment
   * Returns a collection of inventory requests
   */
  inventoryRequestsByExperiment: Array<InventoryRequest>;
  listContent?: Maybe<ListContent>;
  listContents: ListContentCollection;
  /**
   * List Animal Inventory Query
   * Returns a collection of inventory
   */
  listInventory: InventoryCollection;
  /**
   * List Animal Inventory Requests Query
   * Returns a collection of inventory requests
   */
  listInventoryRequests: InventoryRequestCollection;
  me: User;
  otherMolecules: OtherMoleculeCollection;
  pkBloodWorksheet?: Maybe<PkBloodWorksheet>;
  pkBloodWorksheetCollections: Array<PkBloodWorksheetCollection>;
  pkTissueWorksheet?: Maybe<PkTissueWorksheet>;
  pkTissueWorksheetCollections: Array<PkTissueWorksheetCollection>;
  programs: ProgramCollection;
  relatedExperiments: ExperimentCollection;
  roles: RoleCollection;
  smallMolecules: SmallMoleculeCollection;
  tissueBioanalysis: TissueBioanalysis;
  user: User;
  users: UserCollection;
  worksheet?: Maybe<Worksheet>;
  worksheetEntriesByWorksheet: WorksheetEntryCollection;
  worksheetEntry?: Maybe<WorksheetEntry>;
  worksheetsByExperiment: WorksheetCollection;
};


export type QueryActivitiesArgs = {
  experimentId: Scalars['Int'];
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<OrderBy>;
};


export type QueryAdcOrdersArgs = {
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrderStatus>;
};


export type QueryAntibodiesArgs = {
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryBloodBioanalysisArgs = {
  experimentId: Scalars['Int'];
};


export type QueryCellLinesArgs = {
  filter?: InputMaybe<PaginationFilter>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PaginationSort>>;
};


export type QueryConjugatesArgs = {
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCroCellLineArgs = {
  id: Scalars['Int'];
};


export type QueryCroCellLinesArgs = {
  filter?: InputMaybe<PaginationFilter>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PaginationSort>>;
};


export type QueryExperimentArgs = {
  id: Scalars['Int'];
};


export type QueryExperimentAttachmentsArgs = {
  category: Scalars['String'];
  experimentId: Scalars['Int'];
};


export type QueryExperimentOrdersArgs = {
  experimentId: Scalars['Int'];
};


export type QueryExperimentsArgs = {
  filter?: InputMaybe<PaginationFilter>;
  inventoryFilters?: InputMaybe<InventoryExperimentFilters>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PaginationSort>>;
  statuses?: InputMaybe<Array<ExperimentState>>;
};


export type QueryExperimentsByStatusArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<ExperimentState>>;
};


export type QueryImagingArgs = {
  experimentId: Scalars['Int'];
};


export type QueryInventoryArgs = {
  id: Scalars['Int'];
};


export type QueryInventoryRequestArgs = {
  id: Scalars['Int'];
};


export type QueryInventoryRequestsByExperimentArgs = {
  experimentId: Scalars['Int'];
};


export type QueryListContentArgs = {
  category: Scalars['String'];
};


export type QueryListContentsArgs = {
  category?: InputMaybe<ListContentCategory>;
};


export type QueryListInventoryArgs = {
  filter?: InputMaybe<PaginationFilter>;
  filters?: InputMaybe<InventoryFilters>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PaginationSort>>;
};


export type QueryListInventoryRequestsArgs = {
  filter?: InputMaybe<PaginationFilter>;
  filters?: InputMaybe<InventoryRequestFilters>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PaginationSort>>;
};


export type QueryOtherMoleculesArgs = {
  category?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryPkBloodWorksheetArgs = {
  experimentId: Scalars['Int'];
};


export type QueryPkBloodWorksheetCollectionsArgs = {
  pkBloodWorksheetId: Scalars['Int'];
};


export type QueryPkTissueWorksheetArgs = {
  experimentId: Scalars['Int'];
};


export type QueryPkTissueWorksheetCollectionsArgs = {
  pkTissueWorksheetId: Scalars['Int'];
};


export type QueryRelatedExperimentsArgs = {
  experimentId: Scalars['Int'];
};


export type QuerySmallMoleculesArgs = {
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTissueBioanalysisArgs = {
  experimentId: Scalars['Int'];
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};


export type QueryUsersArgs = {
  excludedIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<PaginationFilter>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PaginationSort>>;
};


export type QueryWorksheetArgs = {
  id: Scalars['Int'];
};


export type QueryWorksheetEntriesByWorksheetArgs = {
  worksheetId: Scalars['Int'];
};


export type QueryWorksheetEntryArgs = {
  id: Scalars['Int'];
};


export type QueryWorksheetsByExperimentArgs = {
  experimentId: Scalars['Int'];
};

export type RemoveTreatmentResponse = {
  __typename?: 'RemoveTreatmentResponse';
  treatmentGroups?: Maybe<Array<TreatmentGroup>>;
  treatments: Array<Treatment>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type RoleCollection = {
  __typename?: 'RoleCollection';
  items: Array<Role>;
  totalCount: Scalars['Int'];
};

export type Roles =
  | 'admin'
  | 'conjugation'
  | 'creator'
  | 'manager'
  | 'researcher'
  | 'viewer'
  | 'visitor';

export type SmallMolecule = {
  __typename?: 'SmallMolecule';
  bioregId: Scalars['String'];
  drugClass?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  stereo?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SmallMoleculeCollection = {
  __typename?: 'SmallMoleculeCollection';
  items: Array<SmallMolecule>;
  totalCount: Scalars['Int'];
};

export type Species =
  | 'monkey'
  | 'mouse'
  | 'rat';

export type TestArticle = {
  __typename?: 'TestArticle';
  bioregId?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['Float']>;
  doseNumber?: Maybe<Scalars['Int']>;
  doseUnit?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  interval?: Maybe<Scalars['Float']>;
  moleculeId?: Maybe<Scalars['Int']>;
  moleculeType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  route?: Maybe<Scalars['String']>;
};

export type TissueBioanalysis = {
  __typename?: 'TissueBioanalysis';
  collectTissueWeight: Scalars['Boolean'];
  collectionCriteria: Scalars['String'];
  collectionSchedules?: Maybe<Array<TissueBioanalysisCollectionSchedule>>;
  createdAt: Scalars['DateTime'];
  destination: Scalars['String'];
  experimentId: Scalars['Int'];
  id: Scalars['Int'];
  stains?: Maybe<Scalars['String']>;
  tissues: Array<TissueBioanalysisTissue>;
  treatmentGroups: Array<TissueBioanalysisTreatmentGroup>;
  updatedAt: Scalars['DateTime'];
};

export type TissueBioanalysisCollectionSchedule = BioanalysisCollectionSchedule & {
  __typename?: 'TissueBioanalysisCollectionSchedule';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  onlyGroups: Array<Scalars['Int']>;
  timepoints: Array<TissueBioanalysisTimepoint>;
  tissueBioanalysisId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type TissueBioanalysisTimepoint = BioanalysisTimepoint & {
  __typename?: 'TissueBioanalysisTimepoint';
  createdAt: Scalars['DateTime'];
  dose: Scalars['Int'];
  id: Scalars['Int'];
  minutes: Scalars['Int'];
  onlyAnimals: Array<Scalars['Int']>;
  tissueBioanalysisCollectionScheduleId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type TissueBioanalysisTissue = {
  __typename?: 'TissueBioanalysisTissue';
  createdAt: Scalars['DateTime'];
  handlingAndStorage: Array<HandlingAndStorage>;
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  tissue: Scalars['String'];
  tissueBioanalysisId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type TissueBioanalysisTreatmentGroup = BioanalysisTreatmentGroup & {
  __typename?: 'TissueBioanalysisTreatmentGroup';
  baseTestArticle?: Maybe<TestArticle>;
  baseTestArticleId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  tissueBioanalysisId: Scalars['Int'];
  treatmentGroup?: Maybe<TreatmentGroup>;
  treatmentGroupId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type Treatment = {
  __typename?: 'Treatment';
  id: Scalars['Int'];
  number: Scalars['Int'];
  testArticles: Array<TestArticle>;
};

export type TreatmentGroup = {
  __typename?: 'TreatmentGroup';
  bloodBioanalysisTreatmentGroup?: Maybe<BloodBioanalysisTreatmentGroup>;
  hasBioanalysis?: Maybe<Scalars['Boolean']>;
  hasImaging?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  imagingTreatmentGroup?: Maybe<ImagingTreatmentGroup>;
  modelCount: Scalars['Int'];
  modelId: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  overage?: Maybe<Scalars['Float']>;
  tissueBioanalysisTreatmentGroup?: Maybe<TissueBioanalysisTreatmentGroup>;
  treatmentGroupIndex: Scalars['Int'];
  treatmentId: Scalars['Int'];
};

export type TreatmentGroupIndexInput = {
  experimentId: Scalars['Int'];
  newTreatmentGroupIndex: Scalars['Int'];
  oldTreatmentGroupIndex: Scalars['Int'];
};

export type UpdateBioanalysisCollectionScheduleInput = {
  id?: InputMaybe<Scalars['Int']>;
  isDefault: Scalars['Boolean'];
  onlyGroups: Array<Scalars['Int']>;
  timepoints: Array<UpdateBioanalysisTimepointInput>;
};

export type UpdateBioanalysisTimepointInput = {
  dose: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  minutes: Scalars['Int'];
  onlyAnimals: Array<Scalars['Int']>;
};

export type UpdateBioanalysisTissueInput = {
  handlingAndStorage: Array<HandlingAndStorageInput>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  tissue: Scalars['String'];
};

export type UpdateBioanalysisTreatmentGroupInput = {
  baseTestArticleId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  treatmentGroupId: Scalars['Int'];
};

export type UpdateBloodBioanalysisInput = {
  bloodType: Scalars['String'];
  collectionSchedules: Array<UpdateBioanalysisCollectionScheduleInput>;
  id: Scalars['Int'];
  methods: Array<Scalars['String']>;
  otherMethods?: InputMaybe<Scalars['String']>;
  sampleAmount: Scalars['Int'];
  treatmentGroups: Array<UpdateBioanalysisTreatmentGroupInput>;
};

export type UpdateCroCellLineInput = {
  cultureProperties?: InputMaybe<Scalars['String']>;
  disease: Scalars['String'];
  id: Scalars['Int'];
  location: Scalars['String'];
  modelType: Scalars['String'];
  name: Scalars['String'];
  recommendedGrowthMedia?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  species: Scalars['String'];
};

export type UpdateExperimentInput = {
  CRO?: InputMaybe<Scalars['Boolean']>;
  IACUC?: InputMaybe<Scalars['String']>;
  MTA?: InputMaybe<Scalars['Boolean']>;
  approvalName?: InputMaybe<Scalars['String']>;
  conclusion?: InputMaybe<Scalars['String']>;
  coordinatorId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  designMethods?: InputMaybe<Scalars['String']>;
  endpoints?: InputMaybe<Scalars['String']>;
  hypothesis?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  meetingDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Scalars['String']>;
  purposes?: InputMaybe<Scalars['String']>;
  researcherId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ExperimentState>;
  subStatus?: InputMaybe<ExperimentSubState>;
  subtitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateImagingInput = {
  id: Scalars['Int'];
  instructions?: InputMaybe<Scalars['String']>;
  numViews: Scalars['Int'];
  timePoints: Scalars['String'];
  treatmentGroups: Array<UpdateImagingTreatmentGroupInput>;
};

export type UpdateImagingTreatmentGroupInput = {
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  treatmentGroupId: Scalars['Int'];
};

export type UpdateInventoryInput = {
  dob?: InputMaybe<Scalars['DateTime']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  species?: InputMaybe<Species>;
  status?: InputMaybe<InventoryStatus>;
  strain?: InputMaybe<Scalars['String']>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateInventoryRequestInput = {
  experimentId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  inventoryId?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<InventoryRequestStatus>;
  /** Pass true if the update should attempt to create a new record if a record with the passed id does not exist */
  upsert?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateModelInput = {
  cellLineId?: InputMaybe<Scalars['Int']>;
  gender: Gender;
  id: Scalars['Int'];
  implant: Implant;
  species: Species;
  strain: Scalars['String'];
  subcutaneousEndpoint?: InputMaybe<Scalars['String']>;
  tumorStartingVolume?: InputMaybe<Scalars['String']>;
};

export type UpdateOtherMoleculeInput = {
  category?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePkBloodWorksheetBasisDateInput = {
  basisDate?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type UpdatePkBloodWorksheetCollectionActualTimeInput = {
  actualTime?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type UpdatePkBloodWorksheetCollectionActualTimesInput = {
  actualTimes: Array<UpdatePkBloodWorksheetCollectionActualTimeInput>;
  pkBloodWorksheetId: Scalars['Int'];
};

export type UpdatePkBloodWorksheetNotesInput = {
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdatePkBloodWorksheetStatusInput = {
  id: Scalars['Int'];
  status: Scalars['String'];
};

export type UpdatePkTissueWorksheetBasisDateInput = {
  basisDate?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type UpdatePkTissueWorksheetCollectionActualTimeInput = {
  actualTime?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type UpdatePkTissueWorksheetCollectionActualTimesInput = {
  actualTimes: Array<UpdatePkTissueWorksheetCollectionActualTimeInput>;
  pkTissueWorksheetId: Scalars['Int'];
};

export type UpdatePkTissueWorksheetHandlingAndStorageInput = {
  collected: Scalars['Boolean'];
  id: Scalars['Int'];
  weight?: InputMaybe<Scalars['Float']>;
};

export type UpdatePkTissueWorksheetNotesInput = {
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdatePkTissueWorksheetStatusInput = {
  id: Scalars['Int'];
  status: Scalars['String'];
};

export type UpdateTestArticleInput = {
  dosage?: InputMaybe<Scalars['Float']>;
  doseNumber?: InputMaybe<Scalars['Int']>;
  doseUnit?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  interval?: InputMaybe<Scalars['Float']>;
  moleculeId?: InputMaybe<Scalars['Int']>;
  moleculeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  route?: InputMaybe<Scalars['String']>;
};

export type UpdateTissueBioanalysisInput = {
  collectionCriteria: Scalars['String'];
  collectionSchedules: Array<UpdateBioanalysisCollectionScheduleInput>;
  destination: Scalars['String'];
  id: Scalars['Int'];
  stains?: InputMaybe<Scalars['String']>;
  tissues: Array<UpdateBioanalysisTissueInput>;
  treatmentGroups: Array<UpdateBioanalysisTreatmentGroupInput>;
};

export type UpdateTreatmentGroupInput = {
  hasBioanalysis?: InputMaybe<Scalars['Boolean']>;
  hasImaging?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  modelCount?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  overage?: InputMaybe<Scalars['Float']>;
  treatmentGroupIndex?: InputMaybe<Scalars['Int']>;
  treatmentId?: InputMaybe<Scalars['Int']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['Int']>;
};

export type UpdateWorksheetEntryDataValuesInput = {
  dataUpdates: Scalars['String'];
  id: Scalars['Int'];
};

export type UpdateWorksheetStatusInput = {
  id: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Permission>>;
  roleId: Scalars['Int'];
  userRole: Role;
};

export type UserCollection = {
  __typename?: 'UserCollection';
  items: Array<User>;
  totalCount: Scalars['Int'];
};

export type Worksheet = {
  __typename?: 'Worksheet';
  animalId?: Maybe<Scalars['Int']>;
  definition: Scalars['String'];
  entries?: Maybe<Array<Maybe<WorksheetEntry>>>;
  experimentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  treatmentGroupId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type WorksheetCollection = {
  __typename?: 'WorksheetCollection';
  items: Array<Worksheet>;
  totalCount: Scalars['Int'];
};

export type WorksheetEntry = {
  __typename?: 'WorksheetEntry';
  columnId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  rowId?: Maybe<Scalars['String']>;
  sectionId: Scalars['String'];
  worksheetId: Scalars['Int'];
};

export type WorksheetEntryCollection = {
  __typename?: 'WorksheetEntryCollection';
  items: Array<WorksheetEntry>;
  totalCount: Scalars['Int'];
};

export type ExperimentForPermissionFragment = { __typename?: 'Experiment', id: number, status: ExperimentState, MTA: boolean, coordinator?: { __typename?: 'User', id: number } | undefined, owner: { __typename?: 'User', id: number }, researcher?: { __typename?: 'User', id: number } | undefined };

export type UserBasicInfoFragment = { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined };

export type UserForPermissionFragment = { __typename?: 'User', id: number };

export type CellLineFragment = { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean };

export type ModelFragment = { __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined };

export type PermissionFragment = { __typename?: 'Permission', action: PermissionAction, subject: PermissionResource, conditions?: string | undefined, fields: Array<string> };

export type RoleInfoFragment = { __typename?: 'Role', id: number, name: string };

export type TestArticleFragment = { __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined };

export type TreatmentFragment = { __typename?: 'Treatment', id: number, number: number, testArticles: Array<{ __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined }> };

export type TreatmentGroupFragment = { __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined };

export type ListContentDetailsFragment = { __typename?: 'ListContent', id: number, name: string, description?: string | undefined, category: ListContentCategory };

export type ExperimentBasicInfoFragment = { __typename?: 'Experiment', id: number, name: string, approvalName?: string | undefined, approvalCount: number, status: ExperimentState, hypothesis?: string | undefined, description?: string | undefined, priority?: number | undefined, updatedAt: string, submissionDate?: string | undefined, IACUC: string, CRO: boolean, MTA: boolean, project: string, type: string, subtitle?: string | undefined, completionDate?: string | undefined, owner: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined }, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined };

export type ExperimentForAdcOrderFragment = { __typename?: 'Experiment', approvalName?: string | undefined, approvalCount: number, updatedAt: string, name: string, id: number, status: ExperimentState, MTA: boolean, coordinator?: { __typename?: 'User', id: number } | undefined, owner: { __typename?: 'User', id: number }, researcher?: { __typename?: 'User', id: number } | undefined };

export type ExperimentForInventoryRequestFragment = { __typename?: 'ExperimentForInventoryRequest', approvalName?: string | undefined, MTA: boolean };

export type ExperimentForInventoryRequirementsFragment = { __typename?: 'Experiment', id: number, approvalName?: string | undefined, MTA: boolean, name: string, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, orders?: { __typename?: 'Orders', animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined } | undefined, inventoryRequests?: Array<{ __typename?: 'InventoryRequest', inventoryId: number, quantity: number, status: InventoryRequestStatus, inventory?: { __typename?: 'InventoryForInventoryRequest', poNumber: string, strain: string, status: string, dob: string } | undefined }> | undefined };

export type InventoryForInventoryRequestFragment = { __typename?: 'InventoryForInventoryRequest', gender: string, poNumber: string, species: string, strain: string, status: string, dob: string };

export type AttachmentDetailsFragment = { __typename?: 'Attachment', id: number, createdAt: string, filename: string, category: string, contentType: string };

export type ExperimentDetailsFragment = { __typename?: 'Experiment', IACUC: string, CRO: boolean, project: string, type: string, name: string, approvalName?: string | undefined, approvalCount: number, description?: string | undefined, hypothesis?: string | undefined, subStatus?: ExperimentSubState | undefined, purposes?: string | undefined, designMethods?: string | undefined, updatedAt: string, meetingDate?: string | undefined, endpoints?: string | undefined, conclusion?: string | undefined, id: number, status: ExperimentState, MTA: boolean, coordinator?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, attachments?: Array<{ __typename?: 'Attachment', id: number, createdAt: string, filename: string, category: string, contentType: string }> | undefined, team?: Array<{ __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined> | undefined, models: Array<{ __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined }>, owner: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined }, treatments: Array<{ __typename?: 'Treatment', id: number, number: number, testArticles: Array<{ __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined }> }>, treatmentGroups: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }>, activity: Array<{ __typename?: 'Activity', id: number, createdAt: string, message: string, createdBy: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } }>, orders?: { __typename?: 'Orders', adcOrder?: { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> } | undefined, nonAdcOrder?: { __typename?: 'NonAdcOrder', id: number, status: OrderStatus, nonAdcOrderItems: Array<{ __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> }> } | undefined, animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined } | undefined, worksheets?: Array<{ __typename?: 'Worksheet', id: number, experimentId?: number | undefined, definition: string, status?: string | undefined, type?: string | undefined, treatmentGroupId?: number | undefined, animalId?: number | undefined, name?: string | undefined }> | undefined, bloodBioanalysis?: { __typename?: 'BloodBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, methods: Array<string>, otherMethods?: string | undefined, sampleAmount: number, bloodType: string, treatmentGroups: Array<{ __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined } | undefined, tissueBioanalysis?: { __typename?: 'TissueBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, collectionCriteria: string, destination: string, stains?: string | undefined, treatmentGroups: Array<{ __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined, tissues: Array<{ __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> }> } | undefined, imaging?: { __typename?: 'Imaging', id: number, createdAt: string, updatedAt: string, experimentId: number, instructions?: string | undefined, timePoints: string, numViews: number, treatmentGroups: Array<{ __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined }> } | undefined };

export type UserDetailsFragment = { __typename?: 'User', email: string, firstName?: string | undefined, id: number, lastName?: string | undefined, roleId: number, userRole: { __typename?: 'Role', id: number, name: string } };

export type UserDetailsWithPermissionsFragment = { __typename?: 'User', email: string, firstName?: string | undefined, id: number, lastName?: string | undefined, roleId: number, permissions?: Array<{ __typename?: 'Permission', action: PermissionAction, subject: PermissionResource, conditions?: string | undefined, fields: Array<string> }> | undefined, userRole: { __typename?: 'Role', id: number, name: string } };

export type AntibodyDetailsFragment = { __typename?: 'Antibody', id: number, bioregId: string, name: string, sgName?: string | undefined, dotmaticId: number, humanizedVariant?: string | undefined, isoType?: string | undefined, status?: string | undefined, target?: string | undefined };

export type ConjugateDetailsFragment = { __typename?: 'Conjugate', id: number, bioregId: string, sgName: string, dotmaticId: number, drugLinker?: string | undefined, dars?: string | undefined, parentabbioregId: string, antibodyName: string };

export type SmallMoleculesDetailsFragment = { __typename?: 'SmallMolecule', id: number, name: string, type: string, bioregId: string, drugClass?: string | undefined, stereo?: string | undefined };

export type OtherMoleculesDetailsFragment = { __typename?: 'OtherMolecule', id: number, name: string, category: string, bioregId?: string | undefined, commonName?: string | undefined, otherNames?: string | undefined };

export type ProgramDetailsFragment = { __typename?: 'Program', id: number, name: string, bioregId: string, status: string, dotmaticId: number };

export type ActivityDetailsFragment = { __typename?: 'Activity', id: number, createdAt: string, message: string, createdBy: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } };

export type AdcOrderItemDetailsFragment = { __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } };

export type AdcOrderDetailsFragment = { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> };

export type AdcOrderWithExperimentFragment = { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, experiment: { __typename?: 'Experiment', approvalName?: string | undefined, approvalCount: number, updatedAt: string, name: string, id: number, status: ExperimentState, MTA: boolean, coordinator?: { __typename?: 'User', id: number } | undefined, owner: { __typename?: 'User', id: number }, researcher?: { __typename?: 'User', id: number } | undefined }, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> };

export type NonAdcOrderItemDetailsFragment = { __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> };

export type NonAdcOrderDetailsFragment = { __typename?: 'NonAdcOrder', id: number, status: OrderStatus, nonAdcOrderItems: Array<{ __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> }> };

export type AnimalOrderItemDetailsFragment = { __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } };

export type OrdersDetailsFragment = { __typename?: 'Orders', adcOrder?: { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> } | undefined, nonAdcOrder?: { __typename?: 'NonAdcOrder', id: number, status: OrderStatus, nonAdcOrderItems: Array<{ __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> }> } | undefined, animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined };

export type OrdersDetailsForInventoryRequirementsFragment = { __typename?: 'Orders', animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined };

export type OtherMoleculeDetailsFragment = { __typename?: 'OtherMolecule', id: number, name: string, category: string };

type BioanalysisTreatmentGroup_BloodBioanalysisTreatmentGroup_Fragment = { __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined };

type BioanalysisTreatmentGroup_TissueBioanalysisTreatmentGroup_Fragment = { __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined };

export type BioanalysisTreatmentGroupFragment = BioanalysisTreatmentGroup_BloodBioanalysisTreatmentGroup_Fragment | BioanalysisTreatmentGroup_TissueBioanalysisTreatmentGroup_Fragment;

type BioanalysisTimepoint_BloodBioanalysisTimepoint_Fragment = { __typename?: 'BloodBioanalysisTimepoint', id: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string };

type BioanalysisTimepoint_TissueBioanalysisTimepoint_Fragment = { __typename?: 'TissueBioanalysisTimepoint', id: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string };

export type BioanalysisTimepointFragment = BioanalysisTimepoint_BloodBioanalysisTimepoint_Fragment | BioanalysisTimepoint_TissueBioanalysisTimepoint_Fragment;

type BioanalysisCollectionSchedule_BloodBioanalysisCollectionSchedule_Fragment = { __typename?: 'BloodBioanalysisCollectionSchedule', id: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> };

type BioanalysisCollectionSchedule_TissueBioanalysisCollectionSchedule_Fragment = { __typename?: 'TissueBioanalysisCollectionSchedule', id: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> };

export type BioanalysisCollectionScheduleFragment = BioanalysisCollectionSchedule_BloodBioanalysisCollectionSchedule_Fragment | BioanalysisCollectionSchedule_TissueBioanalysisCollectionSchedule_Fragment;

export type BloodBioanalysisFragment = { __typename?: 'BloodBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, methods: Array<string>, otherMethods?: string | undefined, sampleAmount: number, bloodType: string, treatmentGroups: Array<{ __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined };

export type BloodBioanalysisTreatmentGroupFragment = { __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined };

export type BloodBioanalysisCollectionScheduleFragment = { __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> };

export type BloodBioanalysisTimepointFragment = { __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string };

export type TissueBioanalysisFragment = { __typename?: 'TissueBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, collectionCriteria: string, destination: string, stains?: string | undefined, treatmentGroups: Array<{ __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined, tissues: Array<{ __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> }> };

export type TissueBioanalysisTreatmentGroupFragment = { __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined };

export type TissueBioanalysisCollectionScheduleFragment = { __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> };

export type TissueBioanalysisTimepointFragment = { __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string };

export type TissueBioanalysisTissueFragment = { __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> };

export type HandlingAndStorageFragment = { __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean };

export type ImagingFragment = { __typename?: 'Imaging', id: number, createdAt: string, updatedAt: string, experimentId: number, instructions?: string | undefined, timePoints: string, numViews: number, treatmentGroups: Array<{ __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined }> };

export type ImagingTreatmentGroupFragment = { __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined };

export type AntibodiesByPageQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AntibodiesByPageQuery = { __typename?: 'Query', antibodies: { __typename?: 'AntibodyCollection', totalCount: number, items: Array<{ __typename?: 'Antibody', id: number, bioregId: string, name: string, sgName?: string | undefined, dotmaticId: number, humanizedVariant?: string | undefined, isoType?: string | undefined, status?: string | undefined, target?: string | undefined }> } };

export type ConjugatesByPageQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type ConjugatesByPageQuery = { __typename?: 'Query', conjugates: { __typename?: 'ConjugateCollection', totalCount: number, items: Array<{ __typename?: 'Conjugate', id: number, bioregId: string, sgName: string, dotmaticId: number, drugLinker?: string | undefined, dars?: string | undefined, parentabbioregId: string, antibodyName: string }> } };

export type SmallMoleculesByPageQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type SmallMoleculesByPageQuery = { __typename?: 'Query', smallMolecules: { __typename?: 'SmallMoleculeCollection', totalCount: number, items: Array<{ __typename?: 'SmallMolecule', id: number, name: string, type: string, bioregId: string, drugClass?: string | undefined, stereo?: string | undefined }> } };

export type OtherMoleculesByPageQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
}>;


export type OtherMoleculesByPageQuery = { __typename?: 'Query', otherMolecules: { __typename?: 'OtherMoleculeCollection', totalCount: number, items: Array<{ __typename?: 'OtherMolecule', id: number, name: string, category: string, bioregId?: string | undefined, commonName?: string | undefined, otherNames?: string | undefined }> } };

export type AllProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramCollection', items: Array<{ __typename?: 'Program', id: number, name: string, bioregId: string, status: string, dotmaticId: number }> } };

export type AllExperimentsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PaginationFilter>;
  sort?: InputMaybe<Array<PaginationSort> | PaginationSort>;
  statuses?: InputMaybe<Array<ExperimentState> | ExperimentState>;
}>;


export type AllExperimentsQuery = { __typename?: 'Query', experiments: { __typename?: 'ExperimentCollection', totalCount: number, items: Array<{ __typename?: 'Experiment', id: number, name: string, approvalName?: string | undefined, approvalCount: number, status: ExperimentState, hypothesis?: string | undefined, description?: string | undefined, priority?: number | undefined, updatedAt: string, submissionDate?: string | undefined, IACUC: string, CRO: boolean, MTA: boolean, project: string, type: string, subtitle?: string | undefined, completionDate?: string | undefined, owner: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined }, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined }> } };

export type ExperimentsByStatusQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<ExperimentState> | ExperimentState>;
}>;


export type ExperimentsByStatusQuery = { __typename?: 'Query', experimentsByStatus: { __typename?: 'ExperimentCollection', totalCount: number, items: Array<{ __typename?: 'Experiment', id: number, name: string, approvalName?: string | undefined, approvalCount: number, status: ExperimentState, hypothesis?: string | undefined, description?: string | undefined, priority?: number | undefined, updatedAt: string, submissionDate?: string | undefined, IACUC: string, CRO: boolean, MTA: boolean, project: string, type: string, subtitle?: string | undefined, completionDate?: string | undefined, owner: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined }, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined }> } };

export type AllUsersQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  excludedIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<PaginationSort> | PaginationSort>;
  filter?: InputMaybe<PaginationFilter>;
}>;


export type AllUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserCollection', totalCount: number, items: Array<{ __typename?: 'User', email: string, firstName?: string | undefined, id: number, lastName?: string | undefined, roleId: number, userRole: { __typename?: 'Role', id: number, name: string } }> } };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'Query', roles: { __typename?: 'RoleCollection', items: Array<{ __typename?: 'Role', id: number, name: string }> } };

export type ExperimentByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ExperimentByIdQuery = { __typename?: 'Query', experiment?: { __typename?: 'Experiment', IACUC: string, CRO: boolean, project: string, type: string, name: string, approvalName?: string | undefined, approvalCount: number, description?: string | undefined, hypothesis?: string | undefined, subStatus?: ExperimentSubState | undefined, purposes?: string | undefined, designMethods?: string | undefined, updatedAt: string, meetingDate?: string | undefined, endpoints?: string | undefined, conclusion?: string | undefined, id: number, status: ExperimentState, MTA: boolean, coordinator?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, attachments?: Array<{ __typename?: 'Attachment', id: number, createdAt: string, filename: string, category: string, contentType: string }> | undefined, team?: Array<{ __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined> | undefined, models: Array<{ __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined }>, owner: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined }, treatments: Array<{ __typename?: 'Treatment', id: number, number: number, testArticles: Array<{ __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined }> }>, treatmentGroups: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }>, activity: Array<{ __typename?: 'Activity', id: number, createdAt: string, message: string, createdBy: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } }>, orders?: { __typename?: 'Orders', adcOrder?: { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> } | undefined, nonAdcOrder?: { __typename?: 'NonAdcOrder', id: number, status: OrderStatus, nonAdcOrderItems: Array<{ __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> }> } | undefined, animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined } | undefined, worksheets?: Array<{ __typename?: 'Worksheet', id: number, experimentId?: number | undefined, definition: string, status?: string | undefined, type?: string | undefined, treatmentGroupId?: number | undefined, animalId?: number | undefined, name?: string | undefined }> | undefined, bloodBioanalysis?: { __typename?: 'BloodBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, methods: Array<string>, otherMethods?: string | undefined, sampleAmount: number, bloodType: string, treatmentGroups: Array<{ __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined } | undefined, tissueBioanalysis?: { __typename?: 'TissueBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, collectionCriteria: string, destination: string, stains?: string | undefined, treatmentGroups: Array<{ __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined, tissues: Array<{ __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> }> } | undefined, imaging?: { __typename?: 'Imaging', id: number, createdAt: string, updatedAt: string, experimentId: number, instructions?: string | undefined, timePoints: string, numViews: number, treatmentGroups: Array<{ __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined }> } | undefined } | undefined };

export type ListContentsQueryVariables = Exact<{
  category?: InputMaybe<ListContentCategory>;
}>;


export type ListContentsQuery = { __typename?: 'Query', listContents: { __typename?: 'ListContentCollection', items: Array<{ __typename?: 'ListContent', id: number, name: string, description?: string | undefined, category: ListContentCategory }> } };

export type UserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', email: string, firstName?: string | undefined, id: number, lastName?: string | undefined, roleId: number, userRole: { __typename?: 'Role', id: number, name: string } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', email: string, firstName?: string | undefined, id: number, lastName?: string | undefined, roleId: number, permissions?: Array<{ __typename?: 'Permission', action: PermissionAction, subject: PermissionResource, conditions?: string | undefined, fields: Array<string> }> | undefined, userRole: { __typename?: 'Role', id: number, name: string } } };

export type RelatedExperimentsQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type RelatedExperimentsQuery = { __typename?: 'Query', relatedExperiments: { __typename?: 'ExperimentCollection', totalCount: number, items: Array<{ __typename?: 'Experiment', id: number, name: string, approvalName?: string | undefined, approvalCount: number, status: ExperimentState, hypothesis?: string | undefined, description?: string | undefined, priority?: number | undefined, updatedAt: string, submissionDate?: string | undefined, IACUC: string, CRO: boolean, MTA: boolean, project: string, type: string, subtitle?: string | undefined, completionDate?: string | undefined, owner: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined }, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined }> } };

export type ExperimentActivityQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  experimentId: Scalars['Int'];
}>;


export type ExperimentActivityQuery = { __typename?: 'Query', activities: { __typename?: 'ActivityCollection', totalCount: number, items: Array<{ __typename?: 'Activity', id: number, createdAt: string, message: string, createdBy: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } }> } };

export type UpdateTestArticleMutationVariables = Exact<{
  input: UpdateTestArticleInput;
}>;


export type UpdateTestArticleMutation = { __typename?: 'Mutation', updateTestArticle: { __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined } };

export type AddUsersToExperimentMutationVariables = Exact<{
  input: AddUsersToExperimentInput;
}>;


export type AddUsersToExperimentMutation = { __typename?: 'Mutation', addUsersToExperiment: { __typename?: 'Experiment', team?: Array<{ __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined> | undefined } };

export type DeleteUserFromExperimentMutationVariables = Exact<{
  input: DeleteUserFromExperimentInput;
}>;


export type DeleteUserFromExperimentMutation = { __typename?: 'Mutation', deleteUserFromExperiment: { __typename?: 'Experiment', team?: Array<{ __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined> | undefined } };

export type AddTreatmentToExperimentMutationVariables = Exact<{
  input: AddTreatmentInput;
}>;


export type AddTreatmentToExperimentMutation = { __typename?: 'Mutation', addTreatmentToExperiment: { __typename?: 'Treatment', id: number } };

export type AddTestArticleToTreatmentMutationVariables = Exact<{
  input: AddTestArticleInput;
}>;


export type AddTestArticleToTreatmentMutation = { __typename?: 'Mutation', addTestArticleToTreatment: { __typename?: 'TestArticle', id: number } };

export type AddManyTestArticlesToTreatmentMutationVariables = Exact<{
  input: Array<AddTestArticleInput> | AddTestArticleInput;
}>;


export type AddManyTestArticlesToTreatmentMutation = { __typename?: 'Mutation', setTreatmentsTestArticles: Array<{ __typename?: 'Treatment', id: number, number: number, testArticles: Array<{ __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined }> }> };

export type AddModelToExperimentMutationVariables = Exact<{
  input: AddModelInput;
}>;


export type AddModelToExperimentMutation = { __typename?: 'Mutation', addModelToExperiment: Array<{ __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined }> };

export type UpdateModelMutationVariables = Exact<{
  input: UpdateModelInput;
}>;


export type UpdateModelMutation = { __typename?: 'Mutation', updateModel: Array<{ __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined }> };

export type DuplicateModelToExperimentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DuplicateModelToExperimentMutation = { __typename?: 'Mutation', duplicateAnimalToExperiment: { __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined } };

export type DuplicateTreatmentToExperimentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DuplicateTreatmentToExperimentMutation = { __typename?: 'Mutation', duplicateTreatmentToExperiment: Array<{ __typename?: 'Treatment', id: number, number: number, testArticles: Array<{ __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined }> }> };

export type DuplicateExperimentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DuplicateExperimentMutation = { __typename?: 'Mutation', duplicateExperiment: { __typename?: 'Experiment', id: number } };

export type CreateExperimentMutationVariables = Exact<{
  input: CreateExperimentInput;
}>;


export type CreateExperimentMutation = { __typename?: 'Mutation', createExperiment: { __typename?: 'Experiment', id: number } };

export type UpdateExperimentMutationVariables = Exact<{
  input: UpdateExperimentInput;
}>;


export type UpdateExperimentMutation = { __typename?: 'Mutation', updateExperiment: { __typename?: 'Experiment', IACUC: string, CRO: boolean, project: string, type: string, name: string, approvalName?: string | undefined, approvalCount: number, description?: string | undefined, hypothesis?: string | undefined, subStatus?: ExperimentSubState | undefined, purposes?: string | undefined, designMethods?: string | undefined, updatedAt: string, meetingDate?: string | undefined, endpoints?: string | undefined, conclusion?: string | undefined, id: number, status: ExperimentState, MTA: boolean, coordinator?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, attachments?: Array<{ __typename?: 'Attachment', id: number, createdAt: string, filename: string, category: string, contentType: string }> | undefined, team?: Array<{ __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined> | undefined, models: Array<{ __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined }>, owner: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined }, treatments: Array<{ __typename?: 'Treatment', id: number, number: number, testArticles: Array<{ __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined }> }>, treatmentGroups: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }>, activity: Array<{ __typename?: 'Activity', id: number, createdAt: string, message: string, createdBy: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } }>, orders?: { __typename?: 'Orders', adcOrder?: { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> } | undefined, nonAdcOrder?: { __typename?: 'NonAdcOrder', id: number, status: OrderStatus, nonAdcOrderItems: Array<{ __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> }> } | undefined, animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined } | undefined, worksheets?: Array<{ __typename?: 'Worksheet', id: number, experimentId?: number | undefined, definition: string, status?: string | undefined, type?: string | undefined, treatmentGroupId?: number | undefined, animalId?: number | undefined, name?: string | undefined }> | undefined, bloodBioanalysis?: { __typename?: 'BloodBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, methods: Array<string>, otherMethods?: string | undefined, sampleAmount: number, bloodType: string, treatmentGroups: Array<{ __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined } | undefined, tissueBioanalysis?: { __typename?: 'TissueBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, collectionCriteria: string, destination: string, stains?: string | undefined, treatmentGroups: Array<{ __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined, tissues: Array<{ __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> }> } | undefined, imaging?: { __typename?: 'Imaging', id: number, createdAt: string, updatedAt: string, experimentId: number, instructions?: string | undefined, timePoints: string, numViews: number, treatmentGroups: Array<{ __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined }> } | undefined } };

export type DeleteExperimentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteExperimentMutation = { __typename?: 'Mutation', removeExperiment: boolean };

export type CreateOtherMoleculeMutationVariables = Exact<{
  input: CreateOtherMoleculeInput;
}>;


export type CreateOtherMoleculeMutation = { __typename?: 'Mutation', createOtherMolecule: { __typename?: 'OtherMolecule', id: number, name: string, category: string } };

export type UpdateOtherMoleculeMutationVariables = Exact<{
  input: UpdateOtherMoleculeInput;
}>;


export type UpdateOtherMoleculeMutation = { __typename?: 'Mutation', updateOtherMolecule: { __typename?: 'OtherMolecule', id: number, name: string, category: string } };

export type DeleteOtherMoleculeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOtherMoleculeMutation = { __typename?: 'Mutation', deleteOtherMolecule: boolean };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', email: string, firstName?: string | undefined, id: number, lastName?: string | undefined, roleId: number, userRole: { __typename?: 'Role', id: number, name: string } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', email: string, firstName?: string | undefined, id: number, lastName?: string | undefined, roleId: number, userRole: { __typename?: 'Role', id: number, name: string } } };

export type RemoveModelMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveModelMutation = { __typename?: 'Mutation', removeModel: Array<{ __typename?: 'Model', id: number, species: Species, strain: string, gender: Gender, implant: Implant, subcutaneousEndpoint?: string | undefined, name: string, tumorStartingVolume?: string | undefined, implantationDate?: string | undefined, cellLine?: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } | undefined }> };

export type DeleteTreatmentGroupMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTreatmentGroupMutation = { __typename?: 'Mutation', removeTreatmentGroup: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }> };

export type DuplicateTreatmentGroupMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DuplicateTreatmentGroupMutation = { __typename?: 'Mutation', duplicateTreatmentGroup: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }> };

export type UpdateTreatmentGroupMutationVariables = Exact<{
  input: UpdateTreatmentGroupInput;
}>;


export type UpdateTreatmentGroupMutation = { __typename?: 'Mutation', updateTreatmentGroup: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }> };

export type AddTreatmentGroupMutationVariables = Exact<{
  input: AddTreatmentGroupInput;
}>;


export type AddTreatmentGroupMutation = { __typename?: 'Mutation', addTreatmentGroupToExperiment: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }> };

export type PopulateTreatmentGroupsMutationVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type PopulateTreatmentGroupsMutation = { __typename?: 'Mutation', populateTreatmentGroups: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }> };

export type UpdateTreatmentGroupIndexMutationVariables = Exact<{
  input: TreatmentGroupIndexInput;
}>;


export type UpdateTreatmentGroupIndexMutation = { __typename?: 'Mutation', updateTreatmentGroupIndex: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }> };

export type DeleteTreatmentFromExperimentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTreatmentFromExperimentMutation = { __typename?: 'Mutation', removeTreatment?: { __typename?: 'RemoveTreatmentResponse', treatments: Array<{ __typename?: 'Treatment', id: number, number: number, testArticles: Array<{ __typename?: 'TestArticle', id: number, name: string, doseNumber?: number | undefined, dosage?: number | undefined, doseUnit?: string | undefined, interval?: number | undefined, route?: string | undefined, moleculeId?: number | undefined, moleculeType?: string | undefined, bioregId?: string | undefined }> }>, treatmentGroups?: Array<{ __typename?: 'TreatmentGroup', id: number, treatmentId: number, treatmentGroupIndex: number, modelId: number, modelCount: number, hasBioanalysis?: boolean | undefined, hasImaging?: boolean | undefined, overage?: number | undefined, notes?: string | undefined }> | undefined } | undefined };

export type SetListContentCategoryMutationVariables = Exact<{
  input: ListContentCategoryInput;
}>;


export type SetListContentCategoryMutation = { __typename?: 'Mutation', setListContentCategory?: boolean | undefined };

export type ExperimentAttachmentsQueryVariables = Exact<{
  experimentId: Scalars['Int'];
  category: Scalars['String'];
}>;


export type ExperimentAttachmentsQuery = { __typename?: 'Query', experimentAttachments: Array<{ __typename?: 'Attachment', id: number, createdAt: string, filename: string, category: string, contentType: string }> };

export type ExperimentOrdersQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type ExperimentOrdersQuery = { __typename?: 'Query', experimentOrders: { __typename?: 'Orders', adcOrder?: { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> } | undefined, nonAdcOrder?: { __typename?: 'NonAdcOrder', id: number, status: OrderStatus, nonAdcOrderItems: Array<{ __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> }> } | undefined, animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined } };

export type AdcOrdersQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<OrderStatus>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AdcOrdersQuery = { __typename?: 'Query', adcOrders?: { __typename?: 'AdcOrderCollection', totalCount: number, items: Array<{ __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, experiment: { __typename?: 'Experiment', approvalName?: string | undefined, approvalCount: number, updatedAt: string, name: string, id: number, status: ExperimentState, MTA: boolean, coordinator?: { __typename?: 'User', id: number } | undefined, owner: { __typename?: 'User', id: number }, researcher?: { __typename?: 'User', id: number } | undefined }, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> }> } | undefined };

export type SyncExperimentOrdersMutationVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type SyncExperimentOrdersMutation = { __typename?: 'Mutation', syncExperimentOrders: { __typename?: 'Orders', adcOrder?: { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> } | undefined, nonAdcOrder?: { __typename?: 'NonAdcOrder', id: number, status: OrderStatus, nonAdcOrderItems: Array<{ __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> }> } | undefined, animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined } };

export type UpdateAnimalOrderItemMutationVariables = Exact<{
  input: AnimalOrderItemInput;
}>;


export type UpdateAnimalOrderItemMutation = { __typename?: 'Mutation', updateAnimalOrderItem: { __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } } };

export type UpdateAdcOrderMutationVariables = Exact<{
  input: AdcOrderInput;
}>;


export type UpdateAdcOrderMutation = { __typename?: 'Mutation', updateAdcOrder: { __typename?: 'AdcOrder', id: number, status: OrderStatus, experimentId: number, notes?: string | undefined, fulfilledAt?: string | undefined, adcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> } };

export type UpdateAdcOrderItemMutationVariables = Exact<{
  input: AdcOrderItemInput;
}>;


export type UpdateAdcOrderItemMutation = { __typename?: 'Mutation', updateAdcOrderItem: { __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } } };

export type UpdateNonAdcOrderItemMutationVariables = Exact<{
  input: NonAdcOrderItemInput;
}>;


export type UpdateNonAdcOrderItemMutation = { __typename?: 'Mutation', updateNonAdcOrderItem: { __typename?: 'NonAdcOrderItem', id: number, name: string, category: string, quantity: number, bioregId?: string | undefined, unit: string, fulfilledAt?: string | undefined, testArticles: Array<{ __typename?: 'TestArticle', moleculeId?: number | undefined, moleculeType?: string | undefined }> } };

export type DeliverAdcOrderItemsMutationVariables = Exact<{
  input: DeliverAdcOrderItemsInput;
}>;


export type DeliverAdcOrderItemsMutation = { __typename?: 'Mutation', deliverAdcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> };

export type ReturnAdcOrderItemsMutationVariables = Exact<{
  input: DeliverAdcOrderItemsInput;
}>;


export type ReturnAdcOrderItemsMutation = { __typename?: 'Mutation', returnAdcOrderItems: Array<{ __typename?: 'AdcOrderItem', id: number, bioregId?: string | undefined, quantity?: number | undefined, unit?: string | undefined, batchNumber?: string | undefined, deliveredAmount?: number | undefined, deliveredConcentration?: number | undefined, formulation?: string | undefined, mgPerMl?: number | undefined, deliveredAt?: string | undefined, isBioanalysis: boolean, purpose: string, wAvgOverage: number, returnedAt?: string | undefined, createdAt: string, removed: boolean, a280?: number | undefined, conjugate: { __typename?: 'Conjugate', sgName: string, dotmaticId: number, antibodyName: string } }> };

export type WorksheetFragment = { __typename?: 'Worksheet', id: number, experimentId?: number | undefined, definition: string, status?: string | undefined, type?: string | undefined, treatmentGroupId?: number | undefined, animalId?: number | undefined, name?: string | undefined };

export type WorksheetQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WorksheetQuery = { __typename?: 'Query', worksheet?: { __typename?: 'Worksheet', id: number, experimentId?: number | undefined, definition: string, status?: string | undefined, type?: string | undefined, treatmentGroupId?: number | undefined, animalId?: number | undefined, name?: string | undefined } | undefined };

export type WorksheetsByExperimentQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type WorksheetsByExperimentQuery = { __typename?: 'Query', worksheetsByExperiment: { __typename?: 'WorksheetCollection', totalCount: number, items: Array<{ __typename?: 'Worksheet', id: number, experimentId?: number | undefined, definition: string, status?: string | undefined, type?: string | undefined, treatmentGroupId?: number | undefined, animalId?: number | undefined, name?: string | undefined }> } };

export type UpdateWorksheetStatusMutationVariables = Exact<{
  input: UpdateWorksheetStatusInput;
}>;


export type UpdateWorksheetStatusMutation = { __typename?: 'Mutation', updateWorksheetStatus: { __typename?: 'Worksheet', id: number, experimentId?: number | undefined, definition: string, status?: string | undefined, type?: string | undefined, treatmentGroupId?: number | undefined, animalId?: number | undefined, name?: string | undefined } };

export type WorksheetEntryFragment = { __typename?: 'WorksheetEntry', id: number, worksheetId: number, sectionId: string, rowId?: string | undefined, columnId?: string | undefined, data?: string | undefined };

export type WorksheetEntryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WorksheetEntryQuery = { __typename?: 'Query', worksheetEntry?: { __typename?: 'WorksheetEntry', id: number, worksheetId: number, sectionId: string, rowId?: string | undefined, columnId?: string | undefined, data?: string | undefined } | undefined };

export type WorksheetEntriesByWorksheetQueryVariables = Exact<{
  worksheetId: Scalars['Int'];
}>;


export type WorksheetEntriesByWorksheetQuery = { __typename?: 'Query', worksheetEntriesByWorksheet: { __typename?: 'WorksheetEntryCollection', totalCount: number, items: Array<{ __typename?: 'WorksheetEntry', id: number, worksheetId: number, sectionId: string, rowId?: string | undefined, columnId?: string | undefined, data?: string | undefined }> } };

export type CreateWorksheetEntryMutationVariables = Exact<{
  input: CreateWorksheetEntryInput;
}>;


export type CreateWorksheetEntryMutation = { __typename?: 'Mutation', createWorksheetEntry: { __typename?: 'WorksheetEntry', id: number, worksheetId: number, sectionId: string, rowId?: string | undefined, columnId?: string | undefined, data?: string | undefined } };

export type BulkCreateWorksheetEntriesMutationVariables = Exact<{
  input: BulkCreateWorksheetEntriesInput;
}>;


export type BulkCreateWorksheetEntriesMutation = { __typename?: 'Mutation', bulkCreateWorksheetEntries: { __typename?: 'WorksheetEntryCollection', totalCount: number, items: Array<{ __typename?: 'WorksheetEntry', id: number, worksheetId: number, sectionId: string, rowId?: string | undefined, columnId?: string | undefined, data?: string | undefined }> } };

export type DeleteWorksheetEntryMutationVariables = Exact<{
  input: DeleteWorksheetEntryInput;
}>;


export type DeleteWorksheetEntryMutation = { __typename?: 'Mutation', deleteWorksheetEntry: { __typename?: 'WorksheetEntry', id: number } };

export type BulkDeleteWorksheetEntriesMutationVariables = Exact<{
  input: BulkDeleteWorksheetEntriesInput;
}>;


export type BulkDeleteWorksheetEntriesMutation = { __typename?: 'Mutation', bulkDeleteWorksheetEntries: { __typename?: 'WorksheetEntryCollection', totalCount: number, items: Array<{ __typename?: 'WorksheetEntry', id: number, worksheetId: number, sectionId: string, rowId?: string | undefined, columnId?: string | undefined, data?: string | undefined }> } };

export type UpdateWorksheetEntryDataValuesMutationVariables = Exact<{
  input: UpdateWorksheetEntryDataValuesInput;
}>;


export type UpdateWorksheetEntryDataValuesMutation = { __typename?: 'Mutation', updateWorksheetEntryDataValues: { __typename?: 'WorksheetEntry', id: number, worksheetId: number, sectionId: string, rowId?: string | undefined, columnId?: string | undefined, data?: string | undefined } };

export type InitWorksheetEntriesMutationVariables = Exact<{
  input: Array<CreateWorksheetEntryInput> | CreateWorksheetEntryInput;
}>;


export type InitWorksheetEntriesMutation = { __typename?: 'Mutation', initWorksheetEntries: number };

export type InventoryFragment = { __typename?: 'Inventory', createdAt: string, dob: string, gender: Gender, id: number, notes?: string | undefined, poNumber: string, quantity: number, species: Species, status: InventoryStatus, strain: string, updatedAt: string };

export type InventorySummaryFragment = { __typename?: 'Inventory', used?: number | undefined, reserved?: number | undefined, createdAt: string, dob: string, gender: Gender, id: number, notes?: string | undefined, poNumber: string, quantity: number, species: Species, status: InventoryStatus, strain: string, updatedAt: string };

export type InventoryRequestFragment = { __typename?: 'InventoryRequest', createdAt: string, experimentId?: number | undefined, id: number, inventoryId: number, notes?: string | undefined, quantity: number, status: InventoryRequestStatus, updatedAt: string, experiment?: { __typename?: 'ExperimentForInventoryRequest', approvalName?: string | undefined, MTA: boolean } | undefined, inventory?: { __typename?: 'InventoryForInventoryRequest', gender: string, poNumber: string, species: string, strain: string, status: string, dob: string } | undefined };

export type InventoryRequirementsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PaginationFilter>;
  sort?: InputMaybe<Array<PaginationSort> | PaginationSort>;
  statuses?: InputMaybe<Array<ExperimentState> | ExperimentState>;
}>;


export type InventoryRequirementsQuery = { __typename?: 'Query', experiments: { __typename?: 'ExperimentCollection', totalCount: number, items: Array<{ __typename?: 'Experiment', id: number, approvalName?: string | undefined, MTA: boolean, name: string, researcher?: { __typename?: 'User', id: number, email: string, firstName?: string | undefined, lastName?: string | undefined } | undefined, orders?: { __typename?: 'Orders', animalOrder?: { __typename?: 'AnimalOrder', id: number, status: OrderStatus, animalOrderItems: Array<{ __typename?: 'AnimalOrderItem', id: number, quantity: number, poNumber?: string | undefined, bornAt?: string | undefined, deliveredAt?: string | undefined, notes?: string | undefined, animal: { __typename?: 'Model', id: number, implant: Implant, species: Species, strain: string, gender: Gender } }> } | undefined } | undefined, inventoryRequests?: Array<{ __typename?: 'InventoryRequest', inventoryId: number, quantity: number, status: InventoryRequestStatus, inventory?: { __typename?: 'InventoryForInventoryRequest', poNumber: string, strain: string, status: string, dob: string } | undefined }> | undefined }> } };

export type InventoryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InventoryQuery = { __typename?: 'Query', inventory: { __typename?: 'Inventory', createdAt: string, dob: string, gender: Gender, id: number, notes?: string | undefined, poNumber: string, quantity: number, species: Species, status: InventoryStatus, strain: string, updatedAt: string } };

export type ListInventoryQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<InventoryFilters>;
  filter?: InputMaybe<PaginationFilter>;
  sort?: InputMaybe<Array<PaginationSort> | PaginationSort>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type ListInventoryQuery = { __typename?: 'Query', listInventory: { __typename?: 'InventoryCollection', totalCount: number, items: Array<{ __typename?: 'Inventory', used?: number | undefined, reserved?: number | undefined, createdAt: string, dob: string, gender: Gender, id: number, notes?: string | undefined, poNumber: string, quantity: number, species: Species, status: InventoryStatus, strain: string, updatedAt: string }> } };

export type InventoryRequestQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InventoryRequestQuery = { __typename?: 'Query', inventoryRequest: { __typename?: 'InventoryRequest', createdAt: string, experimentId?: number | undefined, id: number, inventoryId: number, notes?: string | undefined, quantity: number, status: InventoryRequestStatus, updatedAt: string, experiment?: { __typename?: 'ExperimentForInventoryRequest', approvalName?: string | undefined, MTA: boolean } | undefined, inventory?: { __typename?: 'InventoryForInventoryRequest', gender: string, poNumber: string, species: string, strain: string, status: string, dob: string } | undefined } };

export type ListInventoryRequestsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<InventoryRequestFilters>;
  filter?: InputMaybe<PaginationFilter>;
  sort?: InputMaybe<Array<PaginationSort> | PaginationSort>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type ListInventoryRequestsQuery = { __typename?: 'Query', listInventoryRequests: { __typename?: 'InventoryRequestCollection', totalCount: number, items: Array<{ __typename?: 'InventoryRequest', createdAt: string, experimentId?: number | undefined, id: number, inventoryId: number, notes?: string | undefined, quantity: number, status: InventoryRequestStatus, updatedAt: string, experiment?: { __typename?: 'ExperimentForInventoryRequest', approvalName?: string | undefined, MTA: boolean } | undefined, inventory?: { __typename?: 'InventoryForInventoryRequest', gender: string, poNumber: string, species: string, strain: string, status: string, dob: string } | undefined }> } };

export type InventoryRequestsByExperimentQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type InventoryRequestsByExperimentQuery = { __typename?: 'Query', inventoryRequestsByExperiment: Array<{ __typename?: 'InventoryRequest', createdAt: string, experimentId?: number | undefined, id: number, inventoryId: number, notes?: string | undefined, quantity: number, status: InventoryRequestStatus, updatedAt: string, experiment?: { __typename?: 'ExperimentForInventoryRequest', approvalName?: string | undefined, MTA: boolean } | undefined, inventory?: { __typename?: 'InventoryForInventoryRequest', gender: string, poNumber: string, species: string, strain: string, status: string, dob: string } | undefined }> };

export type CreateInventoryMutationVariables = Exact<{
  input: CreateInventoryInput;
}>;


export type CreateInventoryMutation = { __typename?: 'Mutation', createInventory: { __typename?: 'Inventory', createdAt: string, dob: string, gender: Gender, id: number, notes?: string | undefined, poNumber: string, quantity: number, species: Species, status: InventoryStatus, strain: string, updatedAt: string } };

export type CreateInventoryRequestMutationVariables = Exact<{
  input: CreateInventoryRequestInput;
}>;


export type CreateInventoryRequestMutation = { __typename?: 'Mutation', createInventoryRequest: { __typename?: 'InventoryRequest', createdAt: string, experimentId?: number | undefined, id: number, inventoryId: number, notes?: string | undefined, quantity: number, status: InventoryRequestStatus, updatedAt: string, experiment?: { __typename?: 'ExperimentForInventoryRequest', approvalName?: string | undefined, MTA: boolean } | undefined, inventory?: { __typename?: 'InventoryForInventoryRequest', gender: string, poNumber: string, species: string, strain: string, status: string, dob: string } | undefined } };

export type DeleteInventoryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInventoryMutation = { __typename?: 'Mutation', removeInventory: boolean };

export type DeleteInventoryRequestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInventoryRequestMutation = { __typename?: 'Mutation', removeInventoryRequest: boolean };

export type UpdateInventoryMutationVariables = Exact<{
  input: UpdateInventoryInput;
}>;


export type UpdateInventoryMutation = { __typename?: 'Mutation', updateInventory: { __typename?: 'Inventory', createdAt: string, dob: string, gender: Gender, id: number, notes?: string | undefined, poNumber: string, quantity: number, species: Species, status: InventoryStatus, strain: string, updatedAt: string } };

export type UpdateInventoryRequestMutationVariables = Exact<{
  input: UpdateInventoryRequestInput;
}>;


export type UpdateInventoryRequestMutation = { __typename?: 'Mutation', updateInventoryRequest: { __typename?: 'InventoryRequest', createdAt: string, experimentId?: number | undefined, id: number, inventoryId: number, notes?: string | undefined, quantity: number, status: InventoryRequestStatus, updatedAt: string, experiment?: { __typename?: 'ExperimentForInventoryRequest', approvalName?: string | undefined, MTA: boolean } | undefined, inventory?: { __typename?: 'InventoryForInventoryRequest', gender: string, poNumber: string, species: string, strain: string, status: string, dob: string } | undefined } };

export type BloodBioanalysisQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type BloodBioanalysisQuery = { __typename?: 'Query', bloodBioanalysis: { __typename?: 'BloodBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, methods: Array<string>, otherMethods?: string | undefined, sampleAmount: number, bloodType: string, treatmentGroups: Array<{ __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined } };

export type CreateBloodBioanalysisMutationVariables = Exact<{
  input: CreateBloodBioanalysisInput;
}>;


export type CreateBloodBioanalysisMutation = { __typename?: 'Mutation', createBloodBioanalysis: { __typename?: 'BloodBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, methods: Array<string>, otherMethods?: string | undefined, sampleAmount: number, bloodType: string, treatmentGroups: Array<{ __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined } };

export type DeleteBloodBioanalysisMutationVariables = Exact<{
  input: DeleteBloodBioanalysisInput;
}>;


export type DeleteBloodBioanalysisMutation = { __typename?: 'Mutation', deleteBloodBioanalysis: number };

export type UpdateBloodBioanalysisMutationVariables = Exact<{
  input: UpdateBloodBioanalysisInput;
}>;


export type UpdateBloodBioanalysisMutation = { __typename?: 'Mutation', updateBloodBioanalysis: { __typename?: 'BloodBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, methods: Array<string>, otherMethods?: string | undefined, sampleAmount: number, bloodType: string, treatmentGroups: Array<{ __typename?: 'BloodBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, bloodBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'BloodBioanalysisCollectionSchedule', id: number, bloodBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'BloodBioanalysisTimepoint', id: number, bloodBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined } };

export type TissueBioanalysisQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type TissueBioanalysisQuery = { __typename?: 'Query', tissueBioanalysis: { __typename?: 'TissueBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, collectionCriteria: string, destination: string, stains?: string | undefined, treatmentGroups: Array<{ __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined, tissues: Array<{ __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> }> } };

export type CreateTissueBioanalysisMutationVariables = Exact<{
  input: CreateTissueBioanalysisInput;
}>;


export type CreateTissueBioanalysisMutation = { __typename?: 'Mutation', createTissueBioanalysis: { __typename?: 'TissueBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, collectionCriteria: string, destination: string, stains?: string | undefined, treatmentGroups: Array<{ __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined, tissues: Array<{ __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> }> } };

export type DeleteTissueBioanalysisMutationVariables = Exact<{
  input: DeleteTissueBioanalysisInput;
}>;


export type DeleteTissueBioanalysisMutation = { __typename?: 'Mutation', deleteTissueBioanalysis: number };

export type UpdateTissueBioanalysisMutationVariables = Exact<{
  input: UpdateTissueBioanalysisInput;
}>;


export type UpdateTissueBioanalysisMutation = { __typename?: 'Mutation', updateTissueBioanalysis: { __typename?: 'TissueBioanalysis', id: number, createdAt: string, updatedAt: string, experimentId: number, collectionCriteria: string, destination: string, stains?: string | undefined, treatmentGroups: Array<{ __typename?: 'TissueBioanalysisTreatmentGroup', id: number, createdAt: string, updatedAt: string, tissueBioanalysisId: number, treatmentGroupId: number, baseTestArticleId: number, notes?: string | undefined }>, collectionSchedules?: Array<{ __typename?: 'TissueBioanalysisCollectionSchedule', id: number, tissueBioanalysisId: number, isDefault: boolean, onlyGroups: Array<number>, createdAt: string, updatedAt: string, timepoints: Array<{ __typename?: 'TissueBioanalysisTimepoint', id: number, tissueBioanalysisCollectionScheduleId: number, dose: number, minutes: number, onlyAnimals: Array<number>, createdAt: string, updatedAt: string }> }> | undefined, tissues: Array<{ __typename?: 'TissueBioanalysisTissue', id: number, tissueBioanalysisId: number, tissue: string, notes?: string | undefined, createdAt: string, updatedAt: string, handlingAndStorage: Array<{ __typename?: 'HandlingAndStorage', method: string, includeWeight: boolean }> }> } };

export type ImagingQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type ImagingQuery = { __typename?: 'Query', imaging: { __typename?: 'Imaging', id: number, createdAt: string, updatedAt: string, experimentId: number, instructions?: string | undefined, timePoints: string, numViews: number, treatmentGroups: Array<{ __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined }> } };

export type CreateImagingMutationVariables = Exact<{
  input: CreateImagingInput;
}>;


export type CreateImagingMutation = { __typename?: 'Mutation', createImaging: { __typename?: 'Imaging', id: number, createdAt: string, updatedAt: string, experimentId: number, instructions?: string | undefined, timePoints: string, numViews: number, treatmentGroups: Array<{ __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined }> } };

export type DeleteImagingMutationVariables = Exact<{
  input: DeleteImagingInput;
}>;


export type DeleteImagingMutation = { __typename?: 'Mutation', deleteImaging: number };

export type UpdateImagingMutationVariables = Exact<{
  input: UpdateImagingInput;
}>;


export type UpdateImagingMutation = { __typename?: 'Mutation', updateImaging: { __typename?: 'Imaging', id: number, createdAt: string, updatedAt: string, experimentId: number, instructions?: string | undefined, timePoints: string, numViews: number, treatmentGroups: Array<{ __typename?: 'ImagingTreatmentGroup', id: number, createdAt: string, updatedAt: string, imagingId: number, treatmentGroupId: number, notes?: string | undefined }> } };

export type CellLinePageByPageQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PaginationFilter>;
  sort?: InputMaybe<Array<PaginationSort> | PaginationSort>;
}>;


export type CellLinePageByPageQuery = { __typename?: 'Query', cellLines: { __typename?: 'CellLineCollection', totalCount: number, items: Array<{ __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean }> } };

export type CroCellLinesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PaginationFilter>;
  sort?: InputMaybe<Array<PaginationSort> | PaginationSort>;
}>;


export type CroCellLinesQuery = { __typename?: 'Query', croCellLines: { __typename?: 'CellLineCollection', totalCount: number, items: Array<{ __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean }> } };

export type CroCellLineQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CroCellLineQuery = { __typename?: 'Query', croCellLine: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } };

export type CreateCroCellLineMutationVariables = Exact<{
  input: CroCellLineInput;
}>;


export type CreateCroCellLineMutation = { __typename?: 'Mutation', createCROCellLine: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } };

export type DeleteCroCellLineMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCroCellLineMutation = { __typename?: 'Mutation', deleteCROCellLine: boolean };

export type UpdateCroCellLineMutationVariables = Exact<{
  input: UpdateCroCellLineInput;
}>;


export type UpdateCroCellLineMutation = { __typename?: 'Mutation', updateCROCellLine: { __typename?: 'CellLine', id: number, bioregId?: string | undefined, parentBioregId?: string | undefined, name: string, location: string, modelType?: string | undefined, cloneCount?: number | undefined, disease?: string | undefined, recommendedGrowthMedia?: string | undefined, status?: string | undefined, cultureProperties?: string | undefined, source?: string | undefined, species?: string | undefined, eln?: string | undefined, antibiotic?: string | undefined, catalogNumber?: string | undefined, geneticManipulation?: string | undefined, hyperlink?: string | undefined, notes?: string | undefined, seedingDensity384w?: string | undefined, seedingDensity96w?: string | undefined, antibioticSelectionConc?: string | undefined, geneticTarget?: string | undefined, licenseAgreement: boolean, tissueSource?: string | undefined, vectorName?: string | undefined, vendor?: string | undefined, vendorLink?: string | undefined, averageStudyDuration?: number | undefined, thawToImplant?: number | undefined, cro: boolean } };

export type PkBloodWorksheetForPermissionFragment = { __typename?: 'PKBloodWorksheet', status: string };

export type PkBloodWorksheetFragment = { __typename?: 'PKBloodWorksheet', id: number, experimentId: number, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string };

export type PkBloodWorksheetCollectionFragment = { __typename?: 'PKBloodWorksheetCollection', id: number, pkBloodWorksheetId: number, bloodBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string };

export type PkBloodWorksheetQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type PkBloodWorksheetQuery = { __typename?: 'Query', pkBloodWorksheet?: { __typename?: 'PKBloodWorksheet', id: number, experimentId: number, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string } | undefined };

export type PkBloodWorksheetWithCollectionsQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type PkBloodWorksheetWithCollectionsQuery = { __typename?: 'Query', pkBloodWorksheet?: { __typename?: 'PKBloodWorksheet', id: number, experimentId: number, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string, pkBloodWorksheetCollections?: Array<{ __typename?: 'PKBloodWorksheetCollection', id: number, pkBloodWorksheetId: number, bloodBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string }> | undefined } | undefined };

export type UpdatePkBloodWorksheetStatusMutationVariables = Exact<{
  input: UpdatePkBloodWorksheetStatusInput;
}>;


export type UpdatePkBloodWorksheetStatusMutation = { __typename?: 'Mutation', updatePKBloodWorksheetStatus: { __typename?: 'PKBloodWorksheet', id: number, experimentId: number, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string } };

export type UpdatePkBloodWorksheetBasisDateMutationVariables = Exact<{
  input: UpdatePkBloodWorksheetBasisDateInput;
}>;


export type UpdatePkBloodWorksheetBasisDateMutation = { __typename?: 'Mutation', updatePKBloodWorksheetBasisDate: { __typename?: 'PKBloodWorksheet', id: number, experimentId: number, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string, pkBloodWorksheetCollections?: Array<{ __typename?: 'PKBloodWorksheetCollection', id: number, pkBloodWorksheetId: number, bloodBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string }> | undefined } };

export type UpdatePkBloodWorksheetNotesMutationVariables = Exact<{
  input: UpdatePkBloodWorksheetNotesInput;
}>;


export type UpdatePkBloodWorksheetNotesMutation = { __typename?: 'Mutation', updatePKBloodWorksheetNotes: { __typename?: 'PKBloodWorksheet', id: number, experimentId: number, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string } };

export type UpdatePkBloodWorksheetCollectionActualTimeMutationVariables = Exact<{
  input: UpdatePkBloodWorksheetCollectionActualTimeInput;
}>;


export type UpdatePkBloodWorksheetCollectionActualTimeMutation = { __typename?: 'Mutation', updatePKBloodWorksheetCollectionActualTime: { __typename?: 'PKBloodWorksheetCollection', id: number, pkBloodWorksheetId: number, bloodBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string } };

export type UpdatePkBloodWorksheetCollectionActualTimesMutationVariables = Exact<{
  input: UpdatePkBloodWorksheetCollectionActualTimesInput;
}>;


export type UpdatePkBloodWorksheetCollectionActualTimesMutation = { __typename?: 'Mutation', updatePKBloodWorksheetCollectionActualTimes: Array<{ __typename?: 'PKBloodWorksheetCollection', id: number, pkBloodWorksheetId: number, bloodBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string }> };

export type ClearPkBloodWorksheetCollectionsActualTimeMutationVariables = Exact<{
  input: ClearPkBloodWorksheetCollectionsActualTimeInput;
}>;


export type ClearPkBloodWorksheetCollectionsActualTimeMutation = { __typename?: 'Mutation', clearPKBloodWorksheetCollectionsActualTime: Array<{ __typename?: 'PKBloodWorksheetCollection', id: number, pkBloodWorksheetId: number, bloodBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string }> };

export type PkTissueWorksheetForPermissionFragment = { __typename?: 'PKTissueWorksheet', status: string };

export type PkTissueWorksheetFragment = { __typename?: 'PKTissueWorksheet', id: number, experimentId: number, collectionCriteria: string, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string };

export type PkTissueWorksheetCollectionFragment = { __typename?: 'PKTissueWorksheetCollection', id: number, pkTissueWorksheetId: number, tissueBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetHandlingAndStorage: Array<{ __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string }> };

export type PkTissueWorksheetHandlingAndStorageFragment = { __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string };

export type PkTissueWorksheetQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type PkTissueWorksheetQuery = { __typename?: 'Query', pkTissueWorksheet?: { __typename?: 'PKTissueWorksheet', id: number, experimentId: number, collectionCriteria: string, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string } | undefined };

export type PkTissueWorksheetWithCollectionsQueryVariables = Exact<{
  experimentId: Scalars['Int'];
}>;


export type PkTissueWorksheetWithCollectionsQuery = { __typename?: 'Query', pkTissueWorksheet?: { __typename?: 'PKTissueWorksheet', id: number, experimentId: number, collectionCriteria: string, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetCollections?: Array<{ __typename?: 'PKTissueWorksheetCollection', id: number, pkTissueWorksheetId: number, tissueBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetHandlingAndStorage: Array<{ __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string }> }> | undefined } | undefined };

export type UpdatePkTissueWorksheetStatusMutationVariables = Exact<{
  input: UpdatePkTissueWorksheetStatusInput;
}>;


export type UpdatePkTissueWorksheetStatusMutation = { __typename?: 'Mutation', updatePKTissueWorksheetStatus: { __typename?: 'PKTissueWorksheet', id: number, experimentId: number, collectionCriteria: string, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string } };

export type UpdatePkTissueWorksheetBasisDateMutationVariables = Exact<{
  input: UpdatePkTissueWorksheetBasisDateInput;
}>;


export type UpdatePkTissueWorksheetBasisDateMutation = { __typename?: 'Mutation', updatePKTissueWorksheetBasisDate: { __typename?: 'PKTissueWorksheet', id: number, experimentId: number, collectionCriteria: string, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetCollections?: Array<{ __typename?: 'PKTissueWorksheetCollection', id: number, pkTissueWorksheetId: number, tissueBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetHandlingAndStorage: Array<{ __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string }> }> | undefined } };

export type UpdatePkTissueWorksheetNotesMutationVariables = Exact<{
  input: UpdatePkTissueWorksheetNotesInput;
}>;


export type UpdatePkTissueWorksheetNotesMutation = { __typename?: 'Mutation', updatePKTissueWorksheetNotes: { __typename?: 'PKTissueWorksheet', id: number, experimentId: number, collectionCriteria: string, status: string, basisDate?: string | undefined, notes?: string | undefined, createdAt: string, updatedAt: string } };

export type UpdatePkTissueWorksheetCollectionActualTimeMutationVariables = Exact<{
  input: UpdatePkTissueWorksheetCollectionActualTimeInput;
}>;


export type UpdatePkTissueWorksheetCollectionActualTimeMutation = { __typename?: 'Mutation', updatePKTissueWorksheetCollectionActualTime: { __typename?: 'PKTissueWorksheetCollection', id: number, pkTissueWorksheetId: number, tissueBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetHandlingAndStorage: Array<{ __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string }> } };

export type UpdatePkTissueWorksheetCollectionActualTimesMutationVariables = Exact<{
  input: UpdatePkTissueWorksheetCollectionActualTimesInput;
}>;


export type UpdatePkTissueWorksheetCollectionActualTimesMutation = { __typename?: 'Mutation', updatePKTissueWorksheetCollectionActualTimes: Array<{ __typename?: 'PKTissueWorksheetCollection', id: number, pkTissueWorksheetId: number, tissueBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetHandlingAndStorage: Array<{ __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string }> }> };

export type ClearPkTissueWorksheetCollectionsActualTimeMutationVariables = Exact<{
  input: ClearPkTissueWorksheetCollectionsActualTimeInput;
}>;


export type ClearPkTissueWorksheetCollectionsActualTimeMutation = { __typename?: 'Mutation', clearPKTissueWorksheetCollectionsActualTime: Array<{ __typename?: 'PKTissueWorksheetCollection', id: number, pkTissueWorksheetId: number, tissueBioanalysisTimepointId: number, treatmentGroupId: number, animalNumber: number, expectedDate?: string | undefined, expectedTime?: string | undefined, actualTime?: string | undefined, createdAt: string, updatedAt: string, pkTissueWorksheetHandlingAndStorage: Array<{ __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string }> }> };

export type UpdatePkTissueWorksheetHandlingAndStorageMutationVariables = Exact<{
  input: UpdatePkTissueWorksheetHandlingAndStorageInput;
}>;


export type UpdatePkTissueWorksheetHandlingAndStorageMutation = { __typename?: 'Mutation', updatePKTissueWorksheetHandlingAndStorage: { __typename?: 'PKTissueWorksheetHandlingAndStorage', id: number, pkTissueWorksheetCollectionId: number, tissueBioanalysisTissueId: number, method: string, weight?: number | undefined, collected: boolean, createdAt: string, updatedAt: string } };

export const UserForPermissionFragmentDoc = gql`
    fragment UserForPermission on User {
  id
}
    `;
export const ListContentDetailsFragmentDoc = gql`
    fragment ListContentDetails on ListContent {
  id
  name
  description
  category
}
    `;
export const UserBasicInfoFragmentDoc = gql`
    fragment UserBasicInfo on User {
  id
  email
  firstName
  lastName
}
    `;
export const ExperimentBasicInfoFragmentDoc = gql`
    fragment ExperimentBasicInfo on Experiment {
  id
  name
  approvalName
  approvalCount
  status
  hypothesis
  description
  priority
  updatedAt
  submissionDate
  IACUC
  CRO
  MTA
  project
  type
  owner {
    ...UserBasicInfo
  }
  researcher {
    ...UserBasicInfo
  }
  subtitle
  completionDate
}
    ${UserBasicInfoFragmentDoc}`;
export const AnimalOrderItemDetailsFragmentDoc = gql`
    fragment AnimalOrderItemDetails on AnimalOrderItem {
  id
  quantity
  poNumber
  bornAt
  deliveredAt
  notes
  animal {
    id
    implant
    species
    strain
    gender
  }
}
    `;
export const OrdersDetailsForInventoryRequirementsFragmentDoc = gql`
    fragment OrdersDetailsForInventoryRequirements on Orders {
  animalOrder {
    id
    status
    animalOrderItems {
      ...AnimalOrderItemDetails
    }
  }
}
    ${AnimalOrderItemDetailsFragmentDoc}`;
export const ExperimentForInventoryRequirementsFragmentDoc = gql`
    fragment ExperimentForInventoryRequirements on Experiment {
  id
  researcher {
    ...UserBasicInfo
  }
  approvalName
  MTA
  name
  orders {
    ...OrdersDetailsForInventoryRequirements
  }
  inventoryRequests {
    inventoryId
    quantity
    status
    inventory {
      poNumber
      strain
      status
      dob
    }
  }
}
    ${UserBasicInfoFragmentDoc}
${OrdersDetailsForInventoryRequirementsFragmentDoc}`;
export const ExperimentForPermissionFragmentDoc = gql`
    fragment ExperimentForPermission on Experiment {
  id
  status
  MTA
  coordinator {
    id
  }
  owner {
    id
  }
  researcher {
    id
  }
}
    `;
export const AttachmentDetailsFragmentDoc = gql`
    fragment AttachmentDetails on Attachment {
  id
  createdAt
  filename
  category
  contentType
}
    `;
export const CellLineFragmentDoc = gql`
    fragment CellLine on CellLine {
  id
  bioregId
  parentBioregId
  name
  location
  modelType
  cloneCount
  disease
  recommendedGrowthMedia
  status
  cultureProperties
  source
  species
  eln
  antibiotic
  catalogNumber
  geneticManipulation
  hyperlink
  notes
  seedingDensity384w
  seedingDensity96w
  antibioticSelectionConc
  geneticTarget
  licenseAgreement
  tissueSource
  vectorName
  vendor
  vendorLink
  averageStudyDuration
  thawToImplant
  cro
}
    `;
export const ModelFragmentDoc = gql`
    fragment Model on Model {
  id
  cellLine {
    ...CellLine
  }
  species
  strain
  gender
  implant
  subcutaneousEndpoint
  name
  tumorStartingVolume
  implantationDate
}
    ${CellLineFragmentDoc}`;
export const TestArticleFragmentDoc = gql`
    fragment TestArticle on TestArticle {
  id
  name
  doseNumber
  dosage
  doseUnit
  interval
  route
  moleculeId
  moleculeType
  bioregId
}
    `;
export const TreatmentFragmentDoc = gql`
    fragment Treatment on Treatment {
  id
  number
  testArticles {
    ...TestArticle
  }
}
    ${TestArticleFragmentDoc}`;
export const TreatmentGroupFragmentDoc = gql`
    fragment TreatmentGroup on TreatmentGroup {
  id
  treatmentId
  treatmentGroupIndex
  modelId
  modelCount
  hasBioanalysis
  hasImaging
  overage
  notes
}
    `;
export const ActivityDetailsFragmentDoc = gql`
    fragment ActivityDetails on Activity {
  id
  createdAt
  createdBy {
    ...UserBasicInfo
  }
  message
}
    ${UserBasicInfoFragmentDoc}`;
export const AdcOrderItemDetailsFragmentDoc = gql`
    fragment AdcOrderItemDetails on AdcOrderItem {
  id
  conjugate {
    sgName
    dotmaticId
    antibodyName
  }
  bioregId
  quantity
  unit
  batchNumber
  deliveredAmount
  deliveredConcentration
  formulation
  mgPerMl
  deliveredAt
  isBioanalysis
  purpose
  wAvgOverage
  returnedAt
  createdAt
  removed
  a280
}
    `;
export const AdcOrderDetailsFragmentDoc = gql`
    fragment AdcOrderDetails on AdcOrder {
  id
  status
  experimentId
  notes
  fulfilledAt
  adcOrderItems {
    ...AdcOrderItemDetails
  }
}
    ${AdcOrderItemDetailsFragmentDoc}`;
export const NonAdcOrderItemDetailsFragmentDoc = gql`
    fragment NonAdcOrderItemDetails on NonAdcOrderItem {
  id
  name
  category
  quantity
  bioregId
  unit
  fulfilledAt
  testArticles {
    moleculeId
    moleculeType
  }
}
    `;
export const NonAdcOrderDetailsFragmentDoc = gql`
    fragment NonAdcOrderDetails on NonAdcOrder {
  id
  status
  nonAdcOrderItems {
    ...NonAdcOrderItemDetails
  }
}
    ${NonAdcOrderItemDetailsFragmentDoc}`;
export const OrdersDetailsFragmentDoc = gql`
    fragment OrdersDetails on Orders {
  adcOrder {
    ...AdcOrderDetails
  }
  nonAdcOrder {
    ...NonAdcOrderDetails
  }
  animalOrder {
    id
    status
    animalOrderItems {
      ...AnimalOrderItemDetails
    }
  }
}
    ${AdcOrderDetailsFragmentDoc}
${NonAdcOrderDetailsFragmentDoc}
${AnimalOrderItemDetailsFragmentDoc}`;
export const WorksheetFragmentDoc = gql`
    fragment Worksheet on Worksheet {
  id
  experimentId
  definition
  status
  type
  treatmentGroupId
  animalId
  name
}
    `;
export const BloodBioanalysisTreatmentGroupFragmentDoc = gql`
    fragment BloodBioanalysisTreatmentGroup on BloodBioanalysisTreatmentGroup {
  id
  createdAt
  updatedAt
  bloodBioanalysisId
  treatmentGroupId
  baseTestArticleId
  notes
}
    `;
export const BloodBioanalysisTimepointFragmentDoc = gql`
    fragment BloodBioanalysisTimepoint on BloodBioanalysisTimepoint {
  id
  bloodBioanalysisCollectionScheduleId
  dose
  minutes
  onlyAnimals
  createdAt
  updatedAt
}
    `;
export const BloodBioanalysisCollectionScheduleFragmentDoc = gql`
    fragment BloodBioanalysisCollectionSchedule on BloodBioanalysisCollectionSchedule {
  id
  bloodBioanalysisId
  isDefault
  onlyGroups
  timepoints {
    ...BloodBioanalysisTimepoint
  }
  createdAt
  updatedAt
}
    ${BloodBioanalysisTimepointFragmentDoc}`;
export const BloodBioanalysisFragmentDoc = gql`
    fragment BloodBioanalysis on BloodBioanalysis {
  id
  createdAt
  updatedAt
  experimentId
  methods
  otherMethods
  sampleAmount
  bloodType
  treatmentGroups {
    ...BloodBioanalysisTreatmentGroup
  }
  collectionSchedules {
    ...BloodBioanalysisCollectionSchedule
  }
}
    ${BloodBioanalysisTreatmentGroupFragmentDoc}
${BloodBioanalysisCollectionScheduleFragmentDoc}`;
export const TissueBioanalysisTreatmentGroupFragmentDoc = gql`
    fragment TissueBioanalysisTreatmentGroup on TissueBioanalysisTreatmentGroup {
  id
  createdAt
  updatedAt
  tissueBioanalysisId
  treatmentGroupId
  baseTestArticleId
  notes
}
    `;
export const TissueBioanalysisTimepointFragmentDoc = gql`
    fragment TissueBioanalysisTimepoint on TissueBioanalysisTimepoint {
  id
  tissueBioanalysisCollectionScheduleId
  dose
  minutes
  onlyAnimals
  createdAt
  updatedAt
}
    `;
export const TissueBioanalysisCollectionScheduleFragmentDoc = gql`
    fragment TissueBioanalysisCollectionSchedule on TissueBioanalysisCollectionSchedule {
  id
  tissueBioanalysisId
  isDefault
  onlyGroups
  timepoints {
    ...TissueBioanalysisTimepoint
  }
  createdAt
  updatedAt
}
    ${TissueBioanalysisTimepointFragmentDoc}`;
export const HandlingAndStorageFragmentDoc = gql`
    fragment HandlingAndStorage on HandlingAndStorage {
  method
  includeWeight
}
    `;
export const TissueBioanalysisTissueFragmentDoc = gql`
    fragment TissueBioanalysisTissue on TissueBioanalysisTissue {
  id
  tissueBioanalysisId
  tissue
  handlingAndStorage {
    ...HandlingAndStorage
  }
  notes
  createdAt
  updatedAt
}
    ${HandlingAndStorageFragmentDoc}`;
export const TissueBioanalysisFragmentDoc = gql`
    fragment TissueBioanalysis on TissueBioanalysis {
  id
  createdAt
  updatedAt
  experimentId
  collectionCriteria
  destination
  stains
  treatmentGroups {
    ...TissueBioanalysisTreatmentGroup
  }
  collectionSchedules {
    ...TissueBioanalysisCollectionSchedule
  }
  tissues {
    ...TissueBioanalysisTissue
  }
}
    ${TissueBioanalysisTreatmentGroupFragmentDoc}
${TissueBioanalysisCollectionScheduleFragmentDoc}
${TissueBioanalysisTissueFragmentDoc}`;
export const ImagingTreatmentGroupFragmentDoc = gql`
    fragment ImagingTreatmentGroup on ImagingTreatmentGroup {
  id
  createdAt
  updatedAt
  imagingId
  treatmentGroupId
  notes
}
    `;
export const ImagingFragmentDoc = gql`
    fragment Imaging on Imaging {
  id
  createdAt
  updatedAt
  experimentId
  instructions
  timePoints
  treatmentGroups {
    ...ImagingTreatmentGroup
  }
  numViews
}
    ${ImagingTreatmentGroupFragmentDoc}`;
export const ExperimentDetailsFragmentDoc = gql`
    fragment ExperimentDetails on Experiment {
  ...ExperimentForPermission
  IACUC
  CRO
  project
  type
  name
  approvalName
  approvalCount
  description
  hypothesis
  subStatus
  coordinator {
    ...UserBasicInfo
  }
  researcher {
    ...UserBasicInfo
  }
  purposes
  designMethods
  updatedAt
  meetingDate
  endpoints
  conclusion
  attachments {
    ...AttachmentDetails
  }
  team {
    ...UserBasicInfo
  }
  models {
    ...Model
  }
  owner {
    ...UserBasicInfo
  }
  treatments {
    ...Treatment
  }
  treatmentGroups {
    ...TreatmentGroup
  }
  activity {
    ...ActivityDetails
  }
  orders {
    ...OrdersDetails
  }
  worksheets {
    ...Worksheet
  }
  bloodBioanalysis {
    ...BloodBioanalysis
  }
  tissueBioanalysis {
    ...TissueBioanalysis
  }
  imaging {
    ...Imaging
  }
}
    ${ExperimentForPermissionFragmentDoc}
${UserBasicInfoFragmentDoc}
${AttachmentDetailsFragmentDoc}
${ModelFragmentDoc}
${TreatmentFragmentDoc}
${TreatmentGroupFragmentDoc}
${ActivityDetailsFragmentDoc}
${OrdersDetailsFragmentDoc}
${WorksheetFragmentDoc}
${BloodBioanalysisFragmentDoc}
${TissueBioanalysisFragmentDoc}
${ImagingFragmentDoc}`;
export const RoleInfoFragmentDoc = gql`
    fragment RoleInfo on Role {
  id
  name
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  email
  firstName
  id
  lastName
  roleId
  userRole {
    ...RoleInfo
  }
}
    ${RoleInfoFragmentDoc}`;
export const PermissionFragmentDoc = gql`
    fragment Permission on Permission {
  action
  subject
  conditions
  fields
}
    `;
export const UserDetailsWithPermissionsFragmentDoc = gql`
    fragment UserDetailsWithPermissions on User {
  ...UserDetails
  permissions {
    ...Permission
  }
}
    ${UserDetailsFragmentDoc}
${PermissionFragmentDoc}`;
export const AntibodyDetailsFragmentDoc = gql`
    fragment AntibodyDetails on Antibody {
  id
  bioregId
  name
  sgName
  dotmaticId
  humanizedVariant
  isoType
  status
  target
}
    `;
export const ConjugateDetailsFragmentDoc = gql`
    fragment ConjugateDetails on Conjugate {
  id
  bioregId
  sgName
  dotmaticId
  drugLinker
  dars
  parentabbioregId
  antibodyName
}
    `;
export const SmallMoleculesDetailsFragmentDoc = gql`
    fragment SmallMoleculesDetails on SmallMolecule {
  id
  name
  type
  bioregId
  drugClass
  stereo
}
    `;
export const OtherMoleculesDetailsFragmentDoc = gql`
    fragment OtherMoleculesDetails on OtherMolecule {
  id
  name
  category
  bioregId
  commonName
  otherNames
}
    `;
export const ProgramDetailsFragmentDoc = gql`
    fragment ProgramDetails on Program {
  id
  name
  bioregId
  status
  dotmaticId
}
    `;
export const ExperimentForAdcOrderFragmentDoc = gql`
    fragment ExperimentForAdcOrder on Experiment {
  ...ExperimentForPermission
  approvalName
  approvalCount
  updatedAt
  name
}
    ${ExperimentForPermissionFragmentDoc}`;
export const AdcOrderWithExperimentFragmentDoc = gql`
    fragment AdcOrderWithExperiment on AdcOrder {
  ...AdcOrderDetails
  experiment {
    ...ExperimentForAdcOrder
  }
}
    ${AdcOrderDetailsFragmentDoc}
${ExperimentForAdcOrderFragmentDoc}`;
export const OtherMoleculeDetailsFragmentDoc = gql`
    fragment OtherMoleculeDetails on OtherMolecule {
  id
  name
  category
}
    `;
export const BioanalysisTreatmentGroupFragmentDoc = gql`
    fragment BioanalysisTreatmentGroup on BioanalysisTreatmentGroup {
  id
  createdAt
  updatedAt
  treatmentGroupId
  baseTestArticleId
  notes
}
    `;
export const BioanalysisTimepointFragmentDoc = gql`
    fragment BioanalysisTimepoint on BioanalysisTimepoint {
  id
  dose
  minutes
  onlyAnimals
  createdAt
  updatedAt
}
    `;
export const BioanalysisCollectionScheduleFragmentDoc = gql`
    fragment BioanalysisCollectionSchedule on BioanalysisCollectionSchedule {
  id
  isDefault
  onlyGroups
  ... on BloodBioanalysisCollectionSchedule {
    timepoints {
      ...BloodBioanalysisTimepoint
    }
  }
  ... on TissueBioanalysisCollectionSchedule {
    timepoints {
      ...TissueBioanalysisTimepoint
    }
  }
  createdAt
  updatedAt
}
    ${BloodBioanalysisTimepointFragmentDoc}
${TissueBioanalysisTimepointFragmentDoc}`;
export const WorksheetEntryFragmentDoc = gql`
    fragment WorksheetEntry on WorksheetEntry {
  id
  worksheetId
  sectionId
  rowId
  columnId
  data
}
    `;
export const InventoryFragmentDoc = gql`
    fragment Inventory on Inventory {
  createdAt
  dob
  gender
  id
  notes
  poNumber
  quantity
  species
  status
  strain
  updatedAt
}
    `;
export const InventorySummaryFragmentDoc = gql`
    fragment InventorySummary on Inventory {
  ...Inventory
  used
  reserved
}
    ${InventoryFragmentDoc}`;
export const ExperimentForInventoryRequestFragmentDoc = gql`
    fragment ExperimentForInventoryRequest on ExperimentForInventoryRequest {
  approvalName
  MTA
}
    `;
export const InventoryForInventoryRequestFragmentDoc = gql`
    fragment InventoryForInventoryRequest on InventoryForInventoryRequest {
  gender
  poNumber
  species
  strain
  status
  dob
}
    `;
export const InventoryRequestFragmentDoc = gql`
    fragment InventoryRequest on InventoryRequest {
  createdAt
  experiment {
    ...ExperimentForInventoryRequest
  }
  experimentId
  id
  inventory {
    ...InventoryForInventoryRequest
  }
  inventoryId
  notes
  quantity
  status
  updatedAt
}
    ${ExperimentForInventoryRequestFragmentDoc}
${InventoryForInventoryRequestFragmentDoc}`;
export const PkBloodWorksheetForPermissionFragmentDoc = gql`
    fragment PKBloodWorksheetForPermission on PKBloodWorksheet {
  status
}
    `;
export const PkBloodWorksheetFragmentDoc = gql`
    fragment PKBloodWorksheet on PKBloodWorksheet {
  id
  experimentId
  status
  basisDate
  notes
  createdAt
  updatedAt
}
    `;
export const PkBloodWorksheetCollectionFragmentDoc = gql`
    fragment PKBloodWorksheetCollection on PKBloodWorksheetCollection {
  id
  pkBloodWorksheetId
  bloodBioanalysisTimepointId
  treatmentGroupId
  animalNumber
  expectedDate
  expectedTime
  actualTime
  createdAt
  updatedAt
}
    `;
export const PkTissueWorksheetForPermissionFragmentDoc = gql`
    fragment PKTissueWorksheetForPermission on PKTissueWorksheet {
  status
}
    `;
export const PkTissueWorksheetFragmentDoc = gql`
    fragment PKTissueWorksheet on PKTissueWorksheet {
  id
  experimentId
  collectionCriteria
  status
  basisDate
  notes
  createdAt
  updatedAt
}
    `;
export const PkTissueWorksheetHandlingAndStorageFragmentDoc = gql`
    fragment PKTissueWorksheetHandlingAndStorage on PKTissueWorksheetHandlingAndStorage {
  id
  pkTissueWorksheetCollectionId
  tissueBioanalysisTissueId
  method
  weight
  collected
  createdAt
  updatedAt
}
    `;
export const PkTissueWorksheetCollectionFragmentDoc = gql`
    fragment PKTissueWorksheetCollection on PKTissueWorksheetCollection {
  id
  pkTissueWorksheetId
  tissueBioanalysisTimepointId
  treatmentGroupId
  animalNumber
  expectedDate
  expectedTime
  actualTime
  createdAt
  updatedAt
  pkTissueWorksheetHandlingAndStorage {
    ...PKTissueWorksheetHandlingAndStorage
  }
}
    ${PkTissueWorksheetHandlingAndStorageFragmentDoc}`;
export const AntibodiesByPageDocument = gql`
    query antibodiesByPage($limit: Int!, $offset: Int, $query: String) {
  antibodies(limit: $limit, offset: $offset, query: $query) {
    items {
      ...AntibodyDetails
    }
    totalCount
  }
}
    ${AntibodyDetailsFragmentDoc}`;

/**
 * __useAntibodiesByPageQuery__
 *
 * To run a query within a React component, call `useAntibodiesByPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAntibodiesByPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAntibodiesByPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAntibodiesByPageQuery(baseOptions: Apollo.QueryHookOptions<AntibodiesByPageQuery, AntibodiesByPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AntibodiesByPageQuery, AntibodiesByPageQueryVariables>(AntibodiesByPageDocument, options);
      }
export function useAntibodiesByPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AntibodiesByPageQuery, AntibodiesByPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AntibodiesByPageQuery, AntibodiesByPageQueryVariables>(AntibodiesByPageDocument, options);
        }
export type AntibodiesByPageQueryHookResult = ReturnType<typeof useAntibodiesByPageQuery>;
export type AntibodiesByPageLazyQueryHookResult = ReturnType<typeof useAntibodiesByPageLazyQuery>;
export type AntibodiesByPageQueryResult = Apollo.QueryResult<AntibodiesByPageQuery, AntibodiesByPageQueryVariables>;
export const ConjugatesByPageDocument = gql`
    query conjugatesByPage($limit: Int!, $offset: Int, $query: String) {
  conjugates(limit: $limit, offset: $offset, query: $query) {
    items {
      ...ConjugateDetails
    }
    totalCount
  }
}
    ${ConjugateDetailsFragmentDoc}`;

/**
 * __useConjugatesByPageQuery__
 *
 * To run a query within a React component, call `useConjugatesByPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConjugatesByPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConjugatesByPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useConjugatesByPageQuery(baseOptions: Apollo.QueryHookOptions<ConjugatesByPageQuery, ConjugatesByPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConjugatesByPageQuery, ConjugatesByPageQueryVariables>(ConjugatesByPageDocument, options);
      }
export function useConjugatesByPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConjugatesByPageQuery, ConjugatesByPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConjugatesByPageQuery, ConjugatesByPageQueryVariables>(ConjugatesByPageDocument, options);
        }
export type ConjugatesByPageQueryHookResult = ReturnType<typeof useConjugatesByPageQuery>;
export type ConjugatesByPageLazyQueryHookResult = ReturnType<typeof useConjugatesByPageLazyQuery>;
export type ConjugatesByPageQueryResult = Apollo.QueryResult<ConjugatesByPageQuery, ConjugatesByPageQueryVariables>;
export const SmallMoleculesByPageDocument = gql`
    query smallMoleculesByPage($limit: Int!, $offset: Int, $query: String) {
  smallMolecules(limit: $limit, offset: $offset, query: $query) {
    items {
      ...SmallMoleculesDetails
    }
    totalCount
  }
}
    ${SmallMoleculesDetailsFragmentDoc}`;

/**
 * __useSmallMoleculesByPageQuery__
 *
 * To run a query within a React component, call `useSmallMoleculesByPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmallMoleculesByPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmallMoleculesByPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSmallMoleculesByPageQuery(baseOptions: Apollo.QueryHookOptions<SmallMoleculesByPageQuery, SmallMoleculesByPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmallMoleculesByPageQuery, SmallMoleculesByPageQueryVariables>(SmallMoleculesByPageDocument, options);
      }
export function useSmallMoleculesByPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmallMoleculesByPageQuery, SmallMoleculesByPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmallMoleculesByPageQuery, SmallMoleculesByPageQueryVariables>(SmallMoleculesByPageDocument, options);
        }
export type SmallMoleculesByPageQueryHookResult = ReturnType<typeof useSmallMoleculesByPageQuery>;
export type SmallMoleculesByPageLazyQueryHookResult = ReturnType<typeof useSmallMoleculesByPageLazyQuery>;
export type SmallMoleculesByPageQueryResult = Apollo.QueryResult<SmallMoleculesByPageQuery, SmallMoleculesByPageQueryVariables>;
export const OtherMoleculesByPageDocument = gql`
    query otherMoleculesByPage($limit: Int!, $offset: Int, $query: String, $category: String, $isEditable: Boolean) {
  otherMolecules(
    limit: $limit
    offset: $offset
    query: $query
    category: $category
    isEditable: $isEditable
  ) {
    items {
      ...OtherMoleculesDetails
    }
    totalCount
  }
}
    ${OtherMoleculesDetailsFragmentDoc}`;

/**
 * __useOtherMoleculesByPageQuery__
 *
 * To run a query within a React component, call `useOtherMoleculesByPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtherMoleculesByPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtherMoleculesByPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      category: // value for 'category'
 *      isEditable: // value for 'isEditable'
 *   },
 * });
 */
export function useOtherMoleculesByPageQuery(baseOptions: Apollo.QueryHookOptions<OtherMoleculesByPageQuery, OtherMoleculesByPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtherMoleculesByPageQuery, OtherMoleculesByPageQueryVariables>(OtherMoleculesByPageDocument, options);
      }
export function useOtherMoleculesByPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtherMoleculesByPageQuery, OtherMoleculesByPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtherMoleculesByPageQuery, OtherMoleculesByPageQueryVariables>(OtherMoleculesByPageDocument, options);
        }
export type OtherMoleculesByPageQueryHookResult = ReturnType<typeof useOtherMoleculesByPageQuery>;
export type OtherMoleculesByPageLazyQueryHookResult = ReturnType<typeof useOtherMoleculesByPageLazyQuery>;
export type OtherMoleculesByPageQueryResult = Apollo.QueryResult<OtherMoleculesByPageQuery, OtherMoleculesByPageQueryVariables>;
export const AllProgramsDocument = gql`
    query allPrograms {
  programs {
    items {
      ...ProgramDetails
    }
  }
}
    ${ProgramDetailsFragmentDoc}`;

/**
 * __useAllProgramsQuery__
 *
 * To run a query within a React component, call `useAllProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProgramsQuery(baseOptions?: Apollo.QueryHookOptions<AllProgramsQuery, AllProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProgramsQuery, AllProgramsQueryVariables>(AllProgramsDocument, options);
      }
export function useAllProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProgramsQuery, AllProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProgramsQuery, AllProgramsQueryVariables>(AllProgramsDocument, options);
        }
export type AllProgramsQueryHookResult = ReturnType<typeof useAllProgramsQuery>;
export type AllProgramsLazyQueryHookResult = ReturnType<typeof useAllProgramsLazyQuery>;
export type AllProgramsQueryResult = Apollo.QueryResult<AllProgramsQuery, AllProgramsQueryVariables>;
export const AllExperimentsDocument = gql`
    query allExperiments($limit: Int!, $offset: Int, $query: String, $filter: PaginationFilter, $sort: [PaginationSort!], $statuses: [ExperimentState!]) {
  experiments(
    limit: $limit
    offset: $offset
    query: $query
    sort: $sort
    filter: $filter
    statuses: $statuses
  ) {
    items {
      ...ExperimentBasicInfo
    }
    totalCount
  }
}
    ${ExperimentBasicInfoFragmentDoc}`;

/**
 * __useAllExperimentsQuery__
 *
 * To run a query within a React component, call `useAllExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllExperimentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useAllExperimentsQuery(baseOptions: Apollo.QueryHookOptions<AllExperimentsQuery, AllExperimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllExperimentsQuery, AllExperimentsQueryVariables>(AllExperimentsDocument, options);
      }
export function useAllExperimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllExperimentsQuery, AllExperimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllExperimentsQuery, AllExperimentsQueryVariables>(AllExperimentsDocument, options);
        }
export type AllExperimentsQueryHookResult = ReturnType<typeof useAllExperimentsQuery>;
export type AllExperimentsLazyQueryHookResult = ReturnType<typeof useAllExperimentsLazyQuery>;
export type AllExperimentsQueryResult = Apollo.QueryResult<AllExperimentsQuery, AllExperimentsQueryVariables>;
export const ExperimentsByStatusDocument = gql`
    query experimentsByStatus($limit: Int!, $offset: Int, $query: String, $filter: String, $sort: String, $statuses: [ExperimentState!]) {
  experimentsByStatus(
    limit: $limit
    offset: $offset
    sort: $sort
    query: $query
    filter: $filter
    statuses: $statuses
  ) {
    items {
      ...ExperimentBasicInfo
    }
    totalCount
  }
}
    ${ExperimentBasicInfoFragmentDoc}`;

/**
 * __useExperimentsByStatusQuery__
 *
 * To run a query within a React component, call `useExperimentsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentsByStatusQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useExperimentsByStatusQuery(baseOptions: Apollo.QueryHookOptions<ExperimentsByStatusQuery, ExperimentsByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentsByStatusQuery, ExperimentsByStatusQueryVariables>(ExperimentsByStatusDocument, options);
      }
export function useExperimentsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentsByStatusQuery, ExperimentsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentsByStatusQuery, ExperimentsByStatusQueryVariables>(ExperimentsByStatusDocument, options);
        }
export type ExperimentsByStatusQueryHookResult = ReturnType<typeof useExperimentsByStatusQuery>;
export type ExperimentsByStatusLazyQueryHookResult = ReturnType<typeof useExperimentsByStatusLazyQuery>;
export type ExperimentsByStatusQueryResult = Apollo.QueryResult<ExperimentsByStatusQuery, ExperimentsByStatusQueryVariables>;
export const AllUsersDocument = gql`
    query allUsers($limit: Int!, $offset: Int, $query: String, $excludedIds: [Int!], $role: String, $sort: [PaginationSort!], $filter: PaginationFilter) {
  users(
    limit: $limit
    offset: $offset
    query: $query
    excludedIds: $excludedIds
    role: $role
    sort: $sort
    filter: $filter
  ) {
    items {
      ...UserDetails
    }
    totalCount
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      excludedIds: // value for 'excludedIds'
 *      role: // value for 'role'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const AllRolesDocument = gql`
    query allRoles {
  roles {
    items {
      ...RoleInfo
    }
  }
}
    ${RoleInfoFragmentDoc}`;

/**
 * __useAllRolesQuery__
 *
 * To run a query within a React component, call `useAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
      }
export function useAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export type AllRolesQueryHookResult = ReturnType<typeof useAllRolesQuery>;
export type AllRolesLazyQueryHookResult = ReturnType<typeof useAllRolesLazyQuery>;
export type AllRolesQueryResult = Apollo.QueryResult<AllRolesQuery, AllRolesQueryVariables>;
export const ExperimentByIdDocument = gql`
    query experimentById($id: Int!) {
  experiment(id: $id) {
    ...ExperimentDetails
  }
}
    ${ExperimentDetailsFragmentDoc}`;

/**
 * __useExperimentByIdQuery__
 *
 * To run a query within a React component, call `useExperimentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExperimentByIdQuery(baseOptions: Apollo.QueryHookOptions<ExperimentByIdQuery, ExperimentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentByIdQuery, ExperimentByIdQueryVariables>(ExperimentByIdDocument, options);
      }
export function useExperimentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentByIdQuery, ExperimentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentByIdQuery, ExperimentByIdQueryVariables>(ExperimentByIdDocument, options);
        }
export type ExperimentByIdQueryHookResult = ReturnType<typeof useExperimentByIdQuery>;
export type ExperimentByIdLazyQueryHookResult = ReturnType<typeof useExperimentByIdLazyQuery>;
export type ExperimentByIdQueryResult = Apollo.QueryResult<ExperimentByIdQuery, ExperimentByIdQueryVariables>;
export const ListContentsDocument = gql`
    query listContents($category: ListContentCategory) {
  listContents(category: $category) {
    items {
      ...ListContentDetails
    }
  }
}
    ${ListContentDetailsFragmentDoc}`;

/**
 * __useListContentsQuery__
 *
 * To run a query within a React component, call `useListContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContentsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useListContentsQuery(baseOptions?: Apollo.QueryHookOptions<ListContentsQuery, ListContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContentsQuery, ListContentsQueryVariables>(ListContentsDocument, options);
      }
export function useListContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContentsQuery, ListContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContentsQuery, ListContentsQueryVariables>(ListContentsDocument, options);
        }
export type ListContentsQueryHookResult = ReturnType<typeof useListContentsQuery>;
export type ListContentsLazyQueryHookResult = ReturnType<typeof useListContentsLazyQuery>;
export type ListContentsQueryResult = Apollo.QueryResult<ListContentsQuery, ListContentsQueryVariables>;
export const UserDocument = gql`
    query user($id: Int!) {
  user(id: $id) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserDetailsWithPermissions
  }
}
    ${UserDetailsWithPermissionsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const RelatedExperimentsDocument = gql`
    query relatedExperiments($experimentId: Int!) {
  relatedExperiments(experimentId: $experimentId) {
    items {
      ...ExperimentBasicInfo
    }
    totalCount
  }
}
    ${ExperimentBasicInfoFragmentDoc}`;

/**
 * __useRelatedExperimentsQuery__
 *
 * To run a query within a React component, call `useRelatedExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedExperimentsQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useRelatedExperimentsQuery(baseOptions: Apollo.QueryHookOptions<RelatedExperimentsQuery, RelatedExperimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedExperimentsQuery, RelatedExperimentsQueryVariables>(RelatedExperimentsDocument, options);
      }
export function useRelatedExperimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedExperimentsQuery, RelatedExperimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedExperimentsQuery, RelatedExperimentsQueryVariables>(RelatedExperimentsDocument, options);
        }
export type RelatedExperimentsQueryHookResult = ReturnType<typeof useRelatedExperimentsQuery>;
export type RelatedExperimentsLazyQueryHookResult = ReturnType<typeof useRelatedExperimentsLazyQuery>;
export type RelatedExperimentsQueryResult = Apollo.QueryResult<RelatedExperimentsQuery, RelatedExperimentsQueryVariables>;
export const ExperimentActivityDocument = gql`
    query experimentActivity($limit: Int!, $offset: Int, $experimentId: Int!) {
  activities(limit: $limit, offset: $offset, experimentId: $experimentId) {
    items {
      ...ActivityDetails
    }
    totalCount
  }
}
    ${ActivityDetailsFragmentDoc}`;

/**
 * __useExperimentActivityQuery__
 *
 * To run a query within a React component, call `useExperimentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentActivityQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useExperimentActivityQuery(baseOptions: Apollo.QueryHookOptions<ExperimentActivityQuery, ExperimentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentActivityQuery, ExperimentActivityQueryVariables>(ExperimentActivityDocument, options);
      }
export function useExperimentActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentActivityQuery, ExperimentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentActivityQuery, ExperimentActivityQueryVariables>(ExperimentActivityDocument, options);
        }
export type ExperimentActivityQueryHookResult = ReturnType<typeof useExperimentActivityQuery>;
export type ExperimentActivityLazyQueryHookResult = ReturnType<typeof useExperimentActivityLazyQuery>;
export type ExperimentActivityQueryResult = Apollo.QueryResult<ExperimentActivityQuery, ExperimentActivityQueryVariables>;
export const UpdateTestArticleDocument = gql`
    mutation updateTestArticle($input: UpdateTestArticleInput!) {
  updateTestArticle(input: $input) {
    ...TestArticle
  }
}
    ${TestArticleFragmentDoc}`;
export type UpdateTestArticleMutationFn = Apollo.MutationFunction<UpdateTestArticleMutation, UpdateTestArticleMutationVariables>;

/**
 * __useUpdateTestArticleMutation__
 *
 * To run a mutation, you first call `useUpdateTestArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestArticleMutation, { data, loading, error }] = useUpdateTestArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestArticleMutation, UpdateTestArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestArticleMutation, UpdateTestArticleMutationVariables>(UpdateTestArticleDocument, options);
      }
export type UpdateTestArticleMutationHookResult = ReturnType<typeof useUpdateTestArticleMutation>;
export type UpdateTestArticleMutationResult = Apollo.MutationResult<UpdateTestArticleMutation>;
export type UpdateTestArticleMutationOptions = Apollo.BaseMutationOptions<UpdateTestArticleMutation, UpdateTestArticleMutationVariables>;
export const AddUsersToExperimentDocument = gql`
    mutation addUsersToExperiment($input: AddUsersToExperimentInput!) {
  addUsersToExperiment(input: $input) {
    team {
      ...UserBasicInfo
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;
export type AddUsersToExperimentMutationFn = Apollo.MutationFunction<AddUsersToExperimentMutation, AddUsersToExperimentMutationVariables>;

/**
 * __useAddUsersToExperimentMutation__
 *
 * To run a mutation, you first call `useAddUsersToExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToExperimentMutation, { data, loading, error }] = useAddUsersToExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUsersToExperimentMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToExperimentMutation, AddUsersToExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToExperimentMutation, AddUsersToExperimentMutationVariables>(AddUsersToExperimentDocument, options);
      }
export type AddUsersToExperimentMutationHookResult = ReturnType<typeof useAddUsersToExperimentMutation>;
export type AddUsersToExperimentMutationResult = Apollo.MutationResult<AddUsersToExperimentMutation>;
export type AddUsersToExperimentMutationOptions = Apollo.BaseMutationOptions<AddUsersToExperimentMutation, AddUsersToExperimentMutationVariables>;
export const DeleteUserFromExperimentDocument = gql`
    mutation deleteUserFromExperiment($input: DeleteUserFromExperimentInput!) {
  deleteUserFromExperiment(input: $input) {
    team {
      ...UserBasicInfo
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;
export type DeleteUserFromExperimentMutationFn = Apollo.MutationFunction<DeleteUserFromExperimentMutation, DeleteUserFromExperimentMutationVariables>;

/**
 * __useDeleteUserFromExperimentMutation__
 *
 * To run a mutation, you first call `useDeleteUserFromExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFromExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFromExperimentMutation, { data, loading, error }] = useDeleteUserFromExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserFromExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFromExperimentMutation, DeleteUserFromExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFromExperimentMutation, DeleteUserFromExperimentMutationVariables>(DeleteUserFromExperimentDocument, options);
      }
export type DeleteUserFromExperimentMutationHookResult = ReturnType<typeof useDeleteUserFromExperimentMutation>;
export type DeleteUserFromExperimentMutationResult = Apollo.MutationResult<DeleteUserFromExperimentMutation>;
export type DeleteUserFromExperimentMutationOptions = Apollo.BaseMutationOptions<DeleteUserFromExperimentMutation, DeleteUserFromExperimentMutationVariables>;
export const AddTreatmentToExperimentDocument = gql`
    mutation addTreatmentToExperiment($input: AddTreatmentInput!) {
  addTreatmentToExperiment(input: $input) {
    id
  }
}
    `;
export type AddTreatmentToExperimentMutationFn = Apollo.MutationFunction<AddTreatmentToExperimentMutation, AddTreatmentToExperimentMutationVariables>;

/**
 * __useAddTreatmentToExperimentMutation__
 *
 * To run a mutation, you first call `useAddTreatmentToExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTreatmentToExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTreatmentToExperimentMutation, { data, loading, error }] = useAddTreatmentToExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTreatmentToExperimentMutation(baseOptions?: Apollo.MutationHookOptions<AddTreatmentToExperimentMutation, AddTreatmentToExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTreatmentToExperimentMutation, AddTreatmentToExperimentMutationVariables>(AddTreatmentToExperimentDocument, options);
      }
export type AddTreatmentToExperimentMutationHookResult = ReturnType<typeof useAddTreatmentToExperimentMutation>;
export type AddTreatmentToExperimentMutationResult = Apollo.MutationResult<AddTreatmentToExperimentMutation>;
export type AddTreatmentToExperimentMutationOptions = Apollo.BaseMutationOptions<AddTreatmentToExperimentMutation, AddTreatmentToExperimentMutationVariables>;
export const AddTestArticleToTreatmentDocument = gql`
    mutation addTestArticleToTreatment($input: AddTestArticleInput!) {
  addTestArticleToTreatment(input: $input) {
    id
  }
}
    `;
export type AddTestArticleToTreatmentMutationFn = Apollo.MutationFunction<AddTestArticleToTreatmentMutation, AddTestArticleToTreatmentMutationVariables>;

/**
 * __useAddTestArticleToTreatmentMutation__
 *
 * To run a mutation, you first call `useAddTestArticleToTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTestArticleToTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTestArticleToTreatmentMutation, { data, loading, error }] = useAddTestArticleToTreatmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTestArticleToTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<AddTestArticleToTreatmentMutation, AddTestArticleToTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTestArticleToTreatmentMutation, AddTestArticleToTreatmentMutationVariables>(AddTestArticleToTreatmentDocument, options);
      }
export type AddTestArticleToTreatmentMutationHookResult = ReturnType<typeof useAddTestArticleToTreatmentMutation>;
export type AddTestArticleToTreatmentMutationResult = Apollo.MutationResult<AddTestArticleToTreatmentMutation>;
export type AddTestArticleToTreatmentMutationOptions = Apollo.BaseMutationOptions<AddTestArticleToTreatmentMutation, AddTestArticleToTreatmentMutationVariables>;
export const AddManyTestArticlesToTreatmentDocument = gql`
    mutation addManyTestArticlesToTreatment($input: [AddTestArticleInput!]!) {
  setTreatmentsTestArticles(input: $input) {
    ...Treatment
  }
}
    ${TreatmentFragmentDoc}`;
export type AddManyTestArticlesToTreatmentMutationFn = Apollo.MutationFunction<AddManyTestArticlesToTreatmentMutation, AddManyTestArticlesToTreatmentMutationVariables>;

/**
 * __useAddManyTestArticlesToTreatmentMutation__
 *
 * To run a mutation, you first call `useAddManyTestArticlesToTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManyTestArticlesToTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManyTestArticlesToTreatmentMutation, { data, loading, error }] = useAddManyTestArticlesToTreatmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddManyTestArticlesToTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<AddManyTestArticlesToTreatmentMutation, AddManyTestArticlesToTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddManyTestArticlesToTreatmentMutation, AddManyTestArticlesToTreatmentMutationVariables>(AddManyTestArticlesToTreatmentDocument, options);
      }
export type AddManyTestArticlesToTreatmentMutationHookResult = ReturnType<typeof useAddManyTestArticlesToTreatmentMutation>;
export type AddManyTestArticlesToTreatmentMutationResult = Apollo.MutationResult<AddManyTestArticlesToTreatmentMutation>;
export type AddManyTestArticlesToTreatmentMutationOptions = Apollo.BaseMutationOptions<AddManyTestArticlesToTreatmentMutation, AddManyTestArticlesToTreatmentMutationVariables>;
export const AddModelToExperimentDocument = gql`
    mutation addModelToExperiment($input: AddModelInput!) {
  addModelToExperiment(input: $input) {
    ...Model
  }
}
    ${ModelFragmentDoc}`;
export type AddModelToExperimentMutationFn = Apollo.MutationFunction<AddModelToExperimentMutation, AddModelToExperimentMutationVariables>;

/**
 * __useAddModelToExperimentMutation__
 *
 * To run a mutation, you first call `useAddModelToExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddModelToExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addModelToExperimentMutation, { data, loading, error }] = useAddModelToExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddModelToExperimentMutation(baseOptions?: Apollo.MutationHookOptions<AddModelToExperimentMutation, AddModelToExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddModelToExperimentMutation, AddModelToExperimentMutationVariables>(AddModelToExperimentDocument, options);
      }
export type AddModelToExperimentMutationHookResult = ReturnType<typeof useAddModelToExperimentMutation>;
export type AddModelToExperimentMutationResult = Apollo.MutationResult<AddModelToExperimentMutation>;
export type AddModelToExperimentMutationOptions = Apollo.BaseMutationOptions<AddModelToExperimentMutation, AddModelToExperimentMutationVariables>;
export const UpdateModelDocument = gql`
    mutation updateModel($input: UpdateModelInput!) {
  updateModel(input: $input) {
    ...Model
  }
}
    ${ModelFragmentDoc}`;
export type UpdateModelMutationFn = Apollo.MutationFunction<UpdateModelMutation, UpdateModelMutationVariables>;

/**
 * __useUpdateModelMutation__
 *
 * To run a mutation, you first call `useUpdateModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelMutation, { data, loading, error }] = useUpdateModelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateModelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelMutation, UpdateModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelMutation, UpdateModelMutationVariables>(UpdateModelDocument, options);
      }
export type UpdateModelMutationHookResult = ReturnType<typeof useUpdateModelMutation>;
export type UpdateModelMutationResult = Apollo.MutationResult<UpdateModelMutation>;
export type UpdateModelMutationOptions = Apollo.BaseMutationOptions<UpdateModelMutation, UpdateModelMutationVariables>;
export const DuplicateModelToExperimentDocument = gql`
    mutation duplicateModelToExperiment($id: Int!) {
  duplicateAnimalToExperiment(id: $id) {
    ...Model
  }
}
    ${ModelFragmentDoc}`;
export type DuplicateModelToExperimentMutationFn = Apollo.MutationFunction<DuplicateModelToExperimentMutation, DuplicateModelToExperimentMutationVariables>;

/**
 * __useDuplicateModelToExperimentMutation__
 *
 * To run a mutation, you first call `useDuplicateModelToExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateModelToExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateModelToExperimentMutation, { data, loading, error }] = useDuplicateModelToExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateModelToExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateModelToExperimentMutation, DuplicateModelToExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateModelToExperimentMutation, DuplicateModelToExperimentMutationVariables>(DuplicateModelToExperimentDocument, options);
      }
export type DuplicateModelToExperimentMutationHookResult = ReturnType<typeof useDuplicateModelToExperimentMutation>;
export type DuplicateModelToExperimentMutationResult = Apollo.MutationResult<DuplicateModelToExperimentMutation>;
export type DuplicateModelToExperimentMutationOptions = Apollo.BaseMutationOptions<DuplicateModelToExperimentMutation, DuplicateModelToExperimentMutationVariables>;
export const DuplicateTreatmentToExperimentDocument = gql`
    mutation duplicateTreatmentToExperiment($id: Int!) {
  duplicateTreatmentToExperiment(id: $id) {
    ...Treatment
  }
}
    ${TreatmentFragmentDoc}`;
export type DuplicateTreatmentToExperimentMutationFn = Apollo.MutationFunction<DuplicateTreatmentToExperimentMutation, DuplicateTreatmentToExperimentMutationVariables>;

/**
 * __useDuplicateTreatmentToExperimentMutation__
 *
 * To run a mutation, you first call `useDuplicateTreatmentToExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTreatmentToExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTreatmentToExperimentMutation, { data, loading, error }] = useDuplicateTreatmentToExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateTreatmentToExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateTreatmentToExperimentMutation, DuplicateTreatmentToExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateTreatmentToExperimentMutation, DuplicateTreatmentToExperimentMutationVariables>(DuplicateTreatmentToExperimentDocument, options);
      }
export type DuplicateTreatmentToExperimentMutationHookResult = ReturnType<typeof useDuplicateTreatmentToExperimentMutation>;
export type DuplicateTreatmentToExperimentMutationResult = Apollo.MutationResult<DuplicateTreatmentToExperimentMutation>;
export type DuplicateTreatmentToExperimentMutationOptions = Apollo.BaseMutationOptions<DuplicateTreatmentToExperimentMutation, DuplicateTreatmentToExperimentMutationVariables>;
export const DuplicateExperimentDocument = gql`
    mutation duplicateExperiment($id: Int!) {
  duplicateExperiment(id: $id) {
    id
  }
}
    `;
export type DuplicateExperimentMutationFn = Apollo.MutationFunction<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>;

/**
 * __useDuplicateExperimentMutation__
 *
 * To run a mutation, you first call `useDuplicateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateExperimentMutation, { data, loading, error }] = useDuplicateExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>(DuplicateExperimentDocument, options);
      }
export type DuplicateExperimentMutationHookResult = ReturnType<typeof useDuplicateExperimentMutation>;
export type DuplicateExperimentMutationResult = Apollo.MutationResult<DuplicateExperimentMutation>;
export type DuplicateExperimentMutationOptions = Apollo.BaseMutationOptions<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>;
export const CreateExperimentDocument = gql`
    mutation createExperiment($input: CreateExperimentInput!) {
  createExperiment(input: $input) {
    id
  }
}
    `;
export type CreateExperimentMutationFn = Apollo.MutationFunction<CreateExperimentMutation, CreateExperimentMutationVariables>;

/**
 * __useCreateExperimentMutation__
 *
 * To run a mutation, you first call `useCreateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExperimentMutation, { data, loading, error }] = useCreateExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExperimentMutation(baseOptions?: Apollo.MutationHookOptions<CreateExperimentMutation, CreateExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExperimentMutation, CreateExperimentMutationVariables>(CreateExperimentDocument, options);
      }
export type CreateExperimentMutationHookResult = ReturnType<typeof useCreateExperimentMutation>;
export type CreateExperimentMutationResult = Apollo.MutationResult<CreateExperimentMutation>;
export type CreateExperimentMutationOptions = Apollo.BaseMutationOptions<CreateExperimentMutation, CreateExperimentMutationVariables>;
export const UpdateExperimentDocument = gql`
    mutation updateExperiment($input: UpdateExperimentInput!) {
  updateExperiment(input: $input) {
    ...ExperimentDetails
  }
}
    ${ExperimentDetailsFragmentDoc}`;
export type UpdateExperimentMutationFn = Apollo.MutationFunction<UpdateExperimentMutation, UpdateExperimentMutationVariables>;

/**
 * __useUpdateExperimentMutation__
 *
 * To run a mutation, you first call `useUpdateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperimentMutation, { data, loading, error }] = useUpdateExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExperimentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExperimentMutation, UpdateExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExperimentMutation, UpdateExperimentMutationVariables>(UpdateExperimentDocument, options);
      }
export type UpdateExperimentMutationHookResult = ReturnType<typeof useUpdateExperimentMutation>;
export type UpdateExperimentMutationResult = Apollo.MutationResult<UpdateExperimentMutation>;
export type UpdateExperimentMutationOptions = Apollo.BaseMutationOptions<UpdateExperimentMutation, UpdateExperimentMutationVariables>;
export const DeleteExperimentDocument = gql`
    mutation deleteExperiment($id: Int!) {
  removeExperiment(id: $id)
}
    `;
export type DeleteExperimentMutationFn = Apollo.MutationFunction<DeleteExperimentMutation, DeleteExperimentMutationVariables>;

/**
 * __useDeleteExperimentMutation__
 *
 * To run a mutation, you first call `useDeleteExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperimentMutation, { data, loading, error }] = useDeleteExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExperimentMutation, DeleteExperimentMutationVariables>(DeleteExperimentDocument, options);
      }
export type DeleteExperimentMutationHookResult = ReturnType<typeof useDeleteExperimentMutation>;
export type DeleteExperimentMutationResult = Apollo.MutationResult<DeleteExperimentMutation>;
export type DeleteExperimentMutationOptions = Apollo.BaseMutationOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>;
export const CreateOtherMoleculeDocument = gql`
    mutation createOtherMolecule($input: CreateOtherMoleculeInput!) {
  createOtherMolecule(input: $input) {
    ...OtherMoleculeDetails
  }
}
    ${OtherMoleculeDetailsFragmentDoc}`;
export type CreateOtherMoleculeMutationFn = Apollo.MutationFunction<CreateOtherMoleculeMutation, CreateOtherMoleculeMutationVariables>;

/**
 * __useCreateOtherMoleculeMutation__
 *
 * To run a mutation, you first call `useCreateOtherMoleculeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtherMoleculeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtherMoleculeMutation, { data, loading, error }] = useCreateOtherMoleculeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOtherMoleculeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOtherMoleculeMutation, CreateOtherMoleculeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOtherMoleculeMutation, CreateOtherMoleculeMutationVariables>(CreateOtherMoleculeDocument, options);
      }
export type CreateOtherMoleculeMutationHookResult = ReturnType<typeof useCreateOtherMoleculeMutation>;
export type CreateOtherMoleculeMutationResult = Apollo.MutationResult<CreateOtherMoleculeMutation>;
export type CreateOtherMoleculeMutationOptions = Apollo.BaseMutationOptions<CreateOtherMoleculeMutation, CreateOtherMoleculeMutationVariables>;
export const UpdateOtherMoleculeDocument = gql`
    mutation updateOtherMolecule($input: UpdateOtherMoleculeInput!) {
  updateOtherMolecule(input: $input) {
    ...OtherMoleculeDetails
  }
}
    ${OtherMoleculeDetailsFragmentDoc}`;
export type UpdateOtherMoleculeMutationFn = Apollo.MutationFunction<UpdateOtherMoleculeMutation, UpdateOtherMoleculeMutationVariables>;

/**
 * __useUpdateOtherMoleculeMutation__
 *
 * To run a mutation, you first call `useUpdateOtherMoleculeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOtherMoleculeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOtherMoleculeMutation, { data, loading, error }] = useUpdateOtherMoleculeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOtherMoleculeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOtherMoleculeMutation, UpdateOtherMoleculeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOtherMoleculeMutation, UpdateOtherMoleculeMutationVariables>(UpdateOtherMoleculeDocument, options);
      }
export type UpdateOtherMoleculeMutationHookResult = ReturnType<typeof useUpdateOtherMoleculeMutation>;
export type UpdateOtherMoleculeMutationResult = Apollo.MutationResult<UpdateOtherMoleculeMutation>;
export type UpdateOtherMoleculeMutationOptions = Apollo.BaseMutationOptions<UpdateOtherMoleculeMutation, UpdateOtherMoleculeMutationVariables>;
export const DeleteOtherMoleculeDocument = gql`
    mutation deleteOtherMolecule($id: Int!) {
  deleteOtherMolecule(id: $id)
}
    `;
export type DeleteOtherMoleculeMutationFn = Apollo.MutationFunction<DeleteOtherMoleculeMutation, DeleteOtherMoleculeMutationVariables>;

/**
 * __useDeleteOtherMoleculeMutation__
 *
 * To run a mutation, you first call `useDeleteOtherMoleculeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOtherMoleculeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOtherMoleculeMutation, { data, loading, error }] = useDeleteOtherMoleculeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOtherMoleculeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOtherMoleculeMutation, DeleteOtherMoleculeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOtherMoleculeMutation, DeleteOtherMoleculeMutationVariables>(DeleteOtherMoleculeDocument, options);
      }
export type DeleteOtherMoleculeMutationHookResult = ReturnType<typeof useDeleteOtherMoleculeMutation>;
export type DeleteOtherMoleculeMutationResult = Apollo.MutationResult<DeleteOtherMoleculeMutation>;
export type DeleteOtherMoleculeMutationOptions = Apollo.BaseMutationOptions<DeleteOtherMoleculeMutation, DeleteOtherMoleculeMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RemoveModelDocument = gql`
    mutation RemoveModel($id: Int!) {
  removeModel(id: $id) {
    ...Model
  }
}
    ${ModelFragmentDoc}`;
export type RemoveModelMutationFn = Apollo.MutationFunction<RemoveModelMutation, RemoveModelMutationVariables>;

/**
 * __useRemoveModelMutation__
 *
 * To run a mutation, you first call `useRemoveModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeModelMutation, { data, loading, error }] = useRemoveModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveModelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveModelMutation, RemoveModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveModelMutation, RemoveModelMutationVariables>(RemoveModelDocument, options);
      }
export type RemoveModelMutationHookResult = ReturnType<typeof useRemoveModelMutation>;
export type RemoveModelMutationResult = Apollo.MutationResult<RemoveModelMutation>;
export type RemoveModelMutationOptions = Apollo.BaseMutationOptions<RemoveModelMutation, RemoveModelMutationVariables>;
export const DeleteTreatmentGroupDocument = gql`
    mutation deleteTreatmentGroup($id: Int!) {
  removeTreatmentGroup(id: $id) {
    ...TreatmentGroup
  }
}
    ${TreatmentGroupFragmentDoc}`;
export type DeleteTreatmentGroupMutationFn = Apollo.MutationFunction<DeleteTreatmentGroupMutation, DeleteTreatmentGroupMutationVariables>;

/**
 * __useDeleteTreatmentGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTreatmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTreatmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTreatmentGroupMutation, { data, loading, error }] = useDeleteTreatmentGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTreatmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTreatmentGroupMutation, DeleteTreatmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTreatmentGroupMutation, DeleteTreatmentGroupMutationVariables>(DeleteTreatmentGroupDocument, options);
      }
export type DeleteTreatmentGroupMutationHookResult = ReturnType<typeof useDeleteTreatmentGroupMutation>;
export type DeleteTreatmentGroupMutationResult = Apollo.MutationResult<DeleteTreatmentGroupMutation>;
export type DeleteTreatmentGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTreatmentGroupMutation, DeleteTreatmentGroupMutationVariables>;
export const DuplicateTreatmentGroupDocument = gql`
    mutation duplicateTreatmentGroup($id: Int!) {
  duplicateTreatmentGroup(id: $id) {
    ...TreatmentGroup
  }
}
    ${TreatmentGroupFragmentDoc}`;
export type DuplicateTreatmentGroupMutationFn = Apollo.MutationFunction<DuplicateTreatmentGroupMutation, DuplicateTreatmentGroupMutationVariables>;

/**
 * __useDuplicateTreatmentGroupMutation__
 *
 * To run a mutation, you first call `useDuplicateTreatmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTreatmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTreatmentGroupMutation, { data, loading, error }] = useDuplicateTreatmentGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateTreatmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateTreatmentGroupMutation, DuplicateTreatmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateTreatmentGroupMutation, DuplicateTreatmentGroupMutationVariables>(DuplicateTreatmentGroupDocument, options);
      }
export type DuplicateTreatmentGroupMutationHookResult = ReturnType<typeof useDuplicateTreatmentGroupMutation>;
export type DuplicateTreatmentGroupMutationResult = Apollo.MutationResult<DuplicateTreatmentGroupMutation>;
export type DuplicateTreatmentGroupMutationOptions = Apollo.BaseMutationOptions<DuplicateTreatmentGroupMutation, DuplicateTreatmentGroupMutationVariables>;
export const UpdateTreatmentGroupDocument = gql`
    mutation updateTreatmentGroup($input: UpdateTreatmentGroupInput!) {
  updateTreatmentGroup(input: $input) {
    ...TreatmentGroup
  }
}
    ${TreatmentGroupFragmentDoc}`;
export type UpdateTreatmentGroupMutationFn = Apollo.MutationFunction<UpdateTreatmentGroupMutation, UpdateTreatmentGroupMutationVariables>;

/**
 * __useUpdateTreatmentGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTreatmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTreatmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTreatmentGroupMutation, { data, loading, error }] = useUpdateTreatmentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTreatmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTreatmentGroupMutation, UpdateTreatmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTreatmentGroupMutation, UpdateTreatmentGroupMutationVariables>(UpdateTreatmentGroupDocument, options);
      }
export type UpdateTreatmentGroupMutationHookResult = ReturnType<typeof useUpdateTreatmentGroupMutation>;
export type UpdateTreatmentGroupMutationResult = Apollo.MutationResult<UpdateTreatmentGroupMutation>;
export type UpdateTreatmentGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTreatmentGroupMutation, UpdateTreatmentGroupMutationVariables>;
export const AddTreatmentGroupDocument = gql`
    mutation addTreatmentGroup($input: AddTreatmentGroupInput!) {
  addTreatmentGroupToExperiment(input: $input) {
    ...TreatmentGroup
  }
}
    ${TreatmentGroupFragmentDoc}`;
export type AddTreatmentGroupMutationFn = Apollo.MutationFunction<AddTreatmentGroupMutation, AddTreatmentGroupMutationVariables>;

/**
 * __useAddTreatmentGroupMutation__
 *
 * To run a mutation, you first call `useAddTreatmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTreatmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTreatmentGroupMutation, { data, loading, error }] = useAddTreatmentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTreatmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddTreatmentGroupMutation, AddTreatmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTreatmentGroupMutation, AddTreatmentGroupMutationVariables>(AddTreatmentGroupDocument, options);
      }
export type AddTreatmentGroupMutationHookResult = ReturnType<typeof useAddTreatmentGroupMutation>;
export type AddTreatmentGroupMutationResult = Apollo.MutationResult<AddTreatmentGroupMutation>;
export type AddTreatmentGroupMutationOptions = Apollo.BaseMutationOptions<AddTreatmentGroupMutation, AddTreatmentGroupMutationVariables>;
export const PopulateTreatmentGroupsDocument = gql`
    mutation populateTreatmentGroups($experimentId: Int!) {
  populateTreatmentGroups(experimentId: $experimentId) {
    ...TreatmentGroup
  }
}
    ${TreatmentGroupFragmentDoc}`;
export type PopulateTreatmentGroupsMutationFn = Apollo.MutationFunction<PopulateTreatmentGroupsMutation, PopulateTreatmentGroupsMutationVariables>;

/**
 * __usePopulateTreatmentGroupsMutation__
 *
 * To run a mutation, you first call `usePopulateTreatmentGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateTreatmentGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateTreatmentGroupsMutation, { data, loading, error }] = usePopulateTreatmentGroupsMutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function usePopulateTreatmentGroupsMutation(baseOptions?: Apollo.MutationHookOptions<PopulateTreatmentGroupsMutation, PopulateTreatmentGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PopulateTreatmentGroupsMutation, PopulateTreatmentGroupsMutationVariables>(PopulateTreatmentGroupsDocument, options);
      }
export type PopulateTreatmentGroupsMutationHookResult = ReturnType<typeof usePopulateTreatmentGroupsMutation>;
export type PopulateTreatmentGroupsMutationResult = Apollo.MutationResult<PopulateTreatmentGroupsMutation>;
export type PopulateTreatmentGroupsMutationOptions = Apollo.BaseMutationOptions<PopulateTreatmentGroupsMutation, PopulateTreatmentGroupsMutationVariables>;
export const UpdateTreatmentGroupIndexDocument = gql`
    mutation updateTreatmentGroupIndex($input: TreatmentGroupIndexInput!) {
  updateTreatmentGroupIndex(input: $input) {
    ...TreatmentGroup
  }
}
    ${TreatmentGroupFragmentDoc}`;
export type UpdateTreatmentGroupIndexMutationFn = Apollo.MutationFunction<UpdateTreatmentGroupIndexMutation, UpdateTreatmentGroupIndexMutationVariables>;

/**
 * __useUpdateTreatmentGroupIndexMutation__
 *
 * To run a mutation, you first call `useUpdateTreatmentGroupIndexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTreatmentGroupIndexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTreatmentGroupIndexMutation, { data, loading, error }] = useUpdateTreatmentGroupIndexMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTreatmentGroupIndexMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTreatmentGroupIndexMutation, UpdateTreatmentGroupIndexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTreatmentGroupIndexMutation, UpdateTreatmentGroupIndexMutationVariables>(UpdateTreatmentGroupIndexDocument, options);
      }
export type UpdateTreatmentGroupIndexMutationHookResult = ReturnType<typeof useUpdateTreatmentGroupIndexMutation>;
export type UpdateTreatmentGroupIndexMutationResult = Apollo.MutationResult<UpdateTreatmentGroupIndexMutation>;
export type UpdateTreatmentGroupIndexMutationOptions = Apollo.BaseMutationOptions<UpdateTreatmentGroupIndexMutation, UpdateTreatmentGroupIndexMutationVariables>;
export const DeleteTreatmentFromExperimentDocument = gql`
    mutation deleteTreatmentFromExperiment($id: Int!) {
  removeTreatment(id: $id) {
    treatments {
      ...Treatment
    }
    treatmentGroups {
      ...TreatmentGroup
    }
  }
}
    ${TreatmentFragmentDoc}
${TreatmentGroupFragmentDoc}`;
export type DeleteTreatmentFromExperimentMutationFn = Apollo.MutationFunction<DeleteTreatmentFromExperimentMutation, DeleteTreatmentFromExperimentMutationVariables>;

/**
 * __useDeleteTreatmentFromExperimentMutation__
 *
 * To run a mutation, you first call `useDeleteTreatmentFromExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTreatmentFromExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTreatmentFromExperimentMutation, { data, loading, error }] = useDeleteTreatmentFromExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTreatmentFromExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTreatmentFromExperimentMutation, DeleteTreatmentFromExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTreatmentFromExperimentMutation, DeleteTreatmentFromExperimentMutationVariables>(DeleteTreatmentFromExperimentDocument, options);
      }
export type DeleteTreatmentFromExperimentMutationHookResult = ReturnType<typeof useDeleteTreatmentFromExperimentMutation>;
export type DeleteTreatmentFromExperimentMutationResult = Apollo.MutationResult<DeleteTreatmentFromExperimentMutation>;
export type DeleteTreatmentFromExperimentMutationOptions = Apollo.BaseMutationOptions<DeleteTreatmentFromExperimentMutation, DeleteTreatmentFromExperimentMutationVariables>;
export const SetListContentCategoryDocument = gql`
    mutation setListContentCategory($input: ListContentCategoryInput!) {
  setListContentCategory(input: $input)
}
    `;
export type SetListContentCategoryMutationFn = Apollo.MutationFunction<SetListContentCategoryMutation, SetListContentCategoryMutationVariables>;

/**
 * __useSetListContentCategoryMutation__
 *
 * To run a mutation, you first call `useSetListContentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetListContentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setListContentCategoryMutation, { data, loading, error }] = useSetListContentCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetListContentCategoryMutation(baseOptions?: Apollo.MutationHookOptions<SetListContentCategoryMutation, SetListContentCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetListContentCategoryMutation, SetListContentCategoryMutationVariables>(SetListContentCategoryDocument, options);
      }
export type SetListContentCategoryMutationHookResult = ReturnType<typeof useSetListContentCategoryMutation>;
export type SetListContentCategoryMutationResult = Apollo.MutationResult<SetListContentCategoryMutation>;
export type SetListContentCategoryMutationOptions = Apollo.BaseMutationOptions<SetListContentCategoryMutation, SetListContentCategoryMutationVariables>;
export const ExperimentAttachmentsDocument = gql`
    query ExperimentAttachments($experimentId: Int!, $category: String!) {
  experimentAttachments(experimentId: $experimentId, category: $category) {
    ...AttachmentDetails
  }
}
    ${AttachmentDetailsFragmentDoc}`;

/**
 * __useExperimentAttachmentsQuery__
 *
 * To run a query within a React component, call `useExperimentAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentAttachmentsQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useExperimentAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<ExperimentAttachmentsQuery, ExperimentAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentAttachmentsQuery, ExperimentAttachmentsQueryVariables>(ExperimentAttachmentsDocument, options);
      }
export function useExperimentAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentAttachmentsQuery, ExperimentAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentAttachmentsQuery, ExperimentAttachmentsQueryVariables>(ExperimentAttachmentsDocument, options);
        }
export type ExperimentAttachmentsQueryHookResult = ReturnType<typeof useExperimentAttachmentsQuery>;
export type ExperimentAttachmentsLazyQueryHookResult = ReturnType<typeof useExperimentAttachmentsLazyQuery>;
export type ExperimentAttachmentsQueryResult = Apollo.QueryResult<ExperimentAttachmentsQuery, ExperimentAttachmentsQueryVariables>;
export const ExperimentOrdersDocument = gql`
    query ExperimentOrders($experimentId: Int!) {
  experimentOrders(experimentId: $experimentId) {
    ...OrdersDetails
  }
}
    ${OrdersDetailsFragmentDoc}`;

/**
 * __useExperimentOrdersQuery__
 *
 * To run a query within a React component, call `useExperimentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentOrdersQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useExperimentOrdersQuery(baseOptions: Apollo.QueryHookOptions<ExperimentOrdersQuery, ExperimentOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentOrdersQuery, ExperimentOrdersQueryVariables>(ExperimentOrdersDocument, options);
      }
export function useExperimentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentOrdersQuery, ExperimentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentOrdersQuery, ExperimentOrdersQueryVariables>(ExperimentOrdersDocument, options);
        }
export type ExperimentOrdersQueryHookResult = ReturnType<typeof useExperimentOrdersQuery>;
export type ExperimentOrdersLazyQueryHookResult = ReturnType<typeof useExperimentOrdersLazyQuery>;
export type ExperimentOrdersQueryResult = Apollo.QueryResult<ExperimentOrdersQuery, ExperimentOrdersQueryVariables>;
export const AdcOrdersDocument = gql`
    query AdcOrders($limit: Int!, $offset: Int, $status: OrderStatus, $query: String) {
  adcOrders(limit: $limit, offset: $offset, status: $status, query: $query) {
    items {
      ...AdcOrderWithExperiment
    }
    totalCount
  }
}
    ${AdcOrderWithExperimentFragmentDoc}`;

/**
 * __useAdcOrdersQuery__
 *
 * To run a query within a React component, call `useAdcOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdcOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdcOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAdcOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdcOrdersQuery, AdcOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdcOrdersQuery, AdcOrdersQueryVariables>(AdcOrdersDocument, options);
      }
export function useAdcOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdcOrdersQuery, AdcOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdcOrdersQuery, AdcOrdersQueryVariables>(AdcOrdersDocument, options);
        }
export type AdcOrdersQueryHookResult = ReturnType<typeof useAdcOrdersQuery>;
export type AdcOrdersLazyQueryHookResult = ReturnType<typeof useAdcOrdersLazyQuery>;
export type AdcOrdersQueryResult = Apollo.QueryResult<AdcOrdersQuery, AdcOrdersQueryVariables>;
export const SyncExperimentOrdersDocument = gql`
    mutation SyncExperimentOrders($experimentId: Int!) {
  syncExperimentOrders(experimentId: $experimentId) {
    ...OrdersDetails
  }
}
    ${OrdersDetailsFragmentDoc}`;
export type SyncExperimentOrdersMutationFn = Apollo.MutationFunction<SyncExperimentOrdersMutation, SyncExperimentOrdersMutationVariables>;

/**
 * __useSyncExperimentOrdersMutation__
 *
 * To run a mutation, you first call `useSyncExperimentOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncExperimentOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncExperimentOrdersMutation, { data, loading, error }] = useSyncExperimentOrdersMutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useSyncExperimentOrdersMutation(baseOptions?: Apollo.MutationHookOptions<SyncExperimentOrdersMutation, SyncExperimentOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncExperimentOrdersMutation, SyncExperimentOrdersMutationVariables>(SyncExperimentOrdersDocument, options);
      }
export type SyncExperimentOrdersMutationHookResult = ReturnType<typeof useSyncExperimentOrdersMutation>;
export type SyncExperimentOrdersMutationResult = Apollo.MutationResult<SyncExperimentOrdersMutation>;
export type SyncExperimentOrdersMutationOptions = Apollo.BaseMutationOptions<SyncExperimentOrdersMutation, SyncExperimentOrdersMutationVariables>;
export const UpdateAnimalOrderItemDocument = gql`
    mutation UpdateAnimalOrderItem($input: AnimalOrderItemInput!) {
  updateAnimalOrderItem(input: $input) {
    ...AnimalOrderItemDetails
  }
}
    ${AnimalOrderItemDetailsFragmentDoc}`;
export type UpdateAnimalOrderItemMutationFn = Apollo.MutationFunction<UpdateAnimalOrderItemMutation, UpdateAnimalOrderItemMutationVariables>;

/**
 * __useUpdateAnimalOrderItemMutation__
 *
 * To run a mutation, you first call `useUpdateAnimalOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnimalOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnimalOrderItemMutation, { data, loading, error }] = useUpdateAnimalOrderItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnimalOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnimalOrderItemMutation, UpdateAnimalOrderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnimalOrderItemMutation, UpdateAnimalOrderItemMutationVariables>(UpdateAnimalOrderItemDocument, options);
      }
export type UpdateAnimalOrderItemMutationHookResult = ReturnType<typeof useUpdateAnimalOrderItemMutation>;
export type UpdateAnimalOrderItemMutationResult = Apollo.MutationResult<UpdateAnimalOrderItemMutation>;
export type UpdateAnimalOrderItemMutationOptions = Apollo.BaseMutationOptions<UpdateAnimalOrderItemMutation, UpdateAnimalOrderItemMutationVariables>;
export const UpdateAdcOrderDocument = gql`
    mutation UpdateAdcOrder($input: AdcOrderInput!) {
  updateAdcOrder(input: $input) {
    ...AdcOrderDetails
  }
}
    ${AdcOrderDetailsFragmentDoc}`;
export type UpdateAdcOrderMutationFn = Apollo.MutationFunction<UpdateAdcOrderMutation, UpdateAdcOrderMutationVariables>;

/**
 * __useUpdateAdcOrderMutation__
 *
 * To run a mutation, you first call `useUpdateAdcOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdcOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdcOrderMutation, { data, loading, error }] = useUpdateAdcOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdcOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdcOrderMutation, UpdateAdcOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdcOrderMutation, UpdateAdcOrderMutationVariables>(UpdateAdcOrderDocument, options);
      }
export type UpdateAdcOrderMutationHookResult = ReturnType<typeof useUpdateAdcOrderMutation>;
export type UpdateAdcOrderMutationResult = Apollo.MutationResult<UpdateAdcOrderMutation>;
export type UpdateAdcOrderMutationOptions = Apollo.BaseMutationOptions<UpdateAdcOrderMutation, UpdateAdcOrderMutationVariables>;
export const UpdateAdcOrderItemDocument = gql`
    mutation UpdateAdcOrderItem($input: AdcOrderItemInput!) {
  updateAdcOrderItem(input: $input) {
    ...AdcOrderItemDetails
  }
}
    ${AdcOrderItemDetailsFragmentDoc}`;
export type UpdateAdcOrderItemMutationFn = Apollo.MutationFunction<UpdateAdcOrderItemMutation, UpdateAdcOrderItemMutationVariables>;

/**
 * __useUpdateAdcOrderItemMutation__
 *
 * To run a mutation, you first call `useUpdateAdcOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdcOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdcOrderItemMutation, { data, loading, error }] = useUpdateAdcOrderItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdcOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdcOrderItemMutation, UpdateAdcOrderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdcOrderItemMutation, UpdateAdcOrderItemMutationVariables>(UpdateAdcOrderItemDocument, options);
      }
export type UpdateAdcOrderItemMutationHookResult = ReturnType<typeof useUpdateAdcOrderItemMutation>;
export type UpdateAdcOrderItemMutationResult = Apollo.MutationResult<UpdateAdcOrderItemMutation>;
export type UpdateAdcOrderItemMutationOptions = Apollo.BaseMutationOptions<UpdateAdcOrderItemMutation, UpdateAdcOrderItemMutationVariables>;
export const UpdateNonAdcOrderItemDocument = gql`
    mutation UpdateNonAdcOrderItem($input: NonAdcOrderItemInput!) {
  updateNonAdcOrderItem(input: $input) {
    ...NonAdcOrderItemDetails
  }
}
    ${NonAdcOrderItemDetailsFragmentDoc}`;
export type UpdateNonAdcOrderItemMutationFn = Apollo.MutationFunction<UpdateNonAdcOrderItemMutation, UpdateNonAdcOrderItemMutationVariables>;

/**
 * __useUpdateNonAdcOrderItemMutation__
 *
 * To run a mutation, you first call `useUpdateNonAdcOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNonAdcOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNonAdcOrderItemMutation, { data, loading, error }] = useUpdateNonAdcOrderItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNonAdcOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNonAdcOrderItemMutation, UpdateNonAdcOrderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNonAdcOrderItemMutation, UpdateNonAdcOrderItemMutationVariables>(UpdateNonAdcOrderItemDocument, options);
      }
export type UpdateNonAdcOrderItemMutationHookResult = ReturnType<typeof useUpdateNonAdcOrderItemMutation>;
export type UpdateNonAdcOrderItemMutationResult = Apollo.MutationResult<UpdateNonAdcOrderItemMutation>;
export type UpdateNonAdcOrderItemMutationOptions = Apollo.BaseMutationOptions<UpdateNonAdcOrderItemMutation, UpdateNonAdcOrderItemMutationVariables>;
export const DeliverAdcOrderItemsDocument = gql`
    mutation DeliverAdcOrderItems($input: DeliverAdcOrderItemsInput!) {
  deliverAdcOrderItems(input: $input) {
    ...AdcOrderItemDetails
  }
}
    ${AdcOrderItemDetailsFragmentDoc}`;
export type DeliverAdcOrderItemsMutationFn = Apollo.MutationFunction<DeliverAdcOrderItemsMutation, DeliverAdcOrderItemsMutationVariables>;

/**
 * __useDeliverAdcOrderItemsMutation__
 *
 * To run a mutation, you first call `useDeliverAdcOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliverAdcOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliverAdcOrderItemsMutation, { data, loading, error }] = useDeliverAdcOrderItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliverAdcOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeliverAdcOrderItemsMutation, DeliverAdcOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliverAdcOrderItemsMutation, DeliverAdcOrderItemsMutationVariables>(DeliverAdcOrderItemsDocument, options);
      }
export type DeliverAdcOrderItemsMutationHookResult = ReturnType<typeof useDeliverAdcOrderItemsMutation>;
export type DeliverAdcOrderItemsMutationResult = Apollo.MutationResult<DeliverAdcOrderItemsMutation>;
export type DeliverAdcOrderItemsMutationOptions = Apollo.BaseMutationOptions<DeliverAdcOrderItemsMutation, DeliverAdcOrderItemsMutationVariables>;
export const ReturnAdcOrderItemsDocument = gql`
    mutation ReturnAdcOrderItems($input: DeliverAdcOrderItemsInput!) {
  returnAdcOrderItems(input: $input) {
    ...AdcOrderItemDetails
  }
}
    ${AdcOrderItemDetailsFragmentDoc}`;
export type ReturnAdcOrderItemsMutationFn = Apollo.MutationFunction<ReturnAdcOrderItemsMutation, ReturnAdcOrderItemsMutationVariables>;

/**
 * __useReturnAdcOrderItemsMutation__
 *
 * To run a mutation, you first call `useReturnAdcOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnAdcOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnAdcOrderItemsMutation, { data, loading, error }] = useReturnAdcOrderItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReturnAdcOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<ReturnAdcOrderItemsMutation, ReturnAdcOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnAdcOrderItemsMutation, ReturnAdcOrderItemsMutationVariables>(ReturnAdcOrderItemsDocument, options);
      }
export type ReturnAdcOrderItemsMutationHookResult = ReturnType<typeof useReturnAdcOrderItemsMutation>;
export type ReturnAdcOrderItemsMutationResult = Apollo.MutationResult<ReturnAdcOrderItemsMutation>;
export type ReturnAdcOrderItemsMutationOptions = Apollo.BaseMutationOptions<ReturnAdcOrderItemsMutation, ReturnAdcOrderItemsMutationVariables>;
export const WorksheetDocument = gql`
    query worksheet($id: Int!) {
  worksheet(id: $id) {
    ...Worksheet
  }
}
    ${WorksheetFragmentDoc}`;

/**
 * __useWorksheetQuery__
 *
 * To run a query within a React component, call `useWorksheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorksheetQuery(baseOptions: Apollo.QueryHookOptions<WorksheetQuery, WorksheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorksheetQuery, WorksheetQueryVariables>(WorksheetDocument, options);
      }
export function useWorksheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorksheetQuery, WorksheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorksheetQuery, WorksheetQueryVariables>(WorksheetDocument, options);
        }
export type WorksheetQueryHookResult = ReturnType<typeof useWorksheetQuery>;
export type WorksheetLazyQueryHookResult = ReturnType<typeof useWorksheetLazyQuery>;
export type WorksheetQueryResult = Apollo.QueryResult<WorksheetQuery, WorksheetQueryVariables>;
export const WorksheetsByExperimentDocument = gql`
    query worksheetsByExperiment($experimentId: Int!) {
  worksheetsByExperiment(experimentId: $experimentId) {
    items {
      ...Worksheet
    }
    totalCount
  }
}
    ${WorksheetFragmentDoc}`;

/**
 * __useWorksheetsByExperimentQuery__
 *
 * To run a query within a React component, call `useWorksheetsByExperimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetsByExperimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetsByExperimentQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useWorksheetsByExperimentQuery(baseOptions: Apollo.QueryHookOptions<WorksheetsByExperimentQuery, WorksheetsByExperimentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorksheetsByExperimentQuery, WorksheetsByExperimentQueryVariables>(WorksheetsByExperimentDocument, options);
      }
export function useWorksheetsByExperimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorksheetsByExperimentQuery, WorksheetsByExperimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorksheetsByExperimentQuery, WorksheetsByExperimentQueryVariables>(WorksheetsByExperimentDocument, options);
        }
export type WorksheetsByExperimentQueryHookResult = ReturnType<typeof useWorksheetsByExperimentQuery>;
export type WorksheetsByExperimentLazyQueryHookResult = ReturnType<typeof useWorksheetsByExperimentLazyQuery>;
export type WorksheetsByExperimentQueryResult = Apollo.QueryResult<WorksheetsByExperimentQuery, WorksheetsByExperimentQueryVariables>;
export const UpdateWorksheetStatusDocument = gql`
    mutation updateWorksheetStatus($input: UpdateWorksheetStatusInput!) {
  updateWorksheetStatus(input: $input) {
    ...Worksheet
  }
}
    ${WorksheetFragmentDoc}`;
export type UpdateWorksheetStatusMutationFn = Apollo.MutationFunction<UpdateWorksheetStatusMutation, UpdateWorksheetStatusMutationVariables>;

/**
 * __useUpdateWorksheetStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWorksheetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorksheetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorksheetStatusMutation, { data, loading, error }] = useUpdateWorksheetStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorksheetStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorksheetStatusMutation, UpdateWorksheetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorksheetStatusMutation, UpdateWorksheetStatusMutationVariables>(UpdateWorksheetStatusDocument, options);
      }
export type UpdateWorksheetStatusMutationHookResult = ReturnType<typeof useUpdateWorksheetStatusMutation>;
export type UpdateWorksheetStatusMutationResult = Apollo.MutationResult<UpdateWorksheetStatusMutation>;
export type UpdateWorksheetStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWorksheetStatusMutation, UpdateWorksheetStatusMutationVariables>;
export const WorksheetEntryDocument = gql`
    query worksheetEntry($id: Int!) {
  worksheetEntry(id: $id) {
    ...WorksheetEntry
  }
}
    ${WorksheetEntryFragmentDoc}`;

/**
 * __useWorksheetEntryQuery__
 *
 * To run a query within a React component, call `useWorksheetEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetEntryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorksheetEntryQuery(baseOptions: Apollo.QueryHookOptions<WorksheetEntryQuery, WorksheetEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorksheetEntryQuery, WorksheetEntryQueryVariables>(WorksheetEntryDocument, options);
      }
export function useWorksheetEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorksheetEntryQuery, WorksheetEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorksheetEntryQuery, WorksheetEntryQueryVariables>(WorksheetEntryDocument, options);
        }
export type WorksheetEntryQueryHookResult = ReturnType<typeof useWorksheetEntryQuery>;
export type WorksheetEntryLazyQueryHookResult = ReturnType<typeof useWorksheetEntryLazyQuery>;
export type WorksheetEntryQueryResult = Apollo.QueryResult<WorksheetEntryQuery, WorksheetEntryQueryVariables>;
export const WorksheetEntriesByWorksheetDocument = gql`
    query worksheetEntriesByWorksheet($worksheetId: Int!) {
  worksheetEntriesByWorksheet(worksheetId: $worksheetId) {
    items {
      ...WorksheetEntry
    }
    totalCount
  }
}
    ${WorksheetEntryFragmentDoc}`;

/**
 * __useWorksheetEntriesByWorksheetQuery__
 *
 * To run a query within a React component, call `useWorksheetEntriesByWorksheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetEntriesByWorksheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetEntriesByWorksheetQuery({
 *   variables: {
 *      worksheetId: // value for 'worksheetId'
 *   },
 * });
 */
export function useWorksheetEntriesByWorksheetQuery(baseOptions: Apollo.QueryHookOptions<WorksheetEntriesByWorksheetQuery, WorksheetEntriesByWorksheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorksheetEntriesByWorksheetQuery, WorksheetEntriesByWorksheetQueryVariables>(WorksheetEntriesByWorksheetDocument, options);
      }
export function useWorksheetEntriesByWorksheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorksheetEntriesByWorksheetQuery, WorksheetEntriesByWorksheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorksheetEntriesByWorksheetQuery, WorksheetEntriesByWorksheetQueryVariables>(WorksheetEntriesByWorksheetDocument, options);
        }
export type WorksheetEntriesByWorksheetQueryHookResult = ReturnType<typeof useWorksheetEntriesByWorksheetQuery>;
export type WorksheetEntriesByWorksheetLazyQueryHookResult = ReturnType<typeof useWorksheetEntriesByWorksheetLazyQuery>;
export type WorksheetEntriesByWorksheetQueryResult = Apollo.QueryResult<WorksheetEntriesByWorksheetQuery, WorksheetEntriesByWorksheetQueryVariables>;
export const CreateWorksheetEntryDocument = gql`
    mutation createWorksheetEntry($input: CreateWorksheetEntryInput!) {
  createWorksheetEntry(input: $input) {
    ...WorksheetEntry
  }
}
    ${WorksheetEntryFragmentDoc}`;
export type CreateWorksheetEntryMutationFn = Apollo.MutationFunction<CreateWorksheetEntryMutation, CreateWorksheetEntryMutationVariables>;

/**
 * __useCreateWorksheetEntryMutation__
 *
 * To run a mutation, you first call `useCreateWorksheetEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorksheetEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorksheetEntryMutation, { data, loading, error }] = useCreateWorksheetEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorksheetEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorksheetEntryMutation, CreateWorksheetEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorksheetEntryMutation, CreateWorksheetEntryMutationVariables>(CreateWorksheetEntryDocument, options);
      }
export type CreateWorksheetEntryMutationHookResult = ReturnType<typeof useCreateWorksheetEntryMutation>;
export type CreateWorksheetEntryMutationResult = Apollo.MutationResult<CreateWorksheetEntryMutation>;
export type CreateWorksheetEntryMutationOptions = Apollo.BaseMutationOptions<CreateWorksheetEntryMutation, CreateWorksheetEntryMutationVariables>;
export const BulkCreateWorksheetEntriesDocument = gql`
    mutation bulkCreateWorksheetEntries($input: BulkCreateWorksheetEntriesInput!) {
  bulkCreateWorksheetEntries(input: $input) {
    items {
      ...WorksheetEntry
    }
    totalCount
  }
}
    ${WorksheetEntryFragmentDoc}`;
export type BulkCreateWorksheetEntriesMutationFn = Apollo.MutationFunction<BulkCreateWorksheetEntriesMutation, BulkCreateWorksheetEntriesMutationVariables>;

/**
 * __useBulkCreateWorksheetEntriesMutation__
 *
 * To run a mutation, you first call `useBulkCreateWorksheetEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateWorksheetEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateWorksheetEntriesMutation, { data, loading, error }] = useBulkCreateWorksheetEntriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateWorksheetEntriesMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateWorksheetEntriesMutation, BulkCreateWorksheetEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateWorksheetEntriesMutation, BulkCreateWorksheetEntriesMutationVariables>(BulkCreateWorksheetEntriesDocument, options);
      }
export type BulkCreateWorksheetEntriesMutationHookResult = ReturnType<typeof useBulkCreateWorksheetEntriesMutation>;
export type BulkCreateWorksheetEntriesMutationResult = Apollo.MutationResult<BulkCreateWorksheetEntriesMutation>;
export type BulkCreateWorksheetEntriesMutationOptions = Apollo.BaseMutationOptions<BulkCreateWorksheetEntriesMutation, BulkCreateWorksheetEntriesMutationVariables>;
export const DeleteWorksheetEntryDocument = gql`
    mutation deleteWorksheetEntry($input: DeleteWorksheetEntryInput!) {
  deleteWorksheetEntry(input: $input) {
    id
  }
}
    `;
export type DeleteWorksheetEntryMutationFn = Apollo.MutationFunction<DeleteWorksheetEntryMutation, DeleteWorksheetEntryMutationVariables>;

/**
 * __useDeleteWorksheetEntryMutation__
 *
 * To run a mutation, you first call `useDeleteWorksheetEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorksheetEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorksheetEntryMutation, { data, loading, error }] = useDeleteWorksheetEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorksheetEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorksheetEntryMutation, DeleteWorksheetEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorksheetEntryMutation, DeleteWorksheetEntryMutationVariables>(DeleteWorksheetEntryDocument, options);
      }
export type DeleteWorksheetEntryMutationHookResult = ReturnType<typeof useDeleteWorksheetEntryMutation>;
export type DeleteWorksheetEntryMutationResult = Apollo.MutationResult<DeleteWorksheetEntryMutation>;
export type DeleteWorksheetEntryMutationOptions = Apollo.BaseMutationOptions<DeleteWorksheetEntryMutation, DeleteWorksheetEntryMutationVariables>;
export const BulkDeleteWorksheetEntriesDocument = gql`
    mutation bulkDeleteWorksheetEntries($input: BulkDeleteWorksheetEntriesInput!) {
  bulkDeleteWorksheetEntries(input: $input) {
    items {
      ...WorksheetEntry
    }
    totalCount
  }
}
    ${WorksheetEntryFragmentDoc}`;
export type BulkDeleteWorksheetEntriesMutationFn = Apollo.MutationFunction<BulkDeleteWorksheetEntriesMutation, BulkDeleteWorksheetEntriesMutationVariables>;

/**
 * __useBulkDeleteWorksheetEntriesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteWorksheetEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteWorksheetEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteWorksheetEntriesMutation, { data, loading, error }] = useBulkDeleteWorksheetEntriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDeleteWorksheetEntriesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteWorksheetEntriesMutation, BulkDeleteWorksheetEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteWorksheetEntriesMutation, BulkDeleteWorksheetEntriesMutationVariables>(BulkDeleteWorksheetEntriesDocument, options);
      }
export type BulkDeleteWorksheetEntriesMutationHookResult = ReturnType<typeof useBulkDeleteWorksheetEntriesMutation>;
export type BulkDeleteWorksheetEntriesMutationResult = Apollo.MutationResult<BulkDeleteWorksheetEntriesMutation>;
export type BulkDeleteWorksheetEntriesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteWorksheetEntriesMutation, BulkDeleteWorksheetEntriesMutationVariables>;
export const UpdateWorksheetEntryDataValuesDocument = gql`
    mutation updateWorksheetEntryDataValues($input: UpdateWorksheetEntryDataValuesInput!) {
  updateWorksheetEntryDataValues(input: $input) {
    ...WorksheetEntry
  }
}
    ${WorksheetEntryFragmentDoc}`;
export type UpdateWorksheetEntryDataValuesMutationFn = Apollo.MutationFunction<UpdateWorksheetEntryDataValuesMutation, UpdateWorksheetEntryDataValuesMutationVariables>;

/**
 * __useUpdateWorksheetEntryDataValuesMutation__
 *
 * To run a mutation, you first call `useUpdateWorksheetEntryDataValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorksheetEntryDataValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorksheetEntryDataValuesMutation, { data, loading, error }] = useUpdateWorksheetEntryDataValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorksheetEntryDataValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorksheetEntryDataValuesMutation, UpdateWorksheetEntryDataValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorksheetEntryDataValuesMutation, UpdateWorksheetEntryDataValuesMutationVariables>(UpdateWorksheetEntryDataValuesDocument, options);
      }
export type UpdateWorksheetEntryDataValuesMutationHookResult = ReturnType<typeof useUpdateWorksheetEntryDataValuesMutation>;
export type UpdateWorksheetEntryDataValuesMutationResult = Apollo.MutationResult<UpdateWorksheetEntryDataValuesMutation>;
export type UpdateWorksheetEntryDataValuesMutationOptions = Apollo.BaseMutationOptions<UpdateWorksheetEntryDataValuesMutation, UpdateWorksheetEntryDataValuesMutationVariables>;
export const InitWorksheetEntriesDocument = gql`
    mutation initWorksheetEntries($input: [CreateWorksheetEntryInput!]!) {
  initWorksheetEntries(input: $input)
}
    `;
export type InitWorksheetEntriesMutationFn = Apollo.MutationFunction<InitWorksheetEntriesMutation, InitWorksheetEntriesMutationVariables>;

/**
 * __useInitWorksheetEntriesMutation__
 *
 * To run a mutation, you first call `useInitWorksheetEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitWorksheetEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initWorksheetEntriesMutation, { data, loading, error }] = useInitWorksheetEntriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitWorksheetEntriesMutation(baseOptions?: Apollo.MutationHookOptions<InitWorksheetEntriesMutation, InitWorksheetEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitWorksheetEntriesMutation, InitWorksheetEntriesMutationVariables>(InitWorksheetEntriesDocument, options);
      }
export type InitWorksheetEntriesMutationHookResult = ReturnType<typeof useInitWorksheetEntriesMutation>;
export type InitWorksheetEntriesMutationResult = Apollo.MutationResult<InitWorksheetEntriesMutation>;
export type InitWorksheetEntriesMutationOptions = Apollo.BaseMutationOptions<InitWorksheetEntriesMutation, InitWorksheetEntriesMutationVariables>;
export const InventoryRequirementsDocument = gql`
    query InventoryRequirements($limit: Int!, $offset: Int, $query: String, $filter: PaginationFilter, $sort: [PaginationSort!], $statuses: [ExperimentState!]) {
  experiments(
    limit: $limit
    offset: $offset
    query: $query
    sort: $sort
    filter: $filter
    statuses: $statuses
  ) {
    items {
      ...ExperimentForInventoryRequirements
    }
    totalCount
  }
}
    ${ExperimentForInventoryRequirementsFragmentDoc}`;

/**
 * __useInventoryRequirementsQuery__
 *
 * To run a query within a React component, call `useInventoryRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryRequirementsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useInventoryRequirementsQuery(baseOptions: Apollo.QueryHookOptions<InventoryRequirementsQuery, InventoryRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryRequirementsQuery, InventoryRequirementsQueryVariables>(InventoryRequirementsDocument, options);
      }
export function useInventoryRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryRequirementsQuery, InventoryRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryRequirementsQuery, InventoryRequirementsQueryVariables>(InventoryRequirementsDocument, options);
        }
export type InventoryRequirementsQueryHookResult = ReturnType<typeof useInventoryRequirementsQuery>;
export type InventoryRequirementsLazyQueryHookResult = ReturnType<typeof useInventoryRequirementsLazyQuery>;
export type InventoryRequirementsQueryResult = Apollo.QueryResult<InventoryRequirementsQuery, InventoryRequirementsQueryVariables>;
export const InventoryDocument = gql`
    query Inventory($id: Int!) {
  inventory(id: $id) {
    ...Inventory
  }
}
    ${InventoryFragmentDoc}`;

/**
 * __useInventoryQuery__
 *
 * To run a query within a React component, call `useInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventoryQuery(baseOptions: Apollo.QueryHookOptions<InventoryQuery, InventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryQuery, InventoryQueryVariables>(InventoryDocument, options);
      }
export function useInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryQuery, InventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryQuery, InventoryQueryVariables>(InventoryDocument, options);
        }
export type InventoryQueryHookResult = ReturnType<typeof useInventoryQuery>;
export type InventoryLazyQueryHookResult = ReturnType<typeof useInventoryLazyQuery>;
export type InventoryQueryResult = Apollo.QueryResult<InventoryQuery, InventoryQueryVariables>;
export const ListInventoryDocument = gql`
    query ListInventory($limit: Int!, $offset: Int, $filters: InventoryFilters, $filter: PaginationFilter, $sort: [PaginationSort!], $query: String) {
  listInventory(
    limit: $limit
    offset: $offset
    filters: $filters
    filter: $filter
    sort: $sort
    query: $query
  ) {
    items {
      ...InventorySummary
    }
    totalCount
  }
}
    ${InventorySummaryFragmentDoc}`;

/**
 * __useListInventoryQuery__
 *
 * To run a query within a React component, call `useListInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInventoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useListInventoryQuery(baseOptions: Apollo.QueryHookOptions<ListInventoryQuery, ListInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInventoryQuery, ListInventoryQueryVariables>(ListInventoryDocument, options);
      }
export function useListInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInventoryQuery, ListInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInventoryQuery, ListInventoryQueryVariables>(ListInventoryDocument, options);
        }
export type ListInventoryQueryHookResult = ReturnType<typeof useListInventoryQuery>;
export type ListInventoryLazyQueryHookResult = ReturnType<typeof useListInventoryLazyQuery>;
export type ListInventoryQueryResult = Apollo.QueryResult<ListInventoryQuery, ListInventoryQueryVariables>;
export const InventoryRequestDocument = gql`
    query InventoryRequest($id: Int!) {
  inventoryRequest(id: $id) {
    ...InventoryRequest
  }
}
    ${InventoryRequestFragmentDoc}`;

/**
 * __useInventoryRequestQuery__
 *
 * To run a query within a React component, call `useInventoryRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventoryRequestQuery(baseOptions: Apollo.QueryHookOptions<InventoryRequestQuery, InventoryRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryRequestQuery, InventoryRequestQueryVariables>(InventoryRequestDocument, options);
      }
export function useInventoryRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryRequestQuery, InventoryRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryRequestQuery, InventoryRequestQueryVariables>(InventoryRequestDocument, options);
        }
export type InventoryRequestQueryHookResult = ReturnType<typeof useInventoryRequestQuery>;
export type InventoryRequestLazyQueryHookResult = ReturnType<typeof useInventoryRequestLazyQuery>;
export type InventoryRequestQueryResult = Apollo.QueryResult<InventoryRequestQuery, InventoryRequestQueryVariables>;
export const ListInventoryRequestsDocument = gql`
    query ListInventoryRequests($limit: Int!, $offset: Int, $filters: InventoryRequestFilters, $filter: PaginationFilter, $sort: [PaginationSort!], $query: String) {
  listInventoryRequests(
    filters: $filters
    filter: $filter
    sort: $sort
    limit: $limit
    offset: $offset
    query: $query
  ) {
    items {
      ...InventoryRequest
    }
    totalCount
  }
}
    ${InventoryRequestFragmentDoc}`;

/**
 * __useListInventoryRequestsQuery__
 *
 * To run a query within a React component, call `useListInventoryRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInventoryRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInventoryRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useListInventoryRequestsQuery(baseOptions: Apollo.QueryHookOptions<ListInventoryRequestsQuery, ListInventoryRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInventoryRequestsQuery, ListInventoryRequestsQueryVariables>(ListInventoryRequestsDocument, options);
      }
export function useListInventoryRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInventoryRequestsQuery, ListInventoryRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInventoryRequestsQuery, ListInventoryRequestsQueryVariables>(ListInventoryRequestsDocument, options);
        }
export type ListInventoryRequestsQueryHookResult = ReturnType<typeof useListInventoryRequestsQuery>;
export type ListInventoryRequestsLazyQueryHookResult = ReturnType<typeof useListInventoryRequestsLazyQuery>;
export type ListInventoryRequestsQueryResult = Apollo.QueryResult<ListInventoryRequestsQuery, ListInventoryRequestsQueryVariables>;
export const InventoryRequestsByExperimentDocument = gql`
    query inventoryRequestsByExperiment($experimentId: Int!) {
  inventoryRequestsByExperiment(experimentId: $experimentId) {
    ...InventoryRequest
  }
}
    ${InventoryRequestFragmentDoc}`;

/**
 * __useInventoryRequestsByExperimentQuery__
 *
 * To run a query within a React component, call `useInventoryRequestsByExperimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryRequestsByExperimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryRequestsByExperimentQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useInventoryRequestsByExperimentQuery(baseOptions: Apollo.QueryHookOptions<InventoryRequestsByExperimentQuery, InventoryRequestsByExperimentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryRequestsByExperimentQuery, InventoryRequestsByExperimentQueryVariables>(InventoryRequestsByExperimentDocument, options);
      }
export function useInventoryRequestsByExperimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryRequestsByExperimentQuery, InventoryRequestsByExperimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryRequestsByExperimentQuery, InventoryRequestsByExperimentQueryVariables>(InventoryRequestsByExperimentDocument, options);
        }
export type InventoryRequestsByExperimentQueryHookResult = ReturnType<typeof useInventoryRequestsByExperimentQuery>;
export type InventoryRequestsByExperimentLazyQueryHookResult = ReturnType<typeof useInventoryRequestsByExperimentLazyQuery>;
export type InventoryRequestsByExperimentQueryResult = Apollo.QueryResult<InventoryRequestsByExperimentQuery, InventoryRequestsByExperimentQueryVariables>;
export const CreateInventoryDocument = gql`
    mutation createInventory($input: CreateInventoryInput!) {
  createInventory(input: $input) {
    ...Inventory
  }
}
    ${InventoryFragmentDoc}`;
export type CreateInventoryMutationFn = Apollo.MutationFunction<CreateInventoryMutation, CreateInventoryMutationVariables>;

/**
 * __useCreateInventoryMutation__
 *
 * To run a mutation, you first call `useCreateInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryMutation, { data, loading, error }] = useCreateInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInventoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateInventoryMutation, CreateInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInventoryMutation, CreateInventoryMutationVariables>(CreateInventoryDocument, options);
      }
export type CreateInventoryMutationHookResult = ReturnType<typeof useCreateInventoryMutation>;
export type CreateInventoryMutationResult = Apollo.MutationResult<CreateInventoryMutation>;
export type CreateInventoryMutationOptions = Apollo.BaseMutationOptions<CreateInventoryMutation, CreateInventoryMutationVariables>;
export const CreateInventoryRequestDocument = gql`
    mutation createInventoryRequest($input: CreateInventoryRequestInput!) {
  createInventoryRequest(input: $input) {
    ...InventoryRequest
  }
}
    ${InventoryRequestFragmentDoc}`;
export type CreateInventoryRequestMutationFn = Apollo.MutationFunction<CreateInventoryRequestMutation, CreateInventoryRequestMutationVariables>;

/**
 * __useCreateInventoryRequestMutation__
 *
 * To run a mutation, you first call `useCreateInventoryRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryRequestMutation, { data, loading, error }] = useCreateInventoryRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInventoryRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateInventoryRequestMutation, CreateInventoryRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInventoryRequestMutation, CreateInventoryRequestMutationVariables>(CreateInventoryRequestDocument, options);
      }
export type CreateInventoryRequestMutationHookResult = ReturnType<typeof useCreateInventoryRequestMutation>;
export type CreateInventoryRequestMutationResult = Apollo.MutationResult<CreateInventoryRequestMutation>;
export type CreateInventoryRequestMutationOptions = Apollo.BaseMutationOptions<CreateInventoryRequestMutation, CreateInventoryRequestMutationVariables>;
export const DeleteInventoryDocument = gql`
    mutation deleteInventory($id: Int!) {
  removeInventory(id: $id)
}
    `;
export type DeleteInventoryMutationFn = Apollo.MutationFunction<DeleteInventoryMutation, DeleteInventoryMutationVariables>;

/**
 * __useDeleteInventoryMutation__
 *
 * To run a mutation, you first call `useDeleteInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInventoryMutation, { data, loading, error }] = useDeleteInventoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInventoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInventoryMutation, DeleteInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInventoryMutation, DeleteInventoryMutationVariables>(DeleteInventoryDocument, options);
      }
export type DeleteInventoryMutationHookResult = ReturnType<typeof useDeleteInventoryMutation>;
export type DeleteInventoryMutationResult = Apollo.MutationResult<DeleteInventoryMutation>;
export type DeleteInventoryMutationOptions = Apollo.BaseMutationOptions<DeleteInventoryMutation, DeleteInventoryMutationVariables>;
export const DeleteInventoryRequestDocument = gql`
    mutation deleteInventoryRequest($id: Int!) {
  removeInventoryRequest(id: $id)
}
    `;
export type DeleteInventoryRequestMutationFn = Apollo.MutationFunction<DeleteInventoryRequestMutation, DeleteInventoryRequestMutationVariables>;

/**
 * __useDeleteInventoryRequestMutation__
 *
 * To run a mutation, you first call `useDeleteInventoryRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInventoryRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInventoryRequestMutation, { data, loading, error }] = useDeleteInventoryRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInventoryRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInventoryRequestMutation, DeleteInventoryRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInventoryRequestMutation, DeleteInventoryRequestMutationVariables>(DeleteInventoryRequestDocument, options);
      }
export type DeleteInventoryRequestMutationHookResult = ReturnType<typeof useDeleteInventoryRequestMutation>;
export type DeleteInventoryRequestMutationResult = Apollo.MutationResult<DeleteInventoryRequestMutation>;
export type DeleteInventoryRequestMutationOptions = Apollo.BaseMutationOptions<DeleteInventoryRequestMutation, DeleteInventoryRequestMutationVariables>;
export const UpdateInventoryDocument = gql`
    mutation updateInventory($input: UpdateInventoryInput!) {
  updateInventory(input: $input) {
    ...Inventory
  }
}
    ${InventoryFragmentDoc}`;
export type UpdateInventoryMutationFn = Apollo.MutationFunction<UpdateInventoryMutation, UpdateInventoryMutationVariables>;

/**
 * __useUpdateInventoryMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryMutation, { data, loading, error }] = useUpdateInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInventoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryMutation, UpdateInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryMutation, UpdateInventoryMutationVariables>(UpdateInventoryDocument, options);
      }
export type UpdateInventoryMutationHookResult = ReturnType<typeof useUpdateInventoryMutation>;
export type UpdateInventoryMutationResult = Apollo.MutationResult<UpdateInventoryMutation>;
export type UpdateInventoryMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryMutation, UpdateInventoryMutationVariables>;
export const UpdateInventoryRequestDocument = gql`
    mutation updateInventoryRequest($input: UpdateInventoryRequestInput!) {
  updateInventoryRequest(input: $input) {
    ...InventoryRequest
  }
}
    ${InventoryRequestFragmentDoc}`;
export type UpdateInventoryRequestMutationFn = Apollo.MutationFunction<UpdateInventoryRequestMutation, UpdateInventoryRequestMutationVariables>;

/**
 * __useUpdateInventoryRequestMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryRequestMutation, { data, loading, error }] = useUpdateInventoryRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInventoryRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryRequestMutation, UpdateInventoryRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryRequestMutation, UpdateInventoryRequestMutationVariables>(UpdateInventoryRequestDocument, options);
      }
export type UpdateInventoryRequestMutationHookResult = ReturnType<typeof useUpdateInventoryRequestMutation>;
export type UpdateInventoryRequestMutationResult = Apollo.MutationResult<UpdateInventoryRequestMutation>;
export type UpdateInventoryRequestMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryRequestMutation, UpdateInventoryRequestMutationVariables>;
export const BloodBioanalysisDocument = gql`
    query bloodBioanalysis($experimentId: Int!) {
  bloodBioanalysis(experimentId: $experimentId) {
    ...BloodBioanalysis
  }
}
    ${BloodBioanalysisFragmentDoc}`;

/**
 * __useBloodBioanalysisQuery__
 *
 * To run a query within a React component, call `useBloodBioanalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useBloodBioanalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBloodBioanalysisQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useBloodBioanalysisQuery(baseOptions: Apollo.QueryHookOptions<BloodBioanalysisQuery, BloodBioanalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BloodBioanalysisQuery, BloodBioanalysisQueryVariables>(BloodBioanalysisDocument, options);
      }
export function useBloodBioanalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BloodBioanalysisQuery, BloodBioanalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BloodBioanalysisQuery, BloodBioanalysisQueryVariables>(BloodBioanalysisDocument, options);
        }
export type BloodBioanalysisQueryHookResult = ReturnType<typeof useBloodBioanalysisQuery>;
export type BloodBioanalysisLazyQueryHookResult = ReturnType<typeof useBloodBioanalysisLazyQuery>;
export type BloodBioanalysisQueryResult = Apollo.QueryResult<BloodBioanalysisQuery, BloodBioanalysisQueryVariables>;
export const CreateBloodBioanalysisDocument = gql`
    mutation createBloodBioanalysis($input: CreateBloodBioanalysisInput!) {
  createBloodBioanalysis(input: $input) {
    ...BloodBioanalysis
  }
}
    ${BloodBioanalysisFragmentDoc}`;
export type CreateBloodBioanalysisMutationFn = Apollo.MutationFunction<CreateBloodBioanalysisMutation, CreateBloodBioanalysisMutationVariables>;

/**
 * __useCreateBloodBioanalysisMutation__
 *
 * To run a mutation, you first call `useCreateBloodBioanalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBloodBioanalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBloodBioanalysisMutation, { data, loading, error }] = useCreateBloodBioanalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBloodBioanalysisMutation(baseOptions?: Apollo.MutationHookOptions<CreateBloodBioanalysisMutation, CreateBloodBioanalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBloodBioanalysisMutation, CreateBloodBioanalysisMutationVariables>(CreateBloodBioanalysisDocument, options);
      }
export type CreateBloodBioanalysisMutationHookResult = ReturnType<typeof useCreateBloodBioanalysisMutation>;
export type CreateBloodBioanalysisMutationResult = Apollo.MutationResult<CreateBloodBioanalysisMutation>;
export type CreateBloodBioanalysisMutationOptions = Apollo.BaseMutationOptions<CreateBloodBioanalysisMutation, CreateBloodBioanalysisMutationVariables>;
export const DeleteBloodBioanalysisDocument = gql`
    mutation deleteBloodBioanalysis($input: DeleteBloodBioanalysisInput!) {
  deleteBloodBioanalysis(input: $input)
}
    `;
export type DeleteBloodBioanalysisMutationFn = Apollo.MutationFunction<DeleteBloodBioanalysisMutation, DeleteBloodBioanalysisMutationVariables>;

/**
 * __useDeleteBloodBioanalysisMutation__
 *
 * To run a mutation, you first call `useDeleteBloodBioanalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBloodBioanalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBloodBioanalysisMutation, { data, loading, error }] = useDeleteBloodBioanalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBloodBioanalysisMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBloodBioanalysisMutation, DeleteBloodBioanalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBloodBioanalysisMutation, DeleteBloodBioanalysisMutationVariables>(DeleteBloodBioanalysisDocument, options);
      }
export type DeleteBloodBioanalysisMutationHookResult = ReturnType<typeof useDeleteBloodBioanalysisMutation>;
export type DeleteBloodBioanalysisMutationResult = Apollo.MutationResult<DeleteBloodBioanalysisMutation>;
export type DeleteBloodBioanalysisMutationOptions = Apollo.BaseMutationOptions<DeleteBloodBioanalysisMutation, DeleteBloodBioanalysisMutationVariables>;
export const UpdateBloodBioanalysisDocument = gql`
    mutation updateBloodBioanalysis($input: UpdateBloodBioanalysisInput!) {
  updateBloodBioanalysis(input: $input) {
    ...BloodBioanalysis
  }
}
    ${BloodBioanalysisFragmentDoc}`;
export type UpdateBloodBioanalysisMutationFn = Apollo.MutationFunction<UpdateBloodBioanalysisMutation, UpdateBloodBioanalysisMutationVariables>;

/**
 * __useUpdateBloodBioanalysisMutation__
 *
 * To run a mutation, you first call `useUpdateBloodBioanalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBloodBioanalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBloodBioanalysisMutation, { data, loading, error }] = useUpdateBloodBioanalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBloodBioanalysisMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBloodBioanalysisMutation, UpdateBloodBioanalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBloodBioanalysisMutation, UpdateBloodBioanalysisMutationVariables>(UpdateBloodBioanalysisDocument, options);
      }
export type UpdateBloodBioanalysisMutationHookResult = ReturnType<typeof useUpdateBloodBioanalysisMutation>;
export type UpdateBloodBioanalysisMutationResult = Apollo.MutationResult<UpdateBloodBioanalysisMutation>;
export type UpdateBloodBioanalysisMutationOptions = Apollo.BaseMutationOptions<UpdateBloodBioanalysisMutation, UpdateBloodBioanalysisMutationVariables>;
export const TissueBioanalysisDocument = gql`
    query tissueBioanalysis($experimentId: Int!) {
  tissueBioanalysis(experimentId: $experimentId) {
    ...TissueBioanalysis
  }
}
    ${TissueBioanalysisFragmentDoc}`;

/**
 * __useTissueBioanalysisQuery__
 *
 * To run a query within a React component, call `useTissueBioanalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useTissueBioanalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTissueBioanalysisQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useTissueBioanalysisQuery(baseOptions: Apollo.QueryHookOptions<TissueBioanalysisQuery, TissueBioanalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TissueBioanalysisQuery, TissueBioanalysisQueryVariables>(TissueBioanalysisDocument, options);
      }
export function useTissueBioanalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TissueBioanalysisQuery, TissueBioanalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TissueBioanalysisQuery, TissueBioanalysisQueryVariables>(TissueBioanalysisDocument, options);
        }
export type TissueBioanalysisQueryHookResult = ReturnType<typeof useTissueBioanalysisQuery>;
export type TissueBioanalysisLazyQueryHookResult = ReturnType<typeof useTissueBioanalysisLazyQuery>;
export type TissueBioanalysisQueryResult = Apollo.QueryResult<TissueBioanalysisQuery, TissueBioanalysisQueryVariables>;
export const CreateTissueBioanalysisDocument = gql`
    mutation createTissueBioanalysis($input: CreateTissueBioanalysisInput!) {
  createTissueBioanalysis(input: $input) {
    ...TissueBioanalysis
  }
}
    ${TissueBioanalysisFragmentDoc}`;
export type CreateTissueBioanalysisMutationFn = Apollo.MutationFunction<CreateTissueBioanalysisMutation, CreateTissueBioanalysisMutationVariables>;

/**
 * __useCreateTissueBioanalysisMutation__
 *
 * To run a mutation, you first call `useCreateTissueBioanalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTissueBioanalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTissueBioanalysisMutation, { data, loading, error }] = useCreateTissueBioanalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTissueBioanalysisMutation(baseOptions?: Apollo.MutationHookOptions<CreateTissueBioanalysisMutation, CreateTissueBioanalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTissueBioanalysisMutation, CreateTissueBioanalysisMutationVariables>(CreateTissueBioanalysisDocument, options);
      }
export type CreateTissueBioanalysisMutationHookResult = ReturnType<typeof useCreateTissueBioanalysisMutation>;
export type CreateTissueBioanalysisMutationResult = Apollo.MutationResult<CreateTissueBioanalysisMutation>;
export type CreateTissueBioanalysisMutationOptions = Apollo.BaseMutationOptions<CreateTissueBioanalysisMutation, CreateTissueBioanalysisMutationVariables>;
export const DeleteTissueBioanalysisDocument = gql`
    mutation deleteTissueBioanalysis($input: DeleteTissueBioanalysisInput!) {
  deleteTissueBioanalysis(input: $input)
}
    `;
export type DeleteTissueBioanalysisMutationFn = Apollo.MutationFunction<DeleteTissueBioanalysisMutation, DeleteTissueBioanalysisMutationVariables>;

/**
 * __useDeleteTissueBioanalysisMutation__
 *
 * To run a mutation, you first call `useDeleteTissueBioanalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTissueBioanalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTissueBioanalysisMutation, { data, loading, error }] = useDeleteTissueBioanalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTissueBioanalysisMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTissueBioanalysisMutation, DeleteTissueBioanalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTissueBioanalysisMutation, DeleteTissueBioanalysisMutationVariables>(DeleteTissueBioanalysisDocument, options);
      }
export type DeleteTissueBioanalysisMutationHookResult = ReturnType<typeof useDeleteTissueBioanalysisMutation>;
export type DeleteTissueBioanalysisMutationResult = Apollo.MutationResult<DeleteTissueBioanalysisMutation>;
export type DeleteTissueBioanalysisMutationOptions = Apollo.BaseMutationOptions<DeleteTissueBioanalysisMutation, DeleteTissueBioanalysisMutationVariables>;
export const UpdateTissueBioanalysisDocument = gql`
    mutation updateTissueBioanalysis($input: UpdateTissueBioanalysisInput!) {
  updateTissueBioanalysis(input: $input) {
    ...TissueBioanalysis
  }
}
    ${TissueBioanalysisFragmentDoc}`;
export type UpdateTissueBioanalysisMutationFn = Apollo.MutationFunction<UpdateTissueBioanalysisMutation, UpdateTissueBioanalysisMutationVariables>;

/**
 * __useUpdateTissueBioanalysisMutation__
 *
 * To run a mutation, you first call `useUpdateTissueBioanalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTissueBioanalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTissueBioanalysisMutation, { data, loading, error }] = useUpdateTissueBioanalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTissueBioanalysisMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTissueBioanalysisMutation, UpdateTissueBioanalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTissueBioanalysisMutation, UpdateTissueBioanalysisMutationVariables>(UpdateTissueBioanalysisDocument, options);
      }
export type UpdateTissueBioanalysisMutationHookResult = ReturnType<typeof useUpdateTissueBioanalysisMutation>;
export type UpdateTissueBioanalysisMutationResult = Apollo.MutationResult<UpdateTissueBioanalysisMutation>;
export type UpdateTissueBioanalysisMutationOptions = Apollo.BaseMutationOptions<UpdateTissueBioanalysisMutation, UpdateTissueBioanalysisMutationVariables>;
export const ImagingDocument = gql`
    query imaging($experimentId: Int!) {
  imaging(experimentId: $experimentId) {
    ...Imaging
  }
}
    ${ImagingFragmentDoc}`;

/**
 * __useImagingQuery__
 *
 * To run a query within a React component, call `useImagingQuery` and pass it any options that fit your needs.
 * When your component renders, `useImagingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImagingQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useImagingQuery(baseOptions: Apollo.QueryHookOptions<ImagingQuery, ImagingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImagingQuery, ImagingQueryVariables>(ImagingDocument, options);
      }
export function useImagingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImagingQuery, ImagingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImagingQuery, ImagingQueryVariables>(ImagingDocument, options);
        }
export type ImagingQueryHookResult = ReturnType<typeof useImagingQuery>;
export type ImagingLazyQueryHookResult = ReturnType<typeof useImagingLazyQuery>;
export type ImagingQueryResult = Apollo.QueryResult<ImagingQuery, ImagingQueryVariables>;
export const CreateImagingDocument = gql`
    mutation createImaging($input: CreateImagingInput!) {
  createImaging(input: $input) {
    ...Imaging
  }
}
    ${ImagingFragmentDoc}`;
export type CreateImagingMutationFn = Apollo.MutationFunction<CreateImagingMutation, CreateImagingMutationVariables>;

/**
 * __useCreateImagingMutation__
 *
 * To run a mutation, you first call `useCreateImagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImagingMutation, { data, loading, error }] = useCreateImagingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImagingMutation(baseOptions?: Apollo.MutationHookOptions<CreateImagingMutation, CreateImagingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImagingMutation, CreateImagingMutationVariables>(CreateImagingDocument, options);
      }
export type CreateImagingMutationHookResult = ReturnType<typeof useCreateImagingMutation>;
export type CreateImagingMutationResult = Apollo.MutationResult<CreateImagingMutation>;
export type CreateImagingMutationOptions = Apollo.BaseMutationOptions<CreateImagingMutation, CreateImagingMutationVariables>;
export const DeleteImagingDocument = gql`
    mutation deleteImaging($input: DeleteImagingInput!) {
  deleteImaging(input: $input)
}
    `;
export type DeleteImagingMutationFn = Apollo.MutationFunction<DeleteImagingMutation, DeleteImagingMutationVariables>;

/**
 * __useDeleteImagingMutation__
 *
 * To run a mutation, you first call `useDeleteImagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImagingMutation, { data, loading, error }] = useDeleteImagingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteImagingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImagingMutation, DeleteImagingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImagingMutation, DeleteImagingMutationVariables>(DeleteImagingDocument, options);
      }
export type DeleteImagingMutationHookResult = ReturnType<typeof useDeleteImagingMutation>;
export type DeleteImagingMutationResult = Apollo.MutationResult<DeleteImagingMutation>;
export type DeleteImagingMutationOptions = Apollo.BaseMutationOptions<DeleteImagingMutation, DeleteImagingMutationVariables>;
export const UpdateImagingDocument = gql`
    mutation updateImaging($input: UpdateImagingInput!) {
  updateImaging(input: $input) {
    ...Imaging
  }
}
    ${ImagingFragmentDoc}`;
export type UpdateImagingMutationFn = Apollo.MutationFunction<UpdateImagingMutation, UpdateImagingMutationVariables>;

/**
 * __useUpdateImagingMutation__
 *
 * To run a mutation, you first call `useUpdateImagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImagingMutation, { data, loading, error }] = useUpdateImagingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImagingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImagingMutation, UpdateImagingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImagingMutation, UpdateImagingMutationVariables>(UpdateImagingDocument, options);
      }
export type UpdateImagingMutationHookResult = ReturnType<typeof useUpdateImagingMutation>;
export type UpdateImagingMutationResult = Apollo.MutationResult<UpdateImagingMutation>;
export type UpdateImagingMutationOptions = Apollo.BaseMutationOptions<UpdateImagingMutation, UpdateImagingMutationVariables>;
export const CellLinePageByPageDocument = gql`
    query cellLinePageByPage($limit: Int!, $offset: Int, $query: String, $filter: PaginationFilter, $sort: [PaginationSort!]) {
  cellLines(
    limit: $limit
    offset: $offset
    query: $query
    filter: $filter
    sort: $sort
  ) {
    items {
      ...CellLine
    }
    totalCount
  }
}
    ${CellLineFragmentDoc}`;

/**
 * __useCellLinePageByPageQuery__
 *
 * To run a query within a React component, call `useCellLinePageByPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCellLinePageByPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCellLinePageByPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCellLinePageByPageQuery(baseOptions: Apollo.QueryHookOptions<CellLinePageByPageQuery, CellLinePageByPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CellLinePageByPageQuery, CellLinePageByPageQueryVariables>(CellLinePageByPageDocument, options);
      }
export function useCellLinePageByPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CellLinePageByPageQuery, CellLinePageByPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CellLinePageByPageQuery, CellLinePageByPageQueryVariables>(CellLinePageByPageDocument, options);
        }
export type CellLinePageByPageQueryHookResult = ReturnType<typeof useCellLinePageByPageQuery>;
export type CellLinePageByPageLazyQueryHookResult = ReturnType<typeof useCellLinePageByPageLazyQuery>;
export type CellLinePageByPageQueryResult = Apollo.QueryResult<CellLinePageByPageQuery, CellLinePageByPageQueryVariables>;
export const CroCellLinesDocument = gql`
    query croCellLines($limit: Int!, $offset: Int, $query: String, $filter: PaginationFilter, $sort: [PaginationSort!]) {
  croCellLines(
    limit: $limit
    offset: $offset
    query: $query
    filter: $filter
    sort: $sort
  ) {
    items {
      ...CellLine
    }
    totalCount
  }
}
    ${CellLineFragmentDoc}`;

/**
 * __useCroCellLinesQuery__
 *
 * To run a query within a React component, call `useCroCellLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCroCellLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCroCellLinesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCroCellLinesQuery(baseOptions: Apollo.QueryHookOptions<CroCellLinesQuery, CroCellLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CroCellLinesQuery, CroCellLinesQueryVariables>(CroCellLinesDocument, options);
      }
export function useCroCellLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CroCellLinesQuery, CroCellLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CroCellLinesQuery, CroCellLinesQueryVariables>(CroCellLinesDocument, options);
        }
export type CroCellLinesQueryHookResult = ReturnType<typeof useCroCellLinesQuery>;
export type CroCellLinesLazyQueryHookResult = ReturnType<typeof useCroCellLinesLazyQuery>;
export type CroCellLinesQueryResult = Apollo.QueryResult<CroCellLinesQuery, CroCellLinesQueryVariables>;
export const CroCellLineDocument = gql`
    query croCellLine($id: Int!) {
  croCellLine(id: $id) {
    ...CellLine
  }
}
    ${CellLineFragmentDoc}`;

/**
 * __useCroCellLineQuery__
 *
 * To run a query within a React component, call `useCroCellLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCroCellLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCroCellLineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCroCellLineQuery(baseOptions: Apollo.QueryHookOptions<CroCellLineQuery, CroCellLineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CroCellLineQuery, CroCellLineQueryVariables>(CroCellLineDocument, options);
      }
export function useCroCellLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CroCellLineQuery, CroCellLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CroCellLineQuery, CroCellLineQueryVariables>(CroCellLineDocument, options);
        }
export type CroCellLineQueryHookResult = ReturnType<typeof useCroCellLineQuery>;
export type CroCellLineLazyQueryHookResult = ReturnType<typeof useCroCellLineLazyQuery>;
export type CroCellLineQueryResult = Apollo.QueryResult<CroCellLineQuery, CroCellLineQueryVariables>;
export const CreateCroCellLineDocument = gql`
    mutation createCROCellLine($input: CROCellLineInput!) {
  createCROCellLine(input: $input) {
    ...CellLine
  }
}
    ${CellLineFragmentDoc}`;
export type CreateCroCellLineMutationFn = Apollo.MutationFunction<CreateCroCellLineMutation, CreateCroCellLineMutationVariables>;

/**
 * __useCreateCroCellLineMutation__
 *
 * To run a mutation, you first call `useCreateCroCellLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCroCellLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCroCellLineMutation, { data, loading, error }] = useCreateCroCellLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCroCellLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateCroCellLineMutation, CreateCroCellLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCroCellLineMutation, CreateCroCellLineMutationVariables>(CreateCroCellLineDocument, options);
      }
export type CreateCroCellLineMutationHookResult = ReturnType<typeof useCreateCroCellLineMutation>;
export type CreateCroCellLineMutationResult = Apollo.MutationResult<CreateCroCellLineMutation>;
export type CreateCroCellLineMutationOptions = Apollo.BaseMutationOptions<CreateCroCellLineMutation, CreateCroCellLineMutationVariables>;
export const DeleteCroCellLineDocument = gql`
    mutation deleteCROCellLine($id: Int!) {
  deleteCROCellLine(id: $id)
}
    `;
export type DeleteCroCellLineMutationFn = Apollo.MutationFunction<DeleteCroCellLineMutation, DeleteCroCellLineMutationVariables>;

/**
 * __useDeleteCroCellLineMutation__
 *
 * To run a mutation, you first call `useDeleteCroCellLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCroCellLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCroCellLineMutation, { data, loading, error }] = useDeleteCroCellLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCroCellLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCroCellLineMutation, DeleteCroCellLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCroCellLineMutation, DeleteCroCellLineMutationVariables>(DeleteCroCellLineDocument, options);
      }
export type DeleteCroCellLineMutationHookResult = ReturnType<typeof useDeleteCroCellLineMutation>;
export type DeleteCroCellLineMutationResult = Apollo.MutationResult<DeleteCroCellLineMutation>;
export type DeleteCroCellLineMutationOptions = Apollo.BaseMutationOptions<DeleteCroCellLineMutation, DeleteCroCellLineMutationVariables>;
export const UpdateCroCellLineDocument = gql`
    mutation updateCROCellLine($input: UpdateCROCellLineInput!) {
  updateCROCellLine(input: $input) {
    ...CellLine
  }
}
    ${CellLineFragmentDoc}`;
export type UpdateCroCellLineMutationFn = Apollo.MutationFunction<UpdateCroCellLineMutation, UpdateCroCellLineMutationVariables>;

/**
 * __useUpdateCroCellLineMutation__
 *
 * To run a mutation, you first call `useUpdateCroCellLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCroCellLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCroCellLineMutation, { data, loading, error }] = useUpdateCroCellLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCroCellLineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCroCellLineMutation, UpdateCroCellLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCroCellLineMutation, UpdateCroCellLineMutationVariables>(UpdateCroCellLineDocument, options);
      }
export type UpdateCroCellLineMutationHookResult = ReturnType<typeof useUpdateCroCellLineMutation>;
export type UpdateCroCellLineMutationResult = Apollo.MutationResult<UpdateCroCellLineMutation>;
export type UpdateCroCellLineMutationOptions = Apollo.BaseMutationOptions<UpdateCroCellLineMutation, UpdateCroCellLineMutationVariables>;
export const PkBloodWorksheetDocument = gql`
    query pkBloodWorksheet($experimentId: Int!) {
  pkBloodWorksheet(experimentId: $experimentId) {
    ...PKBloodWorksheet
  }
}
    ${PkBloodWorksheetFragmentDoc}`;

/**
 * __usePkBloodWorksheetQuery__
 *
 * To run a query within a React component, call `usePkBloodWorksheetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePkBloodWorksheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePkBloodWorksheetQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function usePkBloodWorksheetQuery(baseOptions: Apollo.QueryHookOptions<PkBloodWorksheetQuery, PkBloodWorksheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PkBloodWorksheetQuery, PkBloodWorksheetQueryVariables>(PkBloodWorksheetDocument, options);
      }
export function usePkBloodWorksheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PkBloodWorksheetQuery, PkBloodWorksheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PkBloodWorksheetQuery, PkBloodWorksheetQueryVariables>(PkBloodWorksheetDocument, options);
        }
export type PkBloodWorksheetQueryHookResult = ReturnType<typeof usePkBloodWorksheetQuery>;
export type PkBloodWorksheetLazyQueryHookResult = ReturnType<typeof usePkBloodWorksheetLazyQuery>;
export type PkBloodWorksheetQueryResult = Apollo.QueryResult<PkBloodWorksheetQuery, PkBloodWorksheetQueryVariables>;
export const PkBloodWorksheetWithCollectionsDocument = gql`
    query pkBloodWorksheetWithCollections($experimentId: Int!) {
  pkBloodWorksheet(experimentId: $experimentId) {
    ...PKBloodWorksheet
    pkBloodWorksheetCollections {
      ...PKBloodWorksheetCollection
    }
  }
}
    ${PkBloodWorksheetFragmentDoc}
${PkBloodWorksheetCollectionFragmentDoc}`;

/**
 * __usePkBloodWorksheetWithCollectionsQuery__
 *
 * To run a query within a React component, call `usePkBloodWorksheetWithCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePkBloodWorksheetWithCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePkBloodWorksheetWithCollectionsQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function usePkBloodWorksheetWithCollectionsQuery(baseOptions: Apollo.QueryHookOptions<PkBloodWorksheetWithCollectionsQuery, PkBloodWorksheetWithCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PkBloodWorksheetWithCollectionsQuery, PkBloodWorksheetWithCollectionsQueryVariables>(PkBloodWorksheetWithCollectionsDocument, options);
      }
export function usePkBloodWorksheetWithCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PkBloodWorksheetWithCollectionsQuery, PkBloodWorksheetWithCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PkBloodWorksheetWithCollectionsQuery, PkBloodWorksheetWithCollectionsQueryVariables>(PkBloodWorksheetWithCollectionsDocument, options);
        }
export type PkBloodWorksheetWithCollectionsQueryHookResult = ReturnType<typeof usePkBloodWorksheetWithCollectionsQuery>;
export type PkBloodWorksheetWithCollectionsLazyQueryHookResult = ReturnType<typeof usePkBloodWorksheetWithCollectionsLazyQuery>;
export type PkBloodWorksheetWithCollectionsQueryResult = Apollo.QueryResult<PkBloodWorksheetWithCollectionsQuery, PkBloodWorksheetWithCollectionsQueryVariables>;
export const UpdatePkBloodWorksheetStatusDocument = gql`
    mutation updatePKBloodWorksheetStatus($input: UpdatePKBloodWorksheetStatusInput!) {
  updatePKBloodWorksheetStatus(input: $input) {
    ...PKBloodWorksheet
  }
}
    ${PkBloodWorksheetFragmentDoc}`;
export type UpdatePkBloodWorksheetStatusMutationFn = Apollo.MutationFunction<UpdatePkBloodWorksheetStatusMutation, UpdatePkBloodWorksheetStatusMutationVariables>;

/**
 * __useUpdatePkBloodWorksheetStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePkBloodWorksheetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkBloodWorksheetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkBloodWorksheetStatusMutation, { data, loading, error }] = useUpdatePkBloodWorksheetStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkBloodWorksheetStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkBloodWorksheetStatusMutation, UpdatePkBloodWorksheetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkBloodWorksheetStatusMutation, UpdatePkBloodWorksheetStatusMutationVariables>(UpdatePkBloodWorksheetStatusDocument, options);
      }
export type UpdatePkBloodWorksheetStatusMutationHookResult = ReturnType<typeof useUpdatePkBloodWorksheetStatusMutation>;
export type UpdatePkBloodWorksheetStatusMutationResult = Apollo.MutationResult<UpdatePkBloodWorksheetStatusMutation>;
export type UpdatePkBloodWorksheetStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePkBloodWorksheetStatusMutation, UpdatePkBloodWorksheetStatusMutationVariables>;
export const UpdatePkBloodWorksheetBasisDateDocument = gql`
    mutation updatePKBloodWorksheetBasisDate($input: UpdatePKBloodWorksheetBasisDateInput!) {
  updatePKBloodWorksheetBasisDate(input: $input) {
    ...PKBloodWorksheet
    pkBloodWorksheetCollections {
      ...PKBloodWorksheetCollection
    }
  }
}
    ${PkBloodWorksheetFragmentDoc}
${PkBloodWorksheetCollectionFragmentDoc}`;
export type UpdatePkBloodWorksheetBasisDateMutationFn = Apollo.MutationFunction<UpdatePkBloodWorksheetBasisDateMutation, UpdatePkBloodWorksheetBasisDateMutationVariables>;

/**
 * __useUpdatePkBloodWorksheetBasisDateMutation__
 *
 * To run a mutation, you first call `useUpdatePkBloodWorksheetBasisDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkBloodWorksheetBasisDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkBloodWorksheetBasisDateMutation, { data, loading, error }] = useUpdatePkBloodWorksheetBasisDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkBloodWorksheetBasisDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkBloodWorksheetBasisDateMutation, UpdatePkBloodWorksheetBasisDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkBloodWorksheetBasisDateMutation, UpdatePkBloodWorksheetBasisDateMutationVariables>(UpdatePkBloodWorksheetBasisDateDocument, options);
      }
export type UpdatePkBloodWorksheetBasisDateMutationHookResult = ReturnType<typeof useUpdatePkBloodWorksheetBasisDateMutation>;
export type UpdatePkBloodWorksheetBasisDateMutationResult = Apollo.MutationResult<UpdatePkBloodWorksheetBasisDateMutation>;
export type UpdatePkBloodWorksheetBasisDateMutationOptions = Apollo.BaseMutationOptions<UpdatePkBloodWorksheetBasisDateMutation, UpdatePkBloodWorksheetBasisDateMutationVariables>;
export const UpdatePkBloodWorksheetNotesDocument = gql`
    mutation updatePKBloodWorksheetNotes($input: UpdatePKBloodWorksheetNotesInput!) {
  updatePKBloodWorksheetNotes(input: $input) {
    ...PKBloodWorksheet
  }
}
    ${PkBloodWorksheetFragmentDoc}`;
export type UpdatePkBloodWorksheetNotesMutationFn = Apollo.MutationFunction<UpdatePkBloodWorksheetNotesMutation, UpdatePkBloodWorksheetNotesMutationVariables>;

/**
 * __useUpdatePkBloodWorksheetNotesMutation__
 *
 * To run a mutation, you first call `useUpdatePkBloodWorksheetNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkBloodWorksheetNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkBloodWorksheetNotesMutation, { data, loading, error }] = useUpdatePkBloodWorksheetNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkBloodWorksheetNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkBloodWorksheetNotesMutation, UpdatePkBloodWorksheetNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkBloodWorksheetNotesMutation, UpdatePkBloodWorksheetNotesMutationVariables>(UpdatePkBloodWorksheetNotesDocument, options);
      }
export type UpdatePkBloodWorksheetNotesMutationHookResult = ReturnType<typeof useUpdatePkBloodWorksheetNotesMutation>;
export type UpdatePkBloodWorksheetNotesMutationResult = Apollo.MutationResult<UpdatePkBloodWorksheetNotesMutation>;
export type UpdatePkBloodWorksheetNotesMutationOptions = Apollo.BaseMutationOptions<UpdatePkBloodWorksheetNotesMutation, UpdatePkBloodWorksheetNotesMutationVariables>;
export const UpdatePkBloodWorksheetCollectionActualTimeDocument = gql`
    mutation updatePKBloodWorksheetCollectionActualTime($input: UpdatePKBloodWorksheetCollectionActualTimeInput!) {
  updatePKBloodWorksheetCollectionActualTime(input: $input) {
    ...PKBloodWorksheetCollection
  }
}
    ${PkBloodWorksheetCollectionFragmentDoc}`;
export type UpdatePkBloodWorksheetCollectionActualTimeMutationFn = Apollo.MutationFunction<UpdatePkBloodWorksheetCollectionActualTimeMutation, UpdatePkBloodWorksheetCollectionActualTimeMutationVariables>;

/**
 * __useUpdatePkBloodWorksheetCollectionActualTimeMutation__
 *
 * To run a mutation, you first call `useUpdatePkBloodWorksheetCollectionActualTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkBloodWorksheetCollectionActualTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkBloodWorksheetCollectionActualTimeMutation, { data, loading, error }] = useUpdatePkBloodWorksheetCollectionActualTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkBloodWorksheetCollectionActualTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkBloodWorksheetCollectionActualTimeMutation, UpdatePkBloodWorksheetCollectionActualTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkBloodWorksheetCollectionActualTimeMutation, UpdatePkBloodWorksheetCollectionActualTimeMutationVariables>(UpdatePkBloodWorksheetCollectionActualTimeDocument, options);
      }
export type UpdatePkBloodWorksheetCollectionActualTimeMutationHookResult = ReturnType<typeof useUpdatePkBloodWorksheetCollectionActualTimeMutation>;
export type UpdatePkBloodWorksheetCollectionActualTimeMutationResult = Apollo.MutationResult<UpdatePkBloodWorksheetCollectionActualTimeMutation>;
export type UpdatePkBloodWorksheetCollectionActualTimeMutationOptions = Apollo.BaseMutationOptions<UpdatePkBloodWorksheetCollectionActualTimeMutation, UpdatePkBloodWorksheetCollectionActualTimeMutationVariables>;
export const UpdatePkBloodWorksheetCollectionActualTimesDocument = gql`
    mutation updatePKBloodWorksheetCollectionActualTimes($input: UpdatePKBloodWorksheetCollectionActualTimesInput!) {
  updatePKBloodWorksheetCollectionActualTimes(input: $input) {
    ...PKBloodWorksheetCollection
  }
}
    ${PkBloodWorksheetCollectionFragmentDoc}`;
export type UpdatePkBloodWorksheetCollectionActualTimesMutationFn = Apollo.MutationFunction<UpdatePkBloodWorksheetCollectionActualTimesMutation, UpdatePkBloodWorksheetCollectionActualTimesMutationVariables>;

/**
 * __useUpdatePkBloodWorksheetCollectionActualTimesMutation__
 *
 * To run a mutation, you first call `useUpdatePkBloodWorksheetCollectionActualTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkBloodWorksheetCollectionActualTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkBloodWorksheetCollectionActualTimesMutation, { data, loading, error }] = useUpdatePkBloodWorksheetCollectionActualTimesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkBloodWorksheetCollectionActualTimesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkBloodWorksheetCollectionActualTimesMutation, UpdatePkBloodWorksheetCollectionActualTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkBloodWorksheetCollectionActualTimesMutation, UpdatePkBloodWorksheetCollectionActualTimesMutationVariables>(UpdatePkBloodWorksheetCollectionActualTimesDocument, options);
      }
export type UpdatePkBloodWorksheetCollectionActualTimesMutationHookResult = ReturnType<typeof useUpdatePkBloodWorksheetCollectionActualTimesMutation>;
export type UpdatePkBloodWorksheetCollectionActualTimesMutationResult = Apollo.MutationResult<UpdatePkBloodWorksheetCollectionActualTimesMutation>;
export type UpdatePkBloodWorksheetCollectionActualTimesMutationOptions = Apollo.BaseMutationOptions<UpdatePkBloodWorksheetCollectionActualTimesMutation, UpdatePkBloodWorksheetCollectionActualTimesMutationVariables>;
export const ClearPkBloodWorksheetCollectionsActualTimeDocument = gql`
    mutation clearPKBloodWorksheetCollectionsActualTime($input: ClearPKBloodWorksheetCollectionsActualTimeInput!) {
  clearPKBloodWorksheetCollectionsActualTime(input: $input) {
    ...PKBloodWorksheetCollection
  }
}
    ${PkBloodWorksheetCollectionFragmentDoc}`;
export type ClearPkBloodWorksheetCollectionsActualTimeMutationFn = Apollo.MutationFunction<ClearPkBloodWorksheetCollectionsActualTimeMutation, ClearPkBloodWorksheetCollectionsActualTimeMutationVariables>;

/**
 * __useClearPkBloodWorksheetCollectionsActualTimeMutation__
 *
 * To run a mutation, you first call `useClearPkBloodWorksheetCollectionsActualTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearPkBloodWorksheetCollectionsActualTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearPkBloodWorksheetCollectionsActualTimeMutation, { data, loading, error }] = useClearPkBloodWorksheetCollectionsActualTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearPkBloodWorksheetCollectionsActualTimeMutation(baseOptions?: Apollo.MutationHookOptions<ClearPkBloodWorksheetCollectionsActualTimeMutation, ClearPkBloodWorksheetCollectionsActualTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearPkBloodWorksheetCollectionsActualTimeMutation, ClearPkBloodWorksheetCollectionsActualTimeMutationVariables>(ClearPkBloodWorksheetCollectionsActualTimeDocument, options);
      }
export type ClearPkBloodWorksheetCollectionsActualTimeMutationHookResult = ReturnType<typeof useClearPkBloodWorksheetCollectionsActualTimeMutation>;
export type ClearPkBloodWorksheetCollectionsActualTimeMutationResult = Apollo.MutationResult<ClearPkBloodWorksheetCollectionsActualTimeMutation>;
export type ClearPkBloodWorksheetCollectionsActualTimeMutationOptions = Apollo.BaseMutationOptions<ClearPkBloodWorksheetCollectionsActualTimeMutation, ClearPkBloodWorksheetCollectionsActualTimeMutationVariables>;
export const PkTissueWorksheetDocument = gql`
    query pkTissueWorksheet($experimentId: Int!) {
  pkTissueWorksheet(experimentId: $experimentId) {
    ...PKTissueWorksheet
  }
}
    ${PkTissueWorksheetFragmentDoc}`;

/**
 * __usePkTissueWorksheetQuery__
 *
 * To run a query within a React component, call `usePkTissueWorksheetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePkTissueWorksheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePkTissueWorksheetQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function usePkTissueWorksheetQuery(baseOptions: Apollo.QueryHookOptions<PkTissueWorksheetQuery, PkTissueWorksheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PkTissueWorksheetQuery, PkTissueWorksheetQueryVariables>(PkTissueWorksheetDocument, options);
      }
export function usePkTissueWorksheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PkTissueWorksheetQuery, PkTissueWorksheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PkTissueWorksheetQuery, PkTissueWorksheetQueryVariables>(PkTissueWorksheetDocument, options);
        }
export type PkTissueWorksheetQueryHookResult = ReturnType<typeof usePkTissueWorksheetQuery>;
export type PkTissueWorksheetLazyQueryHookResult = ReturnType<typeof usePkTissueWorksheetLazyQuery>;
export type PkTissueWorksheetQueryResult = Apollo.QueryResult<PkTissueWorksheetQuery, PkTissueWorksheetQueryVariables>;
export const PkTissueWorksheetWithCollectionsDocument = gql`
    query pkTissueWorksheetWithCollections($experimentId: Int!) {
  pkTissueWorksheet(experimentId: $experimentId) {
    ...PKTissueWorksheet
    pkTissueWorksheetCollections {
      ...PKTissueWorksheetCollection
    }
  }
}
    ${PkTissueWorksheetFragmentDoc}
${PkTissueWorksheetCollectionFragmentDoc}`;

/**
 * __usePkTissueWorksheetWithCollectionsQuery__
 *
 * To run a query within a React component, call `usePkTissueWorksheetWithCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePkTissueWorksheetWithCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePkTissueWorksheetWithCollectionsQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function usePkTissueWorksheetWithCollectionsQuery(baseOptions: Apollo.QueryHookOptions<PkTissueWorksheetWithCollectionsQuery, PkTissueWorksheetWithCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PkTissueWorksheetWithCollectionsQuery, PkTissueWorksheetWithCollectionsQueryVariables>(PkTissueWorksheetWithCollectionsDocument, options);
      }
export function usePkTissueWorksheetWithCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PkTissueWorksheetWithCollectionsQuery, PkTissueWorksheetWithCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PkTissueWorksheetWithCollectionsQuery, PkTissueWorksheetWithCollectionsQueryVariables>(PkTissueWorksheetWithCollectionsDocument, options);
        }
export type PkTissueWorksheetWithCollectionsQueryHookResult = ReturnType<typeof usePkTissueWorksheetWithCollectionsQuery>;
export type PkTissueWorksheetWithCollectionsLazyQueryHookResult = ReturnType<typeof usePkTissueWorksheetWithCollectionsLazyQuery>;
export type PkTissueWorksheetWithCollectionsQueryResult = Apollo.QueryResult<PkTissueWorksheetWithCollectionsQuery, PkTissueWorksheetWithCollectionsQueryVariables>;
export const UpdatePkTissueWorksheetStatusDocument = gql`
    mutation updatePKTissueWorksheetStatus($input: UpdatePKTissueWorksheetStatusInput!) {
  updatePKTissueWorksheetStatus(input: $input) {
    ...PKTissueWorksheet
  }
}
    ${PkTissueWorksheetFragmentDoc}`;
export type UpdatePkTissueWorksheetStatusMutationFn = Apollo.MutationFunction<UpdatePkTissueWorksheetStatusMutation, UpdatePkTissueWorksheetStatusMutationVariables>;

/**
 * __useUpdatePkTissueWorksheetStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePkTissueWorksheetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkTissueWorksheetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkTissueWorksheetStatusMutation, { data, loading, error }] = useUpdatePkTissueWorksheetStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkTissueWorksheetStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkTissueWorksheetStatusMutation, UpdatePkTissueWorksheetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkTissueWorksheetStatusMutation, UpdatePkTissueWorksheetStatusMutationVariables>(UpdatePkTissueWorksheetStatusDocument, options);
      }
export type UpdatePkTissueWorksheetStatusMutationHookResult = ReturnType<typeof useUpdatePkTissueWorksheetStatusMutation>;
export type UpdatePkTissueWorksheetStatusMutationResult = Apollo.MutationResult<UpdatePkTissueWorksheetStatusMutation>;
export type UpdatePkTissueWorksheetStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePkTissueWorksheetStatusMutation, UpdatePkTissueWorksheetStatusMutationVariables>;
export const UpdatePkTissueWorksheetBasisDateDocument = gql`
    mutation updatePKTissueWorksheetBasisDate($input: UpdatePKTissueWorksheetBasisDateInput!) {
  updatePKTissueWorksheetBasisDate(input: $input) {
    ...PKTissueWorksheet
    pkTissueWorksheetCollections {
      ...PKTissueWorksheetCollection
    }
  }
}
    ${PkTissueWorksheetFragmentDoc}
${PkTissueWorksheetCollectionFragmentDoc}`;
export type UpdatePkTissueWorksheetBasisDateMutationFn = Apollo.MutationFunction<UpdatePkTissueWorksheetBasisDateMutation, UpdatePkTissueWorksheetBasisDateMutationVariables>;

/**
 * __useUpdatePkTissueWorksheetBasisDateMutation__
 *
 * To run a mutation, you first call `useUpdatePkTissueWorksheetBasisDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkTissueWorksheetBasisDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkTissueWorksheetBasisDateMutation, { data, loading, error }] = useUpdatePkTissueWorksheetBasisDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkTissueWorksheetBasisDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkTissueWorksheetBasisDateMutation, UpdatePkTissueWorksheetBasisDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkTissueWorksheetBasisDateMutation, UpdatePkTissueWorksheetBasisDateMutationVariables>(UpdatePkTissueWorksheetBasisDateDocument, options);
      }
export type UpdatePkTissueWorksheetBasisDateMutationHookResult = ReturnType<typeof useUpdatePkTissueWorksheetBasisDateMutation>;
export type UpdatePkTissueWorksheetBasisDateMutationResult = Apollo.MutationResult<UpdatePkTissueWorksheetBasisDateMutation>;
export type UpdatePkTissueWorksheetBasisDateMutationOptions = Apollo.BaseMutationOptions<UpdatePkTissueWorksheetBasisDateMutation, UpdatePkTissueWorksheetBasisDateMutationVariables>;
export const UpdatePkTissueWorksheetNotesDocument = gql`
    mutation updatePKTissueWorksheetNotes($input: UpdatePKTissueWorksheetNotesInput!) {
  updatePKTissueWorksheetNotes(input: $input) {
    ...PKTissueWorksheet
  }
}
    ${PkTissueWorksheetFragmentDoc}`;
export type UpdatePkTissueWorksheetNotesMutationFn = Apollo.MutationFunction<UpdatePkTissueWorksheetNotesMutation, UpdatePkTissueWorksheetNotesMutationVariables>;

/**
 * __useUpdatePkTissueWorksheetNotesMutation__
 *
 * To run a mutation, you first call `useUpdatePkTissueWorksheetNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkTissueWorksheetNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkTissueWorksheetNotesMutation, { data, loading, error }] = useUpdatePkTissueWorksheetNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkTissueWorksheetNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkTissueWorksheetNotesMutation, UpdatePkTissueWorksheetNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkTissueWorksheetNotesMutation, UpdatePkTissueWorksheetNotesMutationVariables>(UpdatePkTissueWorksheetNotesDocument, options);
      }
export type UpdatePkTissueWorksheetNotesMutationHookResult = ReturnType<typeof useUpdatePkTissueWorksheetNotesMutation>;
export type UpdatePkTissueWorksheetNotesMutationResult = Apollo.MutationResult<UpdatePkTissueWorksheetNotesMutation>;
export type UpdatePkTissueWorksheetNotesMutationOptions = Apollo.BaseMutationOptions<UpdatePkTissueWorksheetNotesMutation, UpdatePkTissueWorksheetNotesMutationVariables>;
export const UpdatePkTissueWorksheetCollectionActualTimeDocument = gql`
    mutation updatePKTissueWorksheetCollectionActualTime($input: UpdatePKTissueWorksheetCollectionActualTimeInput!) {
  updatePKTissueWorksheetCollectionActualTime(input: $input) {
    ...PKTissueWorksheetCollection
  }
}
    ${PkTissueWorksheetCollectionFragmentDoc}`;
export type UpdatePkTissueWorksheetCollectionActualTimeMutationFn = Apollo.MutationFunction<UpdatePkTissueWorksheetCollectionActualTimeMutation, UpdatePkTissueWorksheetCollectionActualTimeMutationVariables>;

/**
 * __useUpdatePkTissueWorksheetCollectionActualTimeMutation__
 *
 * To run a mutation, you first call `useUpdatePkTissueWorksheetCollectionActualTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkTissueWorksheetCollectionActualTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkTissueWorksheetCollectionActualTimeMutation, { data, loading, error }] = useUpdatePkTissueWorksheetCollectionActualTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkTissueWorksheetCollectionActualTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkTissueWorksheetCollectionActualTimeMutation, UpdatePkTissueWorksheetCollectionActualTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkTissueWorksheetCollectionActualTimeMutation, UpdatePkTissueWorksheetCollectionActualTimeMutationVariables>(UpdatePkTissueWorksheetCollectionActualTimeDocument, options);
      }
export type UpdatePkTissueWorksheetCollectionActualTimeMutationHookResult = ReturnType<typeof useUpdatePkTissueWorksheetCollectionActualTimeMutation>;
export type UpdatePkTissueWorksheetCollectionActualTimeMutationResult = Apollo.MutationResult<UpdatePkTissueWorksheetCollectionActualTimeMutation>;
export type UpdatePkTissueWorksheetCollectionActualTimeMutationOptions = Apollo.BaseMutationOptions<UpdatePkTissueWorksheetCollectionActualTimeMutation, UpdatePkTissueWorksheetCollectionActualTimeMutationVariables>;
export const UpdatePkTissueWorksheetCollectionActualTimesDocument = gql`
    mutation updatePKTissueWorksheetCollectionActualTimes($input: UpdatePKTissueWorksheetCollectionActualTimesInput!) {
  updatePKTissueWorksheetCollectionActualTimes(input: $input) {
    ...PKTissueWorksheetCollection
  }
}
    ${PkTissueWorksheetCollectionFragmentDoc}`;
export type UpdatePkTissueWorksheetCollectionActualTimesMutationFn = Apollo.MutationFunction<UpdatePkTissueWorksheetCollectionActualTimesMutation, UpdatePkTissueWorksheetCollectionActualTimesMutationVariables>;

/**
 * __useUpdatePkTissueWorksheetCollectionActualTimesMutation__
 *
 * To run a mutation, you first call `useUpdatePkTissueWorksheetCollectionActualTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkTissueWorksheetCollectionActualTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkTissueWorksheetCollectionActualTimesMutation, { data, loading, error }] = useUpdatePkTissueWorksheetCollectionActualTimesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkTissueWorksheetCollectionActualTimesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkTissueWorksheetCollectionActualTimesMutation, UpdatePkTissueWorksheetCollectionActualTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkTissueWorksheetCollectionActualTimesMutation, UpdatePkTissueWorksheetCollectionActualTimesMutationVariables>(UpdatePkTissueWorksheetCollectionActualTimesDocument, options);
      }
export type UpdatePkTissueWorksheetCollectionActualTimesMutationHookResult = ReturnType<typeof useUpdatePkTissueWorksheetCollectionActualTimesMutation>;
export type UpdatePkTissueWorksheetCollectionActualTimesMutationResult = Apollo.MutationResult<UpdatePkTissueWorksheetCollectionActualTimesMutation>;
export type UpdatePkTissueWorksheetCollectionActualTimesMutationOptions = Apollo.BaseMutationOptions<UpdatePkTissueWorksheetCollectionActualTimesMutation, UpdatePkTissueWorksheetCollectionActualTimesMutationVariables>;
export const ClearPkTissueWorksheetCollectionsActualTimeDocument = gql`
    mutation clearPKTissueWorksheetCollectionsActualTime($input: ClearPKTissueWorksheetCollectionsActualTimeInput!) {
  clearPKTissueWorksheetCollectionsActualTime(input: $input) {
    ...PKTissueWorksheetCollection
  }
}
    ${PkTissueWorksheetCollectionFragmentDoc}`;
export type ClearPkTissueWorksheetCollectionsActualTimeMutationFn = Apollo.MutationFunction<ClearPkTissueWorksheetCollectionsActualTimeMutation, ClearPkTissueWorksheetCollectionsActualTimeMutationVariables>;

/**
 * __useClearPkTissueWorksheetCollectionsActualTimeMutation__
 *
 * To run a mutation, you first call `useClearPkTissueWorksheetCollectionsActualTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearPkTissueWorksheetCollectionsActualTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearPkTissueWorksheetCollectionsActualTimeMutation, { data, loading, error }] = useClearPkTissueWorksheetCollectionsActualTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearPkTissueWorksheetCollectionsActualTimeMutation(baseOptions?: Apollo.MutationHookOptions<ClearPkTissueWorksheetCollectionsActualTimeMutation, ClearPkTissueWorksheetCollectionsActualTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearPkTissueWorksheetCollectionsActualTimeMutation, ClearPkTissueWorksheetCollectionsActualTimeMutationVariables>(ClearPkTissueWorksheetCollectionsActualTimeDocument, options);
      }
export type ClearPkTissueWorksheetCollectionsActualTimeMutationHookResult = ReturnType<typeof useClearPkTissueWorksheetCollectionsActualTimeMutation>;
export type ClearPkTissueWorksheetCollectionsActualTimeMutationResult = Apollo.MutationResult<ClearPkTissueWorksheetCollectionsActualTimeMutation>;
export type ClearPkTissueWorksheetCollectionsActualTimeMutationOptions = Apollo.BaseMutationOptions<ClearPkTissueWorksheetCollectionsActualTimeMutation, ClearPkTissueWorksheetCollectionsActualTimeMutationVariables>;
export const UpdatePkTissueWorksheetHandlingAndStorageDocument = gql`
    mutation updatePKTissueWorksheetHandlingAndStorage($input: UpdatePKTissueWorksheetHandlingAndStorageInput!) {
  updatePKTissueWorksheetHandlingAndStorage(input: $input) {
    ...PKTissueWorksheetHandlingAndStorage
  }
}
    ${PkTissueWorksheetHandlingAndStorageFragmentDoc}`;
export type UpdatePkTissueWorksheetHandlingAndStorageMutationFn = Apollo.MutationFunction<UpdatePkTissueWorksheetHandlingAndStorageMutation, UpdatePkTissueWorksheetHandlingAndStorageMutationVariables>;

/**
 * __useUpdatePkTissueWorksheetHandlingAndStorageMutation__
 *
 * To run a mutation, you first call `useUpdatePkTissueWorksheetHandlingAndStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePkTissueWorksheetHandlingAndStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePkTissueWorksheetHandlingAndStorageMutation, { data, loading, error }] = useUpdatePkTissueWorksheetHandlingAndStorageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePkTissueWorksheetHandlingAndStorageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePkTissueWorksheetHandlingAndStorageMutation, UpdatePkTissueWorksheetHandlingAndStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePkTissueWorksheetHandlingAndStorageMutation, UpdatePkTissueWorksheetHandlingAndStorageMutationVariables>(UpdatePkTissueWorksheetHandlingAndStorageDocument, options);
      }
export type UpdatePkTissueWorksheetHandlingAndStorageMutationHookResult = ReturnType<typeof useUpdatePkTissueWorksheetHandlingAndStorageMutation>;
export type UpdatePkTissueWorksheetHandlingAndStorageMutationResult = Apollo.MutationResult<UpdatePkTissueWorksheetHandlingAndStorageMutation>;
export type UpdatePkTissueWorksheetHandlingAndStorageMutationOptions = Apollo.BaseMutationOptions<UpdatePkTissueWorksheetHandlingAndStorageMutation, UpdatePkTissueWorksheetHandlingAndStorageMutationVariables>;